import _slicedToArray from "/Users/adhaar/Desktop/Projects/apispreadsheets/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "/Users/adhaar/Desktop/Projects/apispreadsheets/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _toConsumableArray from "/Users/adhaar/Desktop/Projects/apispreadsheets/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import * as e from "react";
import t, { useState as n, useCallback as o, forwardRef as r, useContext as i, useLayoutEffect as l, useEffect as a, useRef as c, createContext as s, useMemo as u, Component as d, Fragment as g } from "react";
import { createPortal as p } from "react-dom";

var f = function () {
  function e(e, t) {
    this.rows = e, this.columns = t, this.first = {
      row: this.rows[0],
      column: this.columns[0]
    }, this.last = {
      row: this.rows[this.rows.length - 1],
      column: this.columns[this.columns.length - 1]
    }, this.height = this.rows.reduce(function (e, t) {
      return e + t.height;
    }, 0), this.width = this.columns.reduce(function (e, t) {
      return e + t.width;
    }, 0);
  }

  return e.prototype.contains = function (e) {
    var t, n, o, r, i, l, a, c;
    return (null === (t = e.column) || void 0 === t ? void 0 : t.idx) >= (null === (n = this.first.column) || void 0 === n ? void 0 : n.idx) && (null === (o = e.column) || void 0 === o ? void 0 : o.idx) <= (null === (r = this.last.column) || void 0 === r ? void 0 : r.idx) && (null === (i = e.row) || void 0 === i ? void 0 : i.idx) >= (null === (l = this.first.row) || void 0 === l ? void 0 : l.idx) && (null === (a = e.row) || void 0 === a ? void 0 : a.idx) <= (null === (c = this.last.row) || void 0 === c ? void 0 : c.idx);
  }, e.prototype.slice = function (t, n) {
    var o = "rows" === n && t ? t.first.row : this.first.row,
        r = "columns" === n && t ? t.first.column : this.first.column,
        i = "rows" === n && t ? t.last.row : this.last.row,
        l = "columns" === n && t ? t.last.column : this.last.column;
    return new e(this.rows.slice(o.idx - this.first.row.idx, i.idx - this.first.row.idx + 1), this.columns.slice(r.idx - this.first.column.idx, l.idx - this.first.column.idx + 1));
  }, e;
}(),
    h = function () {
  function e(e) {
    this.ranges = e, this.width = 0, this.height = 0, this.rowIndexLookup = {}, this.columnIndexLookup = {}, this.spanCellLookup = {}, this.rangesToRender = {};
  }

  return e.prototype.getRange = function (e, t) {
    var n = this.columns.slice(Math.min(e.column.idx, t.column.idx), Math.max(e.column.idx, t.column.idx) + 1),
        o = this.rows.slice(Math.min(e.row.idx, t.row.idx), Math.max(e.row.idx, t.row.idx) + 1);
    return new f(o, n);
  }, e.prototype.getLocation = function (e, t) {
    return {
      row: this.rows[e],
      column: this.columns[t]
    };
  }, e.prototype.getLocationById = function (e, t) {
    try {
      var n = this.rows[this.rowIndexLookup[e]],
          o = this.columns[this.columnIndexLookup[t]];
      return this.validateLocation({
        row: n,
        column: o
      });
    } catch (n) {
      throw new RangeError("column: '".concat(t, "', row: '").concat(e, "'"));
    }
  }, e.prototype.validateLocation = function (e) {
    var t,
        n,
        o = null !== (t = this.columnIndexLookup[e.column.columnId]) && void 0 !== t ? t : Math.min(e.column.idx, this.last.column.idx),
        r = null !== (n = this.rowIndexLookup[e.row.rowId]) && void 0 !== n ? n : Math.min(e.row.idx, this.last.row.idx);
    return this.getLocation(r, o);
  }, e.prototype.validateRange = function (e) {
    return this.getRange(this.validateLocation(e.first), this.validateLocation(e.last));
  }, e.prototype.getCell = function (e) {
    return this.rows[e.row.idx].cells[e.column.idx];
  }, e.DEFAULT_ROW_HEIGHT = 25, e.DEFAULT_COLUMN_WIDTH = 150, e.MIN_COLUMN_WIDTH = 40, e;
}();

function m(e, t) {
  return "".concat(e, ", ").concat(t);
}

function b(e, t) {
  return e.column.columnId === (null == t ? void 0 : t.column.columnId) && e.row.rowId === (null == t ? void 0 : t.row.rowId);
}

var v = function () {
  function e(e) {
    this.updateState = e, this.eventTimestamps = [0, 0], this.eventLocations = [void 0, void 0], this.currentIndex = 0;
  }

  return e.prototype.handlePointerDownInternal = function (e, t, n) {
    this.pointerDownLocation = t;
    var o = this.eventLocations[this.currentIndex];
    this.currentIndex = 1 - this.currentIndex, this.eventTimestamps[this.currentIndex] = new Date().valueOf(), this.eventLocations[this.currentIndex] = t;
    var r = 0 === t.row.idx || 0 === t.column.idx;
    return ("mouse" === e.pointerType || r || b(t, o)) && (n = n.currentBehavior.handlePointerDown(e, t, n)), n;
  }, e.prototype.shouldHandleDoubleClick = function (e, t, n) {
    return t - n < 500 && b(e, this.eventLocations[0]) && b(e, this.eventLocations[1]);
  }, e.prototype.shouldHandleCellSelectionOnMobile = function (e, t, n) {
    return "mouse" !== e.pointerType && b(t, this.pointerDownLocation) && void 0 !== e.pointerType && n - this.eventTimestamps[this.currentIndex] < 500 && t.row.idx > 0 && t.column.idx > 0;
  }, e;
}();

function y(e) {
  return !(0 !== e.button && void 0 !== e.button || "reactgrid-content" === e.target.className && void 0 !== e.pointerType);
}

function I(e, t) {
  if (!t.reactGridElement) return !1;
  var n = t.reactGridElement.getBoundingClientRect().left;
  return !(e.clientX - n > t.cellMatrix.width);
}

var _x = function x(e, t) {
  return _x = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (e, t) {
    e.__proto__ = t;
  } || function (e, t) {
    for (var n in t) {
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
  }, _x(e, t);
};

function w(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");

  function n() {
    this.constructor = e;
  }

  _x(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
}

var _C = function C() {
  return _C = Object.assign || function (e) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      for (var r in t = arguments[n]) {
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
      }
    }

    return e;
  }, _C.apply(this, arguments);
};

function R(e, t, n, o) {
  return new (n || (n = Promise))(function (r, i) {
    function l(e) {
      try {
        c(o.next(e));
      } catch (e) {
        i(e);
      }
    }

    function a(e) {
      try {
        c(o.throw(e));
      } catch (e) {
        i(e);
      }
    }

    function c(e) {
      var t;
      e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
        e(t);
      })).then(l, a);
    }

    c((o = o.apply(e, t || [])).next());
  });
}

function A(e, t) {
  var n,
      o,
      r,
      i,
      l = {
    label: 0,
    sent: function sent() {
      if (1 & r[0]) throw r[1];
      return r[1];
    },
    trys: [],
    ops: []
  };
  return i = {
    next: a(0),
    throw: a(1),
    return: a(2)
  }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
    return this;
  }), i;

  function a(a) {
    return function (c) {
      return function (a) {
        if (n) throw new TypeError("Generator is already executing.");

        for (; i && (i = 0, a[0] && (l = 0)), l;) {
          try {
            if (n = 1, o && (r = 2 & a[0] ? o.return : a[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, a[1])).done) return r;

            switch (o = 0, r && (a = [2 & a[0], r.value]), a[0]) {
              case 0:
              case 1:
                r = a;
                break;

              case 4:
                return l.label++, {
                  value: a[1],
                  done: !1
                };

              case 5:
                l.label++, o = a[1], a = [0];
                continue;

              case 7:
                a = l.ops.pop(), l.trys.pop();
                continue;

              default:
                if (!(r = l.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                  l = 0;
                  continue;
                }

                if (3 === a[0] && (!r || a[1] > r[0] && a[1] < r[3])) {
                  l.label = a[1];
                  break;
                }

                if (6 === a[0] && l.label < r[1]) {
                  l.label = r[1], r = a;
                  break;
                }

                if (r && l.label < r[2]) {
                  l.label = r[2], l.ops.push(a);
                  break;
                }

                r[2] && l.ops.pop(), l.trys.pop();
                continue;
            }

            a = t.call(e, l);
          } catch (e) {
            a = [6, e], o = 0;
          } finally {
            n = r = 0;
          }
        }

        if (5 & a[0]) throw a[1];
        return {
          value: a[0] ? a[1] : void 0,
          done: !0
        };
      }([a, c]);
    };
  }
}

function E(e, t, n) {
  if (n || 2 === arguments.length) for (var o, r = 0, i = t.length; r < i; r++) {
    !o && r in t || (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  }
  return e.concat(o || Array.prototype.slice.call(t));
}

"function" == typeof SuppressedError && SuppressedError;

var M = function M(e, t) {
  return {
    row: e,
    column: t
  };
};

function G(e, t) {
  var n,
      o = e.cellMatrix.getRange(t, t);
  return (null === (n = null == e ? void 0 : e.props) || void 0 === n ? void 0 : n.onSelectionChanged) && e.props.onSelectionChanged([o]), _C(_C({}, e), {
    activeSelectedRangeIdx: 0,
    selectedRanges: [o],
    selectedIndexes: [],
    selectedIds: [],
    selectionMode: "range"
  });
}

function N(e, t, n) {
  return _C(_C({}, e), {
    selectionMode: "range",
    selectedRanges: (n && "range" === e.selectionMode ? e.selectedRanges : []).concat([t]),
    selectedIndexes: [],
    selectedIds: [],
    activeSelectedRangeIdx: n && "range" === e.selectionMode ? e.selectedRanges.length : 0
  });
}

function k(e, t) {
  var n;
  return _C(_C({}, e), {
    selectionMode: "range",
    selectedRanges: Object.assign([], e.selectedRanges, (n = {}, n[e.activeSelectedRangeIdx] = t, n)),
    selectedIndexes: [],
    selectedIds: []
  });
}

function T(e, t, n, o) {
  var r = e.cellMatrix.first.row,
      i = e.cellMatrix.last.row,
      l = e.cellMatrix.getRange(M(r, t), M(i, n));
  return _C(_C({}, e), {
    selectionMode: "column",
    selectedIndexes: o ? e.selectedIndexes.concat(l.columns.map(function (e) {
      return e.idx;
    })) : l.columns.map(function (e) {
      return e.idx;
    }),
    selectedIds: o ? e.selectedIds.concat(l.columns.map(function (e) {
      return e.columnId;
    })) : l.columns.map(function (e) {
      return e.columnId;
    })
  });
}

function B(e, t, n, o) {
  var r = e.cellMatrix.first.column,
      i = e.cellMatrix.last.column,
      l = e.cellMatrix.getRange(M(t, r), M(n, i));
  return _C(_C({}, e), {
    selectionMode: "row",
    selectedIndexes: o ? e.selectedIndexes.concat(l.rows.map(function (e) {
      return e.idx;
    })) : l.rows.map(function (e) {
      return e.idx;
    }),
    selectedIds: o ? e.selectedIds.concat(l.rows.map(function (e) {
      return e.rowId;
    })) : l.rows.map(function (e) {
      return e.rowId;
    })
  });
}

var S,
    L = function () {
  function e() {
    this.autoScrollDirection = "both";
  }

  return e.prototype.handleKeyDown = function (e, t) {
    return t;
  }, e.prototype.handlePointerUp = function (e, t, n) {
    return n;
  }, e.prototype.handleKeyUp = function (e, t) {
    return t;
  }, e.prototype.handleCompositionEnd = function (e, t) {
    return t;
  }, e.prototype.handleCopy = function (e, t) {
    return t;
  }, e.prototype.handlePaste = function (e, t) {
    return t;
  }, e.prototype.handleCut = function (e, t) {
    return t;
  }, e.prototype.handlePointerDown = function (e, t, n) {
    return n;
  }, e.prototype.handleDoubleClick = function (e, t, n) {
    return n;
  }, e.prototype.handlePointerMove = function (e, t, n) {
    return n;
  }, e.prototype.handlePointerEnter = function (e, t, n) {
    return n;
  }, e.prototype.handleContextMenu = function (e, t) {
    return t;
  }, e.prototype.renderPanePart = function (e, t) {}, e;
}();

function P(e, t) {
  try {
    var n = e.cellMatrix.getCell(t);
    if (!n) throw new TypeError("Cell doesn't exists at location");
    if (!n.type) throw new Error("Cell is missing type property");
    var o = e.cellTemplates[n.type];
    if (!o) throw new Error("CellTemplate missing for type '".concat(n.type, "'"));
    var r = o.getCompatibleCell(_C(_C({}, n), {
      type: n.type
    }));
    if (!r) throw new Error("Cell validation failed");
    return {
      cell: r,
      cellTemplate: o
    };
  } catch (e) {
    throw new Error("".concat(e.message, " (rowId: '").concat(t.row.rowId, "', columnId: '").concat(t.column.columnId, "')"));
  }
}

function W(e, t, n) {
  var o = P(e, t),
      r = o.cell,
      i = o.cellTemplate;
  if (r === n || JSON.stringify(r) === JSON.stringify(n) || void 0 === i.update) return e;
  var l = i.update(r, n);
  return l === r && JSON.stringify(l) === JSON.stringify(r) || l.nonEditable || e.queuedCellChanges.push({
    previousCell: r,
    newCell: l,
    type: l.type,
    rowId: t.row.rowId,
    columnId: t.column.columnId
  }), _C({}, e);
}

function X(e, t, n, o) {
  if (void 0 === n && (n = !0), e.focusedLocation && e.currentlyEditedCell && o !== S.ENTER && (e = W(e, e.focusedLocation, e.currentlyEditedCell)), !e.props) throw new Error('"props" field on "state" object should be initiated before possible location focus');
  var r = e.props,
      i = r.onFocusLocationChanged,
      l = r.onFocusLocationChanging,
      a = r.focusLocation,
      c = P(e, t),
      s = c.cell,
      u = c.cellTemplate,
      d = {
    rowId: t.row.rowId,
    columnId: t.column.columnId
  },
      g = !l || l(d),
      p = !u.isFocusable || u.isFocusable(s),
      f = a ? e.cellMatrix.getLocationById(a.rowId, a.columnId) : void 0,
      h = b(t, e.focusedLocation) || !f || b(t, f);
  if (!p || !g || !h) return e;
  i && i(d);
  var m = e.cellMatrix.validateLocation(t);
  return n && (e = G(e, m)), _C(_C({}, e), {
    focusedLocation: m,
    contextMenuPosition: {
      top: -1,
      left: -1
    },
    currentlyEditedCell: void 0
  });
}

function F(e, t) {
  var n = getComputedStyle(e),
      o = "absolute" === n.position,
      r = t ? /(auto|scroll|hidden)/ : /(auto|scroll)/;
  if ("fixed" === n.position) return document.documentElement;

  for (var i = e; i = i.parentElement;) {
    if (n = getComputedStyle(i), (!o || "static" !== n.position) && r.test(n.overflow + n.overflowY + n.overflowX)) return i;
  }

  return Z();
}

function V(e) {
  var t, n;
  return {
    scrollLeft: void 0 !== e ? (null !== (t = e.scrollLeft) && void 0 !== t ? t : Z().scrollX) - (e.clientLeft || 0) : 0,
    scrollTop: void 0 !== e ? (null !== (n = e.scrollTop) && void 0 !== n ? n : Z().scrollY) - (e.clientTop || 0) : 0
  };
}

function Z() {
  return window;
}

function H() {
  return "undefined" != typeof window && -1 !== window.navigator.appVersion.indexOf("Mac");
}

function O() {
  return "undefined" != typeof window && (!!/iPad|iPhone|iPod/.test(window.navigator.platform) || D());
}

function D() {
  return "undefined" != typeof window && window.navigator.maxTouchPoints > 2 && /MacIntel/.test(window.navigator.platform);
}

function Y(e) {
  return e ? {
    width: e instanceof HTMLElement ? e.clientWidth : O() ? window.innerWidth : document.documentElement.clientWidth,
    height: e instanceof HTMLElement ? e.clientHeight : O() ? window.innerHeight : document.documentElement.clientHeight
  } : {
    width: 0,
    height: 0
  };
}

function z(e) {
  var t = V(e.scrollableElement),
      n = t.scrollLeft,
      o = t.scrollTop;
  if (!e.reactGridElement) throw new Error('"state.reactGridElement" field should be initiated before calling "getBoundingClientRect()"');
  var r = e.reactGridElement.getBoundingClientRect(),
      i = r.left + n,
      l = r.top + o;

  if (void 0 !== e.scrollableElement && e.scrollableElement !== Z()) {
    var a = e.scrollableElement.getBoundingClientRect();
    i -= a.left, l -= a.top;
  }

  return {
    left: i,
    top: l
  };
}

function J(e) {
  var t = V(e.scrollableElement),
      n = t.scrollLeft,
      o = t.scrollTop,
      r = Y(e.scrollableElement),
      i = r.width,
      l = r.height,
      a = z(e),
      c = a.left,
      s = a.top,
      u = o + l,
      d = s + e.cellMatrix.height,
      g = s < o ? o : s,
      p = d > u ? u : d,
      f = n + i,
      h = c + e.cellMatrix.width,
      m = c < n ? n : c,
      b = h > f ? f : h;
  return {
    width: Math.max(b - m, 0),
    height: Math.max(p - g, 0),
    visibleOffsetRight: f - b,
    visibleOffsetBottom: u - p
  };
}

!function (e) {
  e[e.POINTER = 1] = "POINTER", e[e.BACKSPACE = 8] = "BACKSPACE", e[e.TAB = 9] = "TAB", e[e.ENTER = 13] = "ENTER", e[e.SHIFT = 16] = "SHIFT", e[e.CTRL = 17] = "CTRL", e[e.ALT = 18] = "ALT", e[e.PAUSE = 19] = "PAUSE", e[e.CAPS_LOCK = 20] = "CAPS_LOCK", e[e.ESCAPE = 27] = "ESCAPE", e[e.SPACE = 32] = "SPACE", e[e.PAGE_UP = 33] = "PAGE_UP", e[e.PAGE_DOWN = 34] = "PAGE_DOWN", e[e.END = 35] = "END", e[e.HOME = 36] = "HOME", e[e.LEFT_ARROW = 37] = "LEFT_ARROW", e[e.UP_ARROW = 38] = "UP_ARROW", e[e.RIGHT_ARROW = 39] = "RIGHT_ARROW", e[e.DOWN_ARROW = 40] = "DOWN_ARROW", e[e.INSERT = 45] = "INSERT", e[e.DELETE = 46] = "DELETE", e[e.KEY_0 = 48] = "KEY_0", e[e.KEY_1 = 49] = "KEY_1", e[e.KEY_2 = 50] = "KEY_2", e[e.KEY_3 = 51] = "KEY_3", e[e.KEY_4 = 52] = "KEY_4", e[e.KEY_5 = 53] = "KEY_5", e[e.KEY_6 = 54] = "KEY_6", e[e.KEY_7 = 55] = "KEY_7", e[e.KEY_8 = 56] = "KEY_8", e[e.KEY_9 = 57] = "KEY_9", e[e.KEY_A = 65] = "KEY_A", e[e.KEY_B = 66] = "KEY_B", e[e.KEY_C = 67] = "KEY_C", e[e.KEY_D = 68] = "KEY_D", e[e.KEY_E = 69] = "KEY_E", e[e.KEY_F = 70] = "KEY_F", e[e.KEY_G = 71] = "KEY_G", e[e.KEY_H = 72] = "KEY_H", e[e.KEY_I = 73] = "KEY_I", e[e.KEY_J = 74] = "KEY_J", e[e.KEY_K = 75] = "KEY_K", e[e.KEY_L = 76] = "KEY_L", e[e.KEY_M = 77] = "KEY_M", e[e.KEY_N = 78] = "KEY_N", e[e.KEY_O = 79] = "KEY_O", e[e.KEY_P = 80] = "KEY_P", e[e.KEY_Q = 81] = "KEY_Q", e[e.KEY_R = 82] = "KEY_R", e[e.KEY_S = 83] = "KEY_S", e[e.KEY_T = 84] = "KEY_T", e[e.KEY_U = 85] = "KEY_U", e[e.KEY_V = 86] = "KEY_V", e[e.KEY_W = 87] = "KEY_W", e[e.KEY_X = 88] = "KEY_X", e[e.KEY_Y = 89] = "KEY_Y", e[e.KEY_Z = 90] = "KEY_Z", e[e.LEFT_META = 91] = "LEFT_META", e[e.RIGHT_META = 92] = "RIGHT_META", e[e.SELECT = 93] = "SELECT", e[e.NUMPAD_0 = 96] = "NUMPAD_0", e[e.NUMPAD_1 = 97] = "NUMPAD_1", e[e.NUMPAD_2 = 98] = "NUMPAD_2", e[e.NUMPAD_3 = 99] = "NUMPAD_3", e[e.NUMPAD_4 = 100] = "NUMPAD_4", e[e.NUMPAD_5 = 101] = "NUMPAD_5", e[e.NUMPAD_6 = 102] = "NUMPAD_6", e[e.NUMPAD_7 = 103] = "NUMPAD_7", e[e.NUMPAD_8 = 104] = "NUMPAD_8", e[e.NUMPAD_9 = 105] = "NUMPAD_9", e[e.MULTIPLY = 106] = "MULTIPLY", e[e.ADD = 107] = "ADD", e[e.SUBTRACT = 109] = "SUBTRACT", e[e.DECIMAL = 110] = "DECIMAL", e[e.DIVIDE = 111] = "DIVIDE", e[e.F1 = 112] = "F1", e[e.F2 = 113] = "F2", e[e.F3 = 114] = "F3", e[e.F4 = 115] = "F4", e[e.F5 = 116] = "F5", e[e.F6 = 117] = "F6", e[e.F7 = 118] = "F7", e[e.F8 = 119] = "F8", e[e.F9 = 120] = "F9", e[e.F10 = 121] = "F10", e[e.F11 = 122] = "F11", e[e.F12 = 123] = "F12", e[e.NUM_LOCK = 144] = "NUM_LOCK", e[e.SCROLL_LOCK = 145] = "SCROLL_LOCK", e[e.FIREFOX_DASH = 173] = "FIREFOX_DASH", e[e.SEMICOLON = 186] = "SEMICOLON", e[e.EQUALS = 187] = "EQUALS", e[e.COMMA = 188] = "COMMA", e[e.DASH = 189] = "DASH", e[e.PERIOD = 190] = "PERIOD", e[e.FORWARD_SLASH = 191] = "FORWARD_SLASH", e[e.GRAVE_ACCENT = 192] = "GRAVE_ACCENT", e[e.OPEN_BRACKET = 219] = "OPEN_BRACKET", e[e.BACK_SLASH = 220] = "BACK_SLASH", e[e.CLOSE_BRACKET = 221] = "CLOSE_BRACKET", e[e.SINGLE_QUOTE = 222] = "SINGLE_QUOTE";
}(S || (S = {}));

var j = function j(e, t) {
  return e > t ? e - t : 0;
};

function U(e, t, n, o) {
  if (!e.reactGridElement) throw new Error('"state.reactGridElement" field should be initiated before calling the "getBoundingClientRect()"');

  var r = e.reactGridElement.getBoundingClientRect(),
      i = t - r.left,
      l = n - r.top,
      a = function (e, t, n) {
    return Q(e, t, n) || function (e, t, n) {
      var o = e.cellMatrix,
          r = V(e.scrollableElement).scrollTop,
          i = z(e).top,
          l = Y(e.scrollableElement).height,
          a = j(r, i),
          c = Math.max(o.height - l + i, 0),
          s = J(e).height + a - o.ranges.stickyBottomRange.height;

      if (o.ranges.stickyBottomRange.rows.length > 0 && t >= s && !(n && r + 1 < c)) {
        var u = o.ranges.stickyBottomRange.rows.find(function (e) {
          return e.bottom > t - s;
        }) || o.last.row;
        return {
          cellY: t - s - u.top,
          row: u
        };
      }
    }(e, t, n) || function (e, t) {
      if (e.cellMatrix.scrollableRange.rows.length < 1) {
        var n = t >= e.cellMatrix.height ? e.cellMatrix.last : e.cellMatrix.first;
        return {
          cellY: n.row.height,
          row: n.row
        };
      }

      return $(e, t);
    }(e, t);
  }(e, l, "vertical" === o || "both" === o),
      c = a.cellY,
      s = a.row,
      u = function (e, t, n) {
    return K(e, t, n) || _(e, t, n) || function (e, t) {
      if (e.cellMatrix.scrollableRange.columns.length < 1) {
        var n = t >= e.cellMatrix.width ? e.cellMatrix.last : e.cellMatrix.first;
        return {
          cellX: n.column.width,
          column: n.column
        };
      }

      return q(e, t);
    }(e, t);
  }(e, i, "horizontal" === o || "both" === o),
      d = u.cellX;

  return {
    row: s,
    column: u.column,
    viewportX: i,
    viewportY: l,
    cellX: d,
    cellY: c
  };
}

function _(e, t, n) {
  var o = e.cellMatrix,
      r = V(e.scrollableElement).scrollLeft,
      i = z(e).left,
      l = Y(e.scrollableElement).width,
      a = j(r, i),
      c = Math.max(o.width - l + i, 0),
      s = J(e).width + a - o.ranges.stickyRightRange.width;

  if (o.ranges.stickyRightRange.columns.length > 0 && t >= s && !(n && r + 1 < c)) {
    var u = o.ranges.stickyRightRange.columns.find(function (e) {
      return e.right > t - s;
    }) || o.last.column;
    return {
      cellX: t - s - u.left,
      column: u
    };
  }
}

function Q(e, t, n) {
  var o = e.cellMatrix,
      r = V(e.scrollableElement).scrollTop,
      i = z(e).top,
      l = j(r, i);

  if (o.ranges.stickyTopRange.rows.find(function (e) {
    return e.bottom > t - l;
  }) && t < o.ranges.stickyTopRange.height + l && !(n && r > i)) {
    var a = o.ranges.stickyTopRange.rows.find(function (e) {
      return e.bottom > t - l;
    }) || o.ranges.stickyTopRange.first.row;
    return {
      cellY: t - a.top,
      row: a
    };
  }
}

function K(e, t, n) {
  var o = e.cellMatrix,
      r = V(e.scrollableElement).scrollLeft,
      i = z(e).left,
      l = j(r, i);

  if (o.ranges.stickyLeftRange.columns.find(function (e) {
    return e.right > t - l;
  }) && t < o.ranges.stickyLeftRange.width + l && !(n && r > i)) {
    var a = o.ranges.stickyLeftRange.columns.find(function (e) {
      return e.right > t - l;
    }) || o.ranges.stickyLeftRange.first.column;
    return {
      cellX: t - a.left,
      column: a
    };
  }
}

function $(e, t) {
  var n = e.cellMatrix,
      o = t - n.ranges.stickyTopRange.height,
      r = n.scrollableRange.rows.find(function (e) {
    return e.bottom >= o;
  }) || n.scrollableRange.last.row;
  return {
    cellY: o - r.top,
    row: r
  };
}

function q(e, t) {
  var n = e.cellMatrix,
      o = t - n.ranges.stickyLeftRange.width,
      r = n.scrollableRange.columns.find(function (e) {
    return e.right >= o;
  }) || n.scrollableRange.last.column;
  return {
    cellX: o - r.left,
    column: r
  };
}

function ee(e, t) {
  e.preventDefault();
  var n = e.clientX,
      o = e.clientY,
      r = t.contextMenuPosition;
  r.top = o, r.left = n;
  var i = U(t, n, o);
  return t.selectedRanges.find(function (e) {
    return e.contains(i);
  }) || (t = X(t, i)), _C(_C({}, t), {
    contextMenuPosition: r
  });
}

var te = function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }

  return w(t, e), t.prototype.handlePointerDown = function (e, t, n) {
    if ("reactgrid-content" === e.target.className) return n;

    if (n.enableRangeSelection && e.shiftKey && n.focusedLocation) {
      var o = n.cellMatrix.getRange(n.focusedLocation, t);
      return Hc(e) && "range" === n.selectionMode ? k(n, o) : N(n, o, !1);
    }

    if (n.enableRangeSelection && Hc(e)) {
      var r = n.selectedRanges.findIndex(function (e) {
        return e.contains(t);
      }),
          i = n.selectedRanges[r],
          l = P(n, t).cellTemplate;
      if (i) n = X(n, t, !1), n = _C(_C({}, n), {
        activeSelectedRangeIdx: r
      });else if (!l.isFocusable) {
        o = n.cellMatrix.getRange(t, t);
        n = X(n = N(n, o, !0), t, !1);
      }
    } else n = X(n, t);

    return n;
  }, t.prototype.handlePointerEnter = function (e, t, n) {
    if (!n.enableRangeSelection || !n.focusedLocation || "reactgrid-content" === e.target.className) return n;
    var o = n.cellMatrix.getRange(n.focusedLocation, t);
    return "range" === n.selectionMode && I(e, n) ? k(n, o) : N(n, o, !1);
  }, t.prototype.handlePointerUp = function (e, t, n) {
    var o, r;

    if ((null === (o = n.props) || void 0 === o ? void 0 : o.onSelectionChanging) && !n.props.onSelectionChanging(n.selectedRanges)) {
      var i = E([], n.selectedRanges, !0).filter(function (e, t) {
        return t !== n.activeSelectedRangeIdx;
      });
      return _C(_C({}, n), {
        selectedRanges: i,
        activeSelectedRangeIdx: i.length - 1
      });
    }

    return (null === (r = n.props) || void 0 === r ? void 0 : r.onSelectionChanged) && n.props.onSelectionChanged(n.selectedRanges), n;
  }, t.prototype.handleContextMenu = function (e, t) {
    return ee(e, t);
  }, t;
}(L),
    ne = function ne(t) {
  var n = t.left,
      o = t.linePosition,
      r = t.offset;
  return e.createElement(e.Fragment, null, -1 !== o && e.createElement("div", {
    className: "rg-column-resize-hint",
    style: {
      left: o - r
    }
  }, e.createElement("span", {
    style: {
      whiteSpace: "nowrap"
    }
  }, "Width: ", Math.floor(o - n - r), "px")));
},
    oe = function (e) {
  function n() {
    var t = null !== e && e.apply(this, arguments) || this;
    return t.autoScrollDirection = "horizontal", t;
  }

  return w(n, e), n.prototype.handlePointerDown = function (e, t, n) {
    var o = this;
    return this.initialLocation = t, this.resizedColumn = t.column, this.isInScrollableRange = n.cellMatrix.scrollableRange.columns.some(function (e) {
      return e.idx === o.resizedColumn.idx;
    }), n;
  }, n.prototype.handlePointerMove = function (e, t, n) {
    var o,
        r,
        i,
        l,
        a = t.viewportX;

    if (!(t.column.idx === this.resizedColumn.idx && t.cellX > (null !== (r = null === (o = n.props) || void 0 === o ? void 0 : o.minColumnWidth) && void 0 !== r ? r : h.MIN_COLUMN_WIDTH) || t.column.idx > this.resizedColumn.idx)) {
      var c = this.getLinePositionOffset(n);
      a = (null !== (l = null === (i = n.props) || void 0 === i ? void 0 : i.minColumnWidth) && void 0 !== l ? l : h.MIN_COLUMN_WIDTH) + this.resizedColumn.left + c;
    }

    return _C(_C({}, n), {
      linePosition: a,
      lineOrientation: "vertical"
    });
  }, n.prototype.handlePointerUp = function (e, t, n) {
    var o,
        r,
        i,
        l,
        a,
        c = this.resizedColumn.width + t.viewportX - this.initialLocation.viewportX;

    if (null === (o = n.props) || void 0 === o ? void 0 : o.onColumnResized) {
      var s = c >= (null !== (i = null === (r = n.props) || void 0 === r ? void 0 : r.minColumnWidth) && void 0 !== i ? i : h.MIN_COLUMN_WIDTH) ? c : null !== (a = null === (l = n.props) || void 0 === l ? void 0 : l.minColumnWidth) && void 0 !== a ? a : h.MIN_COLUMN_WIDTH;
      n.props.onColumnResized(this.resizedColumn.columnId, s, n.selectedIds);
    }

    var u = n.focusedLocation;

    if (void 0 !== u && this.resizedColumn.columnId === u.column.idx) {
      var d = _C(_C({}, u.column), {
        width: c
      });

      u = _C(_C({}, u), {
        column: d
      });
    }

    return _C(_C({}, n), {
      linePosition: -1,
      focusedLocation: u
    });
  }, n.prototype.renderPanePart = function (e, n) {
    var o = this.getLinePositionOffset(e);
    return n.contains(this.initialLocation) && t.createElement(ne, {
      left: this.resizedColumn.left,
      linePosition: e.linePosition,
      offset: o
    });
  }, n.prototype.getLinePositionOffset = function (e) {
    var t = this,
        n = V(e.scrollableElement).scrollLeft,
        o = z(e).left,
        r = j(n, o),
        i = J(e).width + r - e.cellMatrix.ranges.stickyRightRange.width;
    return e.cellMatrix.scrollableRange.columns.some(function (e) {
      return e.idx === t.resizedColumn.idx;
    }) ? e.cellMatrix.ranges.stickyLeftRange.width : e.cellMatrix.ranges.stickyRightRange.columns.some(function (e) {
      return e.idx === t.resizedColumn.idx;
    }) ? i : n;
  }, n;
}(L),
    re = function (e) {
  function t() {
    var t = null !== e && e.apply(this, arguments) || this;
    return t.autoScrollDirection = "horizontal", t;
  }

  return w(t, e), t.prototype.handlePointerDown = function (e, t, n) {
    this.initialColumnIdx = t.column.idx, this.lastPossibleDropLocation = t, this.selectedIdxs = n.selectedIndexes.sort();
    var o = this.selectedIdxs.map(function (e) {
      return n.cellMatrix.columns[e];
    }),
        r = this.selectedIdxs.filter(function (e) {
      return e < t.column.idx;
    }),
        i = r.map(function (e) {
      return n.cellMatrix.columns[e];
    }),
        l = i.reduce(function (e, t) {
      return e + t.width;
    }, 0);
    return this.pointerOffset = l + t.cellX, _C(_C({}, n), {
      lineOrientation: "vertical",
      shadowSize: o.reduce(function (e, t) {
        return e + t.width;
      }, 0),
      shadowPosition: this.getShadowPosition(t, n)
    });
  }, t.prototype.handlePointerMove = function (e, t, n) {
    return _C(_C({}, n), {
      shadowPosition: this.getShadowPosition(t, n)
    });
  }, t.prototype.getShadowPosition = function (e, t) {
    var n = e.viewportX - this.pointerOffset,
        o = t.cellMatrix.width - t.shadowSize;
    return n < 0 ? 0 : n > o ? o : n;
  }, t.prototype.handlePointerEnter = function (e, t, n) {
    var o,
        r = this.getLastPossibleDropLocation(t, n),
        i = V(n.scrollableElement).scrollLeft;
    if (!r) return n;
    var l = r.column.idx > this.initialColumnIdx,
        a = Math.min(r.viewportX - r.cellX + (l ? r.column.width : 0), ((null === (o = n.visibleRange) || void 0 === o ? void 0 : o.width) || 0) + n.cellMatrix.ranges.stickyLeftRange.width + n.cellMatrix.ranges.stickyRightRange.width + i);
    return this.lastPossibleDropLocation = r, _C(_C({}, n), {
      linePosition: a
    });
  }, t.prototype.getLastPossibleDropLocation = function (e, t) {
    var n,
        o = e.column.idx <= this.initialColumnIdx ? "before" : "after",
        r = this.selectedIdxs.map(function (e) {
      return t.cellMatrix.columns[e].columnId;
    });
    return !(null === (n = t.props) || void 0 === n ? void 0 : n.canReorderColumns) || t.props.canReorderColumns(e.column.columnId, r, o) ? e : this.lastPossibleDropLocation;
  }, t.prototype.handlePointerUp = function (e, t, n) {
    var o, r;

    if (t.column.idx !== this.initialColumnIdx && this.lastPossibleDropLocation && (null === (o = n.props) || void 0 === o ? void 0 : o.onColumnsReordered)) {
      var i = this.lastPossibleDropLocation.column.idx <= this.initialColumnIdx,
          l = this.selectedIdxs.map(function (e) {
        return n.cellMatrix.columns[e].columnId;
      });
      null === (r = n.props) || void 0 === r || r.onColumnsReordered(this.lastPossibleDropLocation.column.columnId, l, i ? "before" : "after");
    }

    return _C(_C({}, n), {
      linePosition: -1,
      shadowPosition: -1,
      shadowCursor: "default"
    });
  }, t.prototype.handleContextMenu = function (e, t) {
    return ee(e, t);
  }, t;
}(L);

function ie(e, t, n) {
  var o = e.scrollableElement;
  void 0 !== o.scrollTop ? o.scrollTop = t : o.scrollTo({
    top: t
  }), void 0 !== o.scrollLeft ? o.scrollLeft = n : o.scrollTo({
    left: n
  });
}

function le(e, t) {
  return J(e).height - t;
}

function ae(e, t, n, o) {
  return n + e.row.bottom - t - o;
}

function ce(e, t, n) {
  return t - n + e.row.top - 1;
}

function se(e, t, n) {
  var o = V(e.scrollableElement).scrollTop,
      r = z(e).top,
      i = j(o, r);
  return n < t.row.bottom - i;
}

function ue(e, t) {
  var n = V(e.scrollableElement).scrollTop,
      o = z(e).top,
      r = j(n, o);
  return t.row.top < r;
}

function de(e, t) {
  var n = e.cellMatrix.ranges.stickyTopRange,
      o = t.row;
  return n.rows.length > 0 && o.idx <= n.last.row.idx;
}

function ge(e, t) {
  return J(e).width - t;
}

function pe(e, t, n, o) {
  return n + e.column.right - t - o;
}

function fe(e, t, n) {
  return t - n + e.column.left - 1;
}

function he(e, t, n) {
  var o = V(e.scrollableElement).scrollLeft,
      r = z(e).left,
      i = j(o, r);
  return n < t.column.right - i;
}

function me(e, t) {
  var n = V(e.scrollableElement).scrollLeft,
      o = z(e).left,
      r = j(n, o);
  return t.column.left < r;
}

function be(e, t) {
  var n = e.cellMatrix.ranges.stickyLeftRange,
      o = t.column;
  return n.columns.length > 0 && o.idx <= n.last.column.idx;
}

function ve(e, t, n) {
  var o = n.focusedLocation;

  if (o) {
    var r = !(b(o, t.focusedLocation) || n.currentBehavior instanceof oe),
        i = void 0 !== n.currentlyEditedCell && n.currentlyEditedCell !== t.currentlyEditedCell;

    if (r || i) {
      var l = ye(n, o),
          a = l.left;
      ie(n, l.top, a);
    }
  }
}

function ye(e, t, n) {
  return void 0 === n && (n = "both"), {
    top: Ie(e, t, "horizontal" === n),
    left: xe(e, t, "vertical" === n)
  };
}

function Ie(e, t, n) {
  var o = e.cellMatrix.ranges,
      r = o.stickyTopRange,
      i = o.stickyBottomRange,
      l = V(e.scrollableElement).scrollTop,
      a = le(e, r.height + i.height),
      c = z(e).top,
      s = j(l, c),
      u = t.row;
  if (n || !u) return l;
  var d = we(e, t) ? 1 : 0;
  return de(e, t) || function (e, t) {
    var n = e.cellMatrix.ranges.stickyBottomRange,
        o = t.row;
    return n.rows.length > 0 && o.idx >= n.first.row.idx;
  }(e, t) ? l : se(e, t, a + d) ? ae(t, a - 1 - d, l, s) : ue(e, t) ? ce(t, l, s) : l;
}

function xe(e, t, n) {
  var o = e.cellMatrix.ranges,
      r = o.stickyLeftRange,
      i = o.stickyRightRange,
      l = V(e.scrollableElement).scrollLeft,
      a = ge(e, r.width + i.width),
      c = z(e).left,
      s = j(l, c),
      u = t.column;
  if (n || !u) return l;
  var d = we(e, t) ? 1 : 0;
  return be(e, t) || function (e, t) {
    var n = e.cellMatrix.ranges.stickyRightRange,
        o = t.column;
    return n.columns.length > 0 && o.idx >= n.first.column.idx;
  }(e, t) ? l : he(e, t, a + d) ? pe(t, a - 1 - d, l, s) : me(e, t) ? fe(t, l, s) : l;
}

function we(e, t) {
  return e.cellMatrix.scrollableRange.contains(t) && e.scrollableElement === Z();
}

var Ce = function (e) {
  function t() {
    var t = null !== e && e.apply(this, arguments) || this;
    return t.handlePointerDown = function (e, n) {
      var o;
      t.isInLeftSticky = !1, t.isInRightSticky = !1, t.isInTopSticky = !1, t.isInBottomSticky = !1;

      var r = function (e, t) {
        if (!t.reactGridElement) throw new Error('"state.reactGridElement" field should be initiated before calling the "getBoundingClientRect()"');
        var n = t.reactGridElement.getBoundingClientRect(),
            o = n.left,
            r = n.right,
            i = e.clientX - o,
            l = t.cellMatrix.ranges.stickyRightRange.width;
        return !(i >= t.cellMatrix.width - l) || e.clientX >= r - l;
      }(e, n);

      if ((null === (o = n.props) || void 0 === o ? void 0 : o.onContextMenu) && r && window.addEventListener("contextmenu", t.handleContextMenu), !r) return _C(_C({}, n), {
        contextMenuPosition: {
          top: -1,
          left: -1
        }
      });
      if (!y(e)) return n;
      window.addEventListener("pointermove", t.handlePointerMove), window.addEventListener("pointerup", t.handlePointerUp);
      var i = U(n, e.clientX, e.clientY);
      return t.handlePointerDownInternal(e, i, n);
    }, t.handleHideContextMenu = function (e) {
      window.removeEventListener("pointerdown", t.handleHideContextMenu), t.updateState(function (n) {
        return e instanceof MouseEvent && t.isContainElement(e, n) ? n : _C(_C({}, n), {
          contextMenuPosition: {
            top: -1,
            left: -1
          }
        });
      });
    }, t.isContainElement = function (e, t) {
      var n;
      return null === (n = t.reactGridElement) || void 0 === n ? void 0 : n.contains(e.target);
    }, t.handleContextMenu = function (e) {
      window.removeEventListener("pointerup", t.handlePointerUp), window.removeEventListener("pointermove", t.handlePointerMove), window.removeEventListener("contextmenu", t.handleContextMenu), window.addEventListener("pointerdown", t.handleHideContextMenu), t.updateState(function (n) {
        var o;

        if (t.isContainElement(e, n)) {
          var r = U(n, e.clientX, e.clientY);
          null === (o = (n = (n = n.currentBehavior.handlePointerUp(e, r, n)).currentBehavior.handleContextMenu(e, n)).hiddenFocusElement) || void 0 === o || o.focus();
        }

        return n;
      });
    }, t.handlePointerMove = function (e) {
      t.updateState(function (n) {
        var o,
            r = n.currentBehavior.autoScrollDirection,
            i = U(n, e.clientX, e.clientY, void 0),
            l = U(n, e.clientX, e.clientY, r);

        if (i.column.idx < l.column.idx && !t.isFromLeftToRightScroll && !t.isInLeftSticky ? l = i : i.column.idx > l.column.idx && !t.isFromRightToLeftScroll && !t.isInRightSticky ? (t.isFromRightToLeftScroll = !1, l = i) : i.row.idx < l.row.idx && !t.isFromTopToBottomScroll && !t.isInTopSticky ? (t.isFromTopToBottomScroll = !1, l = i) : i.row.idx > l.row.idx && !t.isFromBottomToTopScroll && !t.isInBottomSticky ? (t.isFromBottomToTopScroll = !1, l = i) : (t.isInLeftSticky = !0, t.isInRightSticky = !0, t.isInTopSticky = !0, t.isInBottomSticky = !0), "reactgrid-content" !== e.target.className && !(n.currentBehavior instanceof oe) && (null === (o = n.props) || void 0 === o ? void 0 : o.enableRangeSelection) || n.currentBehavior instanceof re) {
          var a = ye(n, l),
              c = a.left;
          ie(n, a.top, c);
        }

        n = n.currentBehavior.handlePointerMove(e, l, n);
        var s = t.eventLocations[t.currentIndex];
        return t.eventLocations[t.currentIndex] = l, b(l, s) || (n = n.currentBehavior.handlePointerEnter(e, l, n)), n;
      });
    }, t.handlePointerUp = function (e) {
      0 !== e.button && void 0 !== e.button || (window.removeEventListener("pointerup", t.handlePointerUp), window.removeEventListener("pointermove", t.handlePointerMove), window.removeEventListener("contextmenu", t.handleContextMenu), t.updateState(function (n) {
        var o,
            r = U(n, e.clientX, e.clientY),
            i = new Date().valueOf(),
            l = t.eventTimestamps[1 - t.currentIndex];
        return n = n.currentBehavior.handlePointerUp(e, r, n), t.shouldHandleCellSelectionOnMobile(e, r, i) && (n = n.currentBehavior.handlePointerDown(e, r, n)), n = _C(_C({}, n), {
          currentBehavior: new nc()
        }), t.shouldHandleDoubleClick(r, i, l) && (n = n.currentBehavior.handleDoubleClick(e, r, n)), null === (o = n.hiddenFocusElement) || void 0 === o || o.focus(), n;
      }));
    }, t;
  }

  return w(t, e), t;
}(v),
    Re = 400,
    Ae = 300,
    Ee = 1;

function Me(e) {
  if (e.disableVirtualScrolling) {
    var t = e.cellMatrix.scrollableRange,
        n = t.rows,
        o = t.columns,
        r = new f(n, o);
    return _C(_C({}, e), {
      visibleRange: r
    });
  }

  var i = V(e.scrollableElement),
      l = i.scrollTop,
      a = i.scrollLeft,
      c = Ge(e, [-e.cellMatrix.ranges.stickyTopRange.height], [-e.cellMatrix.ranges.stickyLeftRange.width]),
      s = c.width,
      u = c.height,
      d = Ne(e, s),
      g = ke(e, u),
      p = new f(g, d);
  return _C(_C({}, e), {
    leftScrollBoudary: p.columns.length > 0 ? a - Ae : 0,
    rightScrollBoudary: void 0 === p.last.column ? 0 : Ae + a,
    topScrollBoudary: p.columns.length > 0 ? l - Re : 0,
    bottomScrollBoudary: void 0 === p.last.row ? 0 : Re + l,
    visibleRange: p
  });
}

function Ge(e, t, n) {
  var o = J(e),
      r = o.height,
      i = o.width,
      l = function l(e, t) {
    return e + t;
  };

  return {
    height: Math.max(t.reduce(l, r), 0),
    width: Math.max(n.reduce(l, i), 0)
  };
}

function Ne(e, t) {
  var n = e.cellMatrix.scrollableRange.columns,
      o = z(e).left,
      r = V(e.scrollableElement).scrollLeft,
      i = Math.max(Be(n, r - o - Ae) - Ee - 1, 0),
      l = Be(n, t + j(r, o) + Ae, i);
  return n.slice(i, l + Ee);
}

function ke(e, t) {
  var n = e.cellMatrix.scrollableRange.rows,
      o = z(e).top,
      r = V(e.scrollableElement).scrollTop,
      i = Math.max(Te(n, r - o - Re) - Ee - 1, 0),
      l = Te(n, t + j(r, o) + Re, i);
  return n.slice(i, l + Ee);
}

function Te(e, t, n, o) {
  void 0 === n && (n = 0), void 0 === o && (o = e.length - 1);
  var r = n + o >> 1;
  return r < 0 ? 0 : n >= o ? r : t < e[r].top ? Te(e, t, n, r) : Te(e, t, r + 1, o);
}

function Be(e, t, n, o) {
  void 0 === n && (n = 0), void 0 === o && (o = e.length - 1);
  var r = n + o >> 1;
  return r < 0 ? 0 : n >= o ? r : t < e[r].left ? Be(e, t, n, r) : Be(e, t, r + 1, o);
}

var Se = 50;

function Le(e, t) {
  var n = e.horizontalStickyBreakpoint,
      o = void 0 === n ? Se : n,
      r = e.verticalStickyBreakpoint,
      i = void 0 === r ? Se : r,
      l = e.stickyLeftColumns || 0,
      a = e.stickyTopRows || 0,
      c = e.stickyRightColumns || 0,
      s = e.stickyBottomRows || 0;

  if (e.stickyTopRows || e.stickyLeftColumns || e.stickyRightColumns || e.stickyBottomRows) {
    var u = Y(t.scrollableElement),
        d = u.width,
        g = u.height;

    if (e.stickyLeftColumns || e.stickyRightColumns) {
      var p = e.columns.slice(0, l).reduce(function (e, t) {
        return e + (t.width || h.DEFAULT_COLUMN_WIDTH);
      }, 0),
          f = 0;
      c > 0 && (f = e.columns.slice(-c).reduce(function (e, t) {
        return e + (t.width || h.DEFAULT_COLUMN_WIDTH);
      }, 0));
      var m = p + f > o * d / 100;
      l = m ? 0 : l, c = m ? 0 : c;
    }

    if (e.stickyTopRows || e.stickyBottomRows) {
      var b = e.rows.slice(0, a).reduce(function (e, t) {
        return e + (t.height || h.DEFAULT_ROW_HEIGHT);
      }, 0),
          v = 0;
      s > 0 && (v = e.rows.slice(-s).reduce(function (e, t) {
        return e + (t.height || h.DEFAULT_ROW_HEIGHT);
      }, 0));
      var y = b + v > i * g / 100;
      a = y ? 0 : a, s = y ? 0 : s;
    }
  }

  return _C(_C({}, t), {
    leftStickyColumns: l,
    topStickyRows: a,
    rightStickyColumns: c,
    bottomStickyRows: s
  });
}

var Pe = function Pe(e, t) {
  var n = this;
  this.updateState = e, this.pointerEventsController = t, this.pointerDownHandler = function (e) {
    return n.updateState(function (t) {
      return n.pointerEventsController.handlePointerDown(e, t);
    });
  }, this.keyDownHandler = function (e) {
    return n.updateState(function (t) {
      return t.currentBehavior.handleKeyDown(e, t);
    });
  }, this.keyUpHandler = function (e) {
    return n.updateState(function (t) {
      return t.currentBehavior.handleKeyUp(e, t);
    });
  }, this.compositionEndHandler = function (e) {
    return n.updateState(function (t) {
      return t.currentBehavior.handleCompositionEnd(e, t);
    });
  }, this.copyHandler = function (e) {
    return n.updateState(function (t) {
      return t.currentBehavior.handleCopy(e, t);
    });
  }, this.pasteHandler = function (e) {
    return n.updateState(function (t) {
      return t.currentBehavior.handlePaste(e, t);
    });
  }, this.cutHandler = function (e) {
    return n.updateState(function (t) {
      return t.currentBehavior.handleCut(e, t);
    });
  }, this.blurHandler = function (e) {
    return n.updateState(function (t) {
      var n, o, r;
      return (null === (o = null === (n = e.target) || void 0 === n ? void 0 : n.id) || void 0 === o ? void 0 : o.startsWith("react-select-")) && (null === (r = t.hiddenFocusElement) || void 0 === r || r.focus({
        preventScroll: !0
      })), t;
    });
  }, this.windowResizeHandler = function () {
    return n.updateState(Me);
  }, this.reactgridRefHandler = function (e) {
    return n.assignElementsRefs(e, Me);
  }, this.hiddenElementRefHandler = function (e) {
    return n.updateState(function (t) {
      var n;
      return (null === (n = t.props) || void 0 === n ? void 0 : n.initialFocusLocation) && e && e.focus({
        preventScroll: !0
      }), t.hiddenFocusElement = e, t;
    });
  }, this.pasteCaptureHandler = function (e) {
    var t,
        n = e.clipboardData.getData("text/html"),
        o = new DOMParser().parseFromString(n, "text/html");
    n && "reactgrid-content" === (null === (t = o.body.firstElementChild) || void 0 === t ? void 0 : t.getAttribute("data-reactgrid")) && (e.bubbles = !1);
  }, this.scrollHandlerInternal = function (e) {
    try {
      return n.updateOnScrollChange(e);
    } catch (e) {
      console.error(e);
    }
  }, this.scrollHandler = function () {
    return n.scrollHandlerInternal(Me);
  }, this.assignElementsRefs = function (e, t) {
    e && n.updateState(function (n) {
      var o = F(e, !0);
      return n.props && (n = Le(n.props, n)), t(_C(_C({}, n), {
        reactGridElement: e,
        scrollableElement: o
      }));
    });
  }, this.updateOnScrollChange = function (e) {
    n.updateState(function (t) {
      if (t.disableVirtualScrolling) return t;
      var n = 200,
          o = V(t.scrollableElement),
          r = o.scrollTop,
          i = o.scrollLeft,
          l = J(t),
          a = l.width,
          c = l.height;
      return a > 0 && c > 0 && (r >= t.bottomScrollBoudary - n || r <= t.topScrollBoudary + n || i >= t.rightScrollBoudary - n || i <= t.leftScrollBoudary + n) ? e(t) : t;
    });
  };
},
    We = function () {
  function e() {
    this.reset();
  }

  return e.prototype.reset = function () {
    return this.cellMatrix = new h({}), this;
  }, e.prototype.setProps = function (e) {
    return this.cellMatrix.props = e, this;
  }, e.prototype.fillRowsAndCols = function (e) {
    var t = this;
    void 0 === e && (e = {
      leftStickyColumns: 0,
      topStickyRows: 0,
      rightStickyColumns: 0,
      bottomStickyRows: 0
    });
    var n = e.leftStickyColumns,
        o = e.topStickyRows,
        r = e.rightStickyColumns,
        i = e.bottomStickyRows;
    if (!Array.isArray(this.cellMatrix.props.rows)) throw new TypeError('Feeded ReactGrids "rows" property is not an array!');
    if (!Array.isArray(this.cellMatrix.props.columns)) throw new TypeError('Feeded ReactGrids "columns" property is not an array!');
    return this.cellMatrix.rows = this.cellMatrix.props.rows.reduce(function (e, n, r) {
      var l = t.getTop(r, o, i, e),
          a = n.height || h.DEFAULT_ROW_HEIGHT;
      return e.push(_C(_C({}, n), {
        top: l,
        height: a,
        idx: r,
        bottom: l + a
      })), t.cellMatrix.height += a, t.cellMatrix.rowIndexLookup[n.rowId] = r, e;
    }, []), this.cellMatrix.columns = this.cellMatrix.props.columns.reduce(function (e, o, i) {
      var l,
          a,
          c,
          s,
          u = t.getLeft(i, n, r, e),
          d = o.width ? o.width < (null !== (a = null === (l = t.cellMatrix.props) || void 0 === l ? void 0 : l.minColumnWidth) && void 0 !== a ? a : h.MIN_COLUMN_WIDTH) ? null !== (s = null === (c = t.cellMatrix.props) || void 0 === c ? void 0 : c.minColumnWidth) && void 0 !== s ? s : h.MIN_COLUMN_WIDTH : o.width : h.DEFAULT_COLUMN_WIDTH;
      return e.push(_C(_C({}, o), {
        idx: i,
        left: u,
        width: d,
        right: u + d
      })), t.cellMatrix.width += d, t.cellMatrix.columnIndexLookup[o.columnId] = i, e;
    }, []), this;
  }, e.prototype.setRangesToRenderLookup = function () {
    var e = this,
        t = [];
    this.cellMatrix.rows.forEach(function (n, o) {
      n.cells.forEach(function (n, r) {
        var i = "rowspan" in n && n.rowspan || 0,
            l = "colspan" in n && n.colspan || 0,
            a = i ? e.cellMatrix.rows.slice(o, o + i) : [e.cellMatrix.rows[o]],
            c = l ? e.cellMatrix.columns.slice(r, r + l) : [e.cellMatrix.columns[r]],
            s = new f(a, c);
        t = E(E([], t, !0), e.getRangesToRender(s), !0), e.cellMatrix.spanCellLookup[m(r, o)] = {
          range: s
        };
      });
    });
    var n = t.map(function (e) {
      return m(e.first.column.idx, e.first.row.idx);
    });
    return Object.keys(this.cellMatrix.spanCellLookup).forEach(function (t) {
      n.includes(t) || (e.cellMatrix.rangesToRender[t] = e.cellMatrix.spanCellLookup[t]);
    }), this;
  }, e.prototype.getRangesToRender = function (e) {
    var t = e.rows.flatMap(function (t) {
      return e.columns.map(function (e) {
        return new f([t], [e]);
      });
    });
    return t.shift(), t;
  }, e.prototype.fillSticky = function (e) {
    void 0 === e && (e = {
      leftStickyColumns: 0,
      topStickyRows: 0,
      rightStickyColumns: 0,
      bottomStickyRows: 0
    });
    var t = e.leftStickyColumns,
        n = e.topStickyRows,
        o = e.rightStickyColumns,
        r = e.bottomStickyRows;
    return this.cellMatrix.ranges.stickyLeftRange = new f(this.cellMatrix.rows, this.cellMatrix.columns.slice(0, t || 0)), this.cellMatrix.ranges.stickyTopRange = new f(this.cellMatrix.rows.slice(0, n || 0), this.cellMatrix.columns), this.cellMatrix.ranges.stickyRightRange = new f(this.cellMatrix.rows, this.cellMatrix.columns.slice(this.getStickyRightFirstIdx(t, o), this.cellMatrix.columns.length)), this.cellMatrix.ranges.stickyBottomRange = new f(this.cellMatrix.rows.slice(this.getStickyBottomFirstIdx(n, r), this.cellMatrix.rows.length), this.cellMatrix.columns), this;
  }, e.prototype.fillScrollableRange = function (e) {
    void 0 === e && (e = {
      leftStickyColumns: 0,
      topStickyRows: 0,
      rightStickyColumns: 0,
      bottomStickyRows: 0
    });
    var t = e.leftStickyColumns,
        n = e.topStickyRows,
        o = e.rightStickyColumns,
        r = e.bottomStickyRows;
    return this.cellMatrix.scrollableRange = this.getScrollableRange(t, n, o, r), this;
  }, e.prototype.setEdgeLocations = function () {
    return this.cellMatrix.first = this.cellMatrix.getLocation(0, 0), this.cellMatrix.last = this.cellMatrix.getLocation(this.cellMatrix.rows.length - 1, this.cellMatrix.columns.length - 1), this;
  }, e.prototype.getTop = function (e, t, n, o) {
    return 0 === e || e === t || e === this.getStickyBottomFirstIdx(t || 0, n || 0) ? 0 : o[e - 1].top + o[e - 1].height;
  }, e.prototype.getLeft = function (e, t, n, o) {
    return 0 === e || e === t || e === this.getStickyRightFirstIdx(t || 0, n || 0) ? 0 : o[e - 1].left + o[e - 1].width;
  }, e.prototype.getScrollableRange = function (e, t, n, o) {
    return new f(this.cellMatrix.rows.slice(t || 0, this.getStickyBottomFirstIdx(t, o)), this.cellMatrix.columns.slice(e || 0, this.getStickyRightFirstIdx(e, n)));
  }, e.prototype.getStickyBottomFirstIdx = function (e, t) {
    var n = t || 0,
        o = e || 0,
        r = this.cellMatrix.props.rows.length;
    return r - (n + o > r ? 0 : n);
  }, e.prototype.getStickyRightFirstIdx = function (e, t) {
    var n = t || 0,
        o = e || 0,
        r = this.cellMatrix.props.columns.length;
    return r - (n + o > r ? 0 : n);
  }, e.prototype.getCellMatrix = function () {
    var e = this.cellMatrix;
    return this.reset(), e;
  }, e;
}(),
    Xe = function Xe(e, t, n) {
  var o = e[t];
  if (null == o) throw new Error("Cell is missing property '".concat(String(t), "'"));
  if (typeof o !== n) throw new Error("Property '".concat(String(t), "' expected to be of type '").concat(n, "' but is '").concat(typeof o, "'"));
  return o;
},
    Fe = function () {
  function t() {}

  return t.prototype.getCompatibleCell = function (e) {
    var t = Xe(e, "checked", "boolean"),
        n = t ? e.checkedText ? e.checkedText : "1" : e.uncheckedText ? e.uncheckedText : "";
    return _C(_C({}, e), {
      checked: !!t,
      value: t ? 1 : NaN,
      text: n
    });
  }, t.prototype.handleKeyDown = function (e, t, n, o, r) {
    return o || t !== S.SPACE && t !== S.ENTER ? {
      cell: e,
      enableEditMode: !1
    } : {
      cell: this.getCompatibleCell(this.toggleCheckboxCell(e)),
      enableEditMode: !1
    };
  }, t.prototype.toggleCheckboxCell = function (e) {
    return this.getCompatibleCell(_C(_C({}, e), {
      checked: !e.checked
    }));
  }, t.prototype.update = function (e, t) {
    var n = "checkbox" === t.type ? t.checked : !!t.value;
    return this.getCompatibleCell(_C(_C({}, e), {
      checked: n
    }));
  }, t.prototype.getClassName = function (e) {
    return e.className ? e.className : "";
  }, t.prototype.render = function (t, n, o) {
    var r = this;
    return e.createElement("label", null, e.createElement("input", {
      className: "rg-input",
      type: "checkbox",
      checked: t.checked,
      onChange: function onChange(e) {
        return o(r.toggleCheckboxCell(t), !0);
      }
    }), e.createElement("span", null));
  }, t;
}(),
    Ve = function Ve(e) {
  return e >= S.KEY_0 && e <= S.KEY_Z || De(e) || e >= S.MULTIPLY && e <= S.DIVIDE || e >= S.SEMICOLON && e <= S.SINGLE_QUOTE || e === S.SPACE;
},
    Ze = function Ze(e) {
  return null !== e.match(/^[a-zA-Z0-9]$/);
},
    He = function He(e) {
  return 1 === e.length;
},
    Oe = function Oe(e) {
  return e >= S.KEY_0 && e <= S.KEY_9 || De(e);
},
    De = function De(e) {
  return e >= S.NUMPAD_0 && e <= S.NUMPAD_9;
},
    Ye = function Ye(e) {
  return e >= S.COMMA && e <= S.PERIOD || e === S.DECIMAL || e === S.SUBTRACT || e === S.FIREFOX_DASH;
},
    ze = function ze(e) {
  return null !== e.match(/[\d.,+-]/);
},
    Je = function Je(e) {
  return e === S.LEFT_ARROW || e === S.RIGHT_ARROW || e === S.UP_ARROW || e === S.DOWN_ARROW || e === S.END || e === S.HOME || e === S.BACKSPACE || e === S.DELETE;
},
    je = function je(e, t) {
  "" !== t && (t = _e());
  var n = "".concat(t && "".concat(t, " ")).concat(e);
  return Date.parse(n);
},
    Ue = function Ue(e) {
  return e.toString().padStart(2, "0");
},
    _e = function _e() {
  return O() || D() ? "1970/01/01" : "1970-01-01";
},
    Qe = [];

Qe[8] = "", Qe[9] = "", Qe[13] = "\n", Qe[16] = "", Qe[17] = "", Qe[18] = "", Qe[19] = "", Qe[20] = "", Qe[27] = "", Qe[32] = " ", Qe[33] = "", Qe[34] = "", Qe[35] = "", Qe[36] = "", Qe[37] = "", Qe[38] = "", Qe[39] = "", Qe[40] = "", Qe[45] = "", Qe[46] = "", Qe[48] = ")", Qe[49] = "!", Qe[50] = "@", Qe[51] = "#", Qe[52] = "$", Qe[53] = "%", Qe[54] = "^", Qe[55] = "&", Qe[56] = "*", Qe[57] = "(", Qe[59] = ":", Qe[61] = "+", Qe[65] = "A", Qe[66] = "B", Qe[67] = "C", Qe[68] = "D", Qe[69] = "E", Qe[70] = "F", Qe[71] = "G", Qe[72] = "H", Qe[73] = "I", Qe[74] = "J", Qe[75] = "K", Qe[76] = "L", Qe[77] = "M", Qe[78] = "N", Qe[79] = "O", Qe[80] = "P", Qe[81] = "Q", Qe[82] = "R", Qe[83] = "S", Qe[84] = "T", Qe[85] = "U", Qe[86] = "V", Qe[87] = "W", Qe[88] = "X", Qe[89] = "Y", Qe[90] = "Z", Qe[91] = "", Qe[92] = "", Qe[93] = "", Qe[96] = "0", Qe[97] = "1", Qe[98] = "2", Qe[99] = "3", Qe[100] = "4", Qe[101] = "5", Qe[102] = "6", Qe[103] = "7", Qe[104] = "8", Qe[105] = "9", Qe[106] = "*", Qe[107] = "+", Qe[109] = "_", Qe[107] = "+", Qe[111] = "/", Qe[112] = "", Qe[113] = "", Qe[114] = "", Qe[115] = "", Qe[116] = "", Qe[117] = "", Qe[118] = "", Qe[119] = "", Qe[120] = "", Qe[121] = "", Qe[122] = "", Qe[123] = "", Qe[144] = "", Qe[145] = "", Qe[186] = ":", Qe[187] = "+", Qe[188] = "<", Qe[189] = "_", Qe[190] = ">", Qe[191] = "?", Qe[192] = "~", Qe[219] = "{", Qe[220] = "|", Qe[221] = "}", Qe[222] = '"';
var Ke = [];
Ke[8] = "", Ke[9] = "", Ke[13] = "\n", Ke[16] = "", Ke[17] = "", Ke[18] = "", Ke[19] = "", Ke[20] = "", Ke[27] = "", Ke[32] = " ", Ke[33] = "", Ke[34] = "", Ke[35] = "", Ke[36] = "", Ke[37] = "", Ke[38] = "", Ke[39] = "", Ke[40] = "", Ke[45] = "", Ke[46] = "", Ke[48] = "0", Ke[49] = "1", Ke[50] = "2", Ke[51] = "3", Ke[52] = "4", Ke[53] = "5", Ke[54] = "6", Ke[55] = "7", Ke[56] = "8", Ke[57] = "9", Ke[59] = ";", Ke[61] = "=", Ke[65] = "a", Ke[66] = "b", Ke[67] = "c", Ke[68] = "d", Ke[69] = "e", Ke[70] = "f", Ke[71] = "g", Ke[72] = "h", Ke[73] = "i", Ke[74] = "j", Ke[75] = "k", Ke[76] = "l", Ke[77] = "m", Ke[78] = "n", Ke[79] = "o", Ke[80] = "p", Ke[81] = "q", Ke[82] = "r", Ke[83] = "s", Ke[84] = "t", Ke[85] = "u", Ke[86] = "v", Ke[87] = "w", Ke[88] = "x", Ke[89] = "y", Ke[90] = "z", Ke[91] = "", Ke[92] = "", Ke[93] = "", Ke[96] = "0", Ke[97] = "1", Ke[98] = "2", Ke[99] = "3", Ke[100] = "4", Ke[101] = "5", Ke[102] = "6", Ke[103] = "7", Ke[104] = "8", Ke[105] = "9", Ke[106] = "*", Ke[107] = "+", Ke[109] = "_", Ke[107] = "+", Ke[111] = "/", Ke[112] = "", Ke[113] = "", Ke[114] = "", Ke[115] = "", Ke[116] = "", Ke[117] = "", Ke[118] = "", Ke[119] = "", Ke[120] = "", Ke[121] = "", Ke[122] = "", Ke[123] = "", Ke[144] = "", Ke[145] = "", Ke[186] = ";", Ke[187] = "=", Ke[188] = ",", Ke[189] = "-", Ke[190] = ".", Ke[191] = "/", Ke[192] = "`", Ke[219] = "[", Ke[220] = "\\", Ke[221] = "]", Ke[222] = "'";

var $e = function $e(e, t) {
  return void 0 === t && (t = !1), t ? Qe[e] : Ke[e];
},
    qe = function qe(e, t, n) {
  void 0 === t && (t = !1), void 0 === n && (n = !1);
  var o = navigator.language || "en-US";
  return t || n ? e.toLocaleUpperCase(o) : e.toLocaleLowerCase(o);
},
    et = function () {
  function t() {
    this.wasEscKeyPressed = !1;
  }

  return t.prototype.getCompatibleCell = function (e) {
    var t = e.date ? Xe(e, "date", "object") : new Date(NaN),
        n = e.format || new Intl.DateTimeFormat(window.navigator.language),
        o = t.getTime(),
        r = Number.isNaN(o) ? "" : n.format(t);
    return _C(_C({}, e), {
      date: t,
      value: o,
      text: r
    });
  }, t.prototype.handleKeyDown = function (e, t, n, o, r, i, l) {
    return !n && Ze(qe(i)) ? {
      cell: this.getCompatibleCell(_C({}, e)),
      enableEditMode: !0
    } : {
      cell: e,
      enableEditMode: t === S.POINTER || t === S.ENTER
    };
  }, t.prototype.update = function (e, t) {
    return this.getCompatibleCell(_C(_C({}, e), {
      date: new Date(t.value)
    }));
  }, t.prototype.getClassName = function (e, t) {
    return e.className ? e.className : "";
  }, t.prototype.render = function (t, n, o) {
    var r = this;
    if (!n) return t.text;
    if (!t.date) return '"cell.date" is not initialized with a date value';
    var i = Ue(t.date.getFullYear()),
        l = Ue(t.date.getMonth() + 1),
        a = Ue(t.date.getDate());
    return e.createElement("input", {
      className: "rg-input",
      ref: function ref(e) {
        e && e.focus();
      },
      type: "date",
      defaultValue: "".concat(i, "-").concat(l, "-").concat(a),
      onChange: function onChange(e) {
        if (e.currentTarget.value) {
          var n = e.currentTarget.value.split("-").map(function (e) {
            return parseInt(e);
          }),
              i = n[0],
              l = n[1],
              a = n[2];
          o(r.getCompatibleCell(_C(_C({}, t), {
            date: new Date(i, l - 1, a)
          })), !1);
        }
      },
      onBlur: function onBlur(e) {
        if (e.currentTarget.value) {
          var n = e.currentTarget.value.split("-").map(function (e) {
            return parseInt(e);
          }),
              i = n[0],
              l = n[1],
              a = n[2];
          o(r.getCompatibleCell(_C(_C({}, t), {
            date: new Date(i, l - 1, a)
          })), !r.wasEscKeyPressed), r.wasEscKeyPressed = !1;
        }
      },
      onKeyDown: function onKeyDown(e) {
        (Oe(e.keyCode) || Je(e.keyCode) || e.keyCode === S.COMMA || e.keyCode === S.PERIOD || (e.ctrlKey || e.metaKey) && e.keyCode === S.KEY_A) && e.stopPropagation(), Oe(e.keyCode) || Je(e.keyCode) || e.keyCode === S.COMMA || e.keyCode === S.PERIOD || e.preventDefault(), e.keyCode === S.ESCAPE && (r.wasEscKeyPressed = !0);
      },
      onCopy: function onCopy(e) {
        return e.stopPropagation();
      },
      onCut: function onCut(e) {
        return e.stopPropagation();
      },
      onPaste: function onPaste(e) {
        return e.stopPropagation();
      },
      onPointerDown: function onPointerDown(e) {
        return e.stopPropagation();
      }
    });
  }, t;
}(),
    tt = function () {
  function t() {
    this.wasEscKeyPressed = !1;
  }

  return t.prototype.getCompatibleCell = function (e) {
    var t = Xe(e, "text", "string"),
        n = parseFloat(t);
    return _C(_C({}, e), {
      text: t,
      value: n
    });
  }, t.prototype.handleKeyDown = function (e, t, n, o, r, i, l) {
    var a = qe(i, o, l);
    return n || r || !Ve(t) || o && t === S.SPACE ? {
      cell: e,
      enableEditMode: t === S.POINTER || t === S.ENTER
    } : {
      cell: _C(_C({}, e), {
        text: a
      }),
      enableEditMode: !0
    };
  }, t.prototype.handleCompositionEnd = function (e, t) {
    return {
      cell: _C(_C({}, e), {
        text: t
      }),
      enableEditMode: !0
    };
  }, t.prototype.update = function (e, t) {
    return this.getCompatibleCell(_C(_C({}, e), {
      text: t.text
    }));
  }, t.prototype.getClassName = function (e, t) {
    return !e.validator || e.validator(e.text) ? "valid" : "rg-invalid";
  }, t.prototype.render = function (t, n, o) {
    var r = this;

    if (!n) {
      var i = !(!t.validator || t.validator(t.text)) && t.errorMessage ? t.errorMessage : t.text;
      return t.renderer ? t.renderer(i) : i;
    }

    return e.createElement("input", {
      className: "rg-input",
      ref: function ref(e) {
        e && e.focus();
      },
      onChange: function onChange(e) {
        return o(r.getCompatibleCell(_C(_C({}, t), {
          text: e.currentTarget.value
        })), !1);
      },
      onBlur: function onBlur(e) {
        o(r.getCompatibleCell(_C(_C({}, t), {
          text: e.currentTarget.value
        })), !r.wasEscKeyPressed), r.wasEscKeyPressed = !1;
      },
      onKeyDown: function onKeyDown(e) {
        (Ve(e.keyCode) || Je(e.keyCode)) && e.stopPropagation(), e.keyCode === S.ESCAPE && (r.wasEscKeyPressed = !0);
      },
      defaultValue: t.text,
      onCopy: function onCopy(e) {
        return e.stopPropagation();
      },
      onCut: function onCut(e) {
        return e.stopPropagation();
      },
      onPaste: function onPaste(e) {
        return e.stopPropagation();
      },
      onPointerDown: function onPointerDown(e) {
        return e.stopPropagation();
      }
    });
  }, t;
}(),
    nt = function () {
  function t() {
    this.wasEscKeyPressed = !1;
  }

  return t.prototype.getCompatibleCell = function (e) {
    var t = Xe(e, "text", "string"),
        n = !1;

    try {
      n = Xe(e, "isExpanded", "boolean");
    } catch (e) {
      n = !0;
    }

    var o = -1;

    try {
      o = Xe(e, "indent", "number");
    } catch (e) {
      o = 0;
    }

    var r = !1;

    try {
      r = Xe(e, "hasChildren", "boolean");
    } catch (e) {
      r = !1;
    }

    var i = parseFloat(t);
    return _C(_C({}, e), {
      text: t,
      value: i,
      isExpanded: n,
      indent: o,
      hasChildren: r
    });
  }, t.prototype.update = function (e, t) {
    return this.getCompatibleCell(_C(_C({}, e), {
      isExpanded: t.isExpanded,
      text: t.text
    }));
  }, t.prototype.handleKeyDown = function (e, t, n, o, r, i, l) {
    var a = t === S.POINTER || t === S.ENTER,
        c = _C({}, e),
        s = qe(i, o, l);

    return t !== S.SPACE || void 0 === c.isExpanded || o ? n || r || !Ve(t) || o && t === S.SPACE || (c.text = s, a = !0) : c.isExpanded = !c.isExpanded, {
      cell: c,
      enableEditMode: a
    };
  }, t.prototype.handleCompositionEnd = function (e, t) {
    return {
      cell: _C(_C({}, e), {
        text: t
      }),
      enableEditMode: !0
    };
  }, t.prototype.getClassName = function (e, t) {
    var n,
        o = e.hasChildren ? e.isExpanded ? "expanded" : "collapsed" : "",
        r = null !== (n = e.className) && void 0 !== n ? n : "";
    return "".concat(o, " ").concat(r);
  }, t.prototype.getStyle = function (e, t) {
    var n,
        o = null !== (n = e.indent) && void 0 !== n ? n : 0;
    return {
      paddingLeft: "calc(".concat(1.4 * o, "em + 2px)")
    };
  }, t.prototype.render = function (t, n, o) {
    var r = this;
    return n ? e.createElement("input", {
      className: "rg-input",
      ref: function ref(e) {
        e && (e.focus(), e.setSelectionRange(e.value.length, e.value.length));
      },
      defaultValue: t.text,
      onChange: function onChange(e) {
        return o(r.getCompatibleCell(_C(_C({}, t), {
          text: e.currentTarget.value
        })), !1);
      },
      onBlur: function onBlur(e) {
        o(r.getCompatibleCell(_C(_C({}, t), {
          text: e.currentTarget.value
        })), !r.wasEscKeyPressed), r.wasEscKeyPressed = !1;
      },
      onCopy: function onCopy(e) {
        return e.stopPropagation();
      },
      onCut: function onCut(e) {
        return e.stopPropagation();
      },
      onPaste: function onPaste(e) {
        return e.stopPropagation();
      },
      onPointerDown: function onPointerDown(e) {
        return e.stopPropagation();
      },
      onKeyDown: function onKeyDown(e) {
        (Ve(e.keyCode) || Je(e.keyCode)) && e.stopPropagation(), e.keyCode === S.ESCAPE && (r.wasEscKeyPressed = !0);
      }
    }) : e.createElement(e.Fragment, null, t.hasChildren ? e.createElement("div", {
      className: "chevron",
      onPointerDown: function onPointerDown(e) {
        e.stopPropagation(), o(r.getCompatibleCell(_C(_C({}, t), {
          isExpanded: !t.isExpanded
        })), !0);
      }
    }, e.createElement("span", {
      className: "icon"
    }, "❯")) : e.createElement("div", {
      className: "no-child"
    }), t.text);
  }, t;
}(),
    ot = function () {
  function e() {
    this.isFocusable = function (e) {
      return !1;
    }, this.getStyle = function (e) {
      return {
        background: "rgba(128, 128, 128, 0.1)"
      };
    };
  }

  return e.prototype.getCompatibleCell = function (e) {
    var t = Xe(e, "text", "string"),
        n = parseFloat(t);
    return _C(_C({}, e), {
      text: t,
      value: n
    });
  }, e.prototype.render = function (e, t, n) {
    return e.text;
  }, e.prototype.getClassName = function (e, t) {
    return e.className ? e.className : "";
  }, e;
}(),
    rt = function rt() {
  return navigator.language || "en-US";
};

function it(e, t) {
  if (void 0 === t && (t = rt()), !e.trim()) return NaN;

  var n = function (e) {
    var t = Intl.NumberFormat(e).format(123456.789);
    return {
      thousandsSeparator: t.split("123")[1][0],
      decimalSeparator: t.split("123")[1][4]
    };
  }(t),
      o = n.thousandsSeparator,
      r = n.decimalSeparator,
      i = e.replace(/\u00A0/g, " ").replace(new RegExp("[".concat(o, "\\s]"), "g"), "").replace(new RegExp("\\".concat(r), "g"), ".").replace(/^(?!-)\D+|\D+$/g, "");

  return null === i || 0 === i.trim().length ? NaN : Number(i);
}

var lt = function () {
  function t() {
    this.wasEscKeyPressed = !1, this.getTextFromCharCode = function (e) {
      switch (e.charCodeAt(0)) {
        case S.DASH:
        case S.FIREFOX_DASH:
        case S.SUBTRACT:
          return "-";

        case S.COMMA:
          return ",";

        case S.PERIOD:
        case S.DECIMAL:
          return ".";

        default:
          return e;
      }
    };
  }

  return t.prototype.getCompatibleCell = function (e) {
    var t;

    try {
      t = Xe(e, "value", "number");
    } catch (e) {
      t = NaN;
    }

    var n = e.format || new Intl.NumberFormat(window.navigator.language),
        o = e.nanToZero && Number.isNaN(t) ? 0 : t,
        r = Number.isNaN(o) || e.hideZero && 0 === o ? "" : n.format(o);
    return _C(_C({}, e), {
      value: o,
      text: r
    });
  }, t.prototype.handleKeyDown = function (e, t, n, o, r, i, l) {
    De(t) && (t -= 48);
    var a = qe(i);

    if (!n && ze(a)) {
      var c = Number(a);
      return Number.isNaN(c) && ze(a) ? {
        cell: _C(_C({}, this.getCompatibleCell(_C(_C({}, e), {
          value: c
        }))), {
          text: a
        }),
        enableEditMode: !0
      } : {
        cell: this.getCompatibleCell(_C(_C({}, e), {
          value: c
        })),
        enableEditMode: !0
      };
    }

    return {
      cell: e,
      enableEditMode: t === S.POINTER || t === S.ENTER
    };
  }, t.prototype.update = function (e, t) {
    return this.getCompatibleCell(_C(_C({}, e), {
      value: t.value
    }));
  }, t.prototype.getClassName = function (e, t) {
    var n,
        o,
        r = null === (o = null === (n = e.validator) || void 0 === n ? void 0 : n.call(e, e.value)) || void 0 === o || o,
        i = e.className || "";
    return "".concat(r ? "" : "rg-invalid", " ").concat(i);
  }, t.prototype.render = function (t, n, o) {
    var r,
        i,
        l = this;
    if (!n) return !(null === (i = null === (r = t.validator) || void 0 === r ? void 0 : r.call(t, t.value)) || void 0 === i || i) && t.errorMessage ? t.errorMessage : t.text;
    var a = t.format ? t.format.resolvedOptions().locale : window.navigator.languages[0],
        c = new Intl.NumberFormat(a, {
      useGrouping: !1,
      maximumFractionDigits: 20
    });
    return e.createElement("input", {
      className: "rg-input",
      inputMode: "decimal",
      ref: function ref(e) {
        e && (e.focus(), e.setSelectionRange(e.value.length, e.value.length));
      },
      defaultValue: Number.isNaN(t.value) ? this.getTextFromCharCode(t.text) : c.format(t.value),
      onChange: function onChange(e) {
        return o(l.getCompatibleCell(_C(_C({}, t), {
          value: it(e.currentTarget.value)
        })), !1);
      },
      onBlur: function onBlur(e) {
        o(l.getCompatibleCell(_C(_C({}, t), {
          value: it(e.currentTarget.value)
        })), !l.wasEscKeyPressed), l.wasEscKeyPressed = !1;
      },
      onKeyDown: function onKeyDown(e) {
        (Oe(e.keyCode) || Je(e.keyCode) || Ye(e.keyCode) || (e.ctrlKey || e.metaKey) && e.keyCode === S.KEY_A) && e.stopPropagation(), Oe(e.keyCode) || Je(e.keyCode) || ze(qe(e.key)) || e.preventDefault(), e.keyCode === S.ESCAPE && (l.wasEscKeyPressed = !0);
      },
      onCopy: function onCopy(e) {
        return e.stopPropagation();
      },
      onCut: function onCut(e) {
        return e.stopPropagation();
      },
      onPaste: function onPaste(e) {
        return e.stopPropagation();
      },
      onPointerDown: function onPointerDown(e) {
        return e.stopPropagation();
      }
    });
  }, t;
}(),
    at = function () {
  function t() {
    this.wasEscKeyPressed = !1;
  }

  return t.prototype.getCompatibleCell = function (e) {
    var t,
        n = Xe(e, "text", "string");

    try {
      t = Xe(e, "placeholder", "string");
    } catch (e) {
      t = "";
    }

    var o = parseFloat(n);
    return _C(_C({}, e), {
      text: n,
      value: o,
      placeholder: t
    });
  }, t.prototype.update = function (e, t) {
    return this.getCompatibleCell(_C(_C({}, e), {
      text: t.text,
      placeholder: t.placeholder
    }));
  }, t.prototype.handleKeyDown = function (e, t, n, o, r, i, l) {
    var a = qe(i, o, l);
    return n || r || !Ve(t) || o && t === S.SPACE ? {
      cell: e,
      enableEditMode: t === S.POINTER || t === S.ENTER
    } : {
      cell: this.getCompatibleCell(_C(_C({}, e), {
        text: a
      })),
      enableEditMode: !0
    };
  }, t.prototype.handleCompositionEnd = function (e, t) {
    return {
      cell: _C(_C({}, e), {
        text: t
      }),
      enableEditMode: !0
    };
  }, t.prototype.getClassName = function (e, t) {
    var n = !e.validator || e.validator(e.text),
        o = e.className ? e.className : "";
    return "".concat(n ? "valid" : "rg-invalid", " ").concat(e.placeholder && "" === e.text ? "placeholder" : "", " ").concat(o);
  }, t.prototype.render = function (t, n, o) {
    var r = this;

    if (!n) {
      var i = !t.validator || t.validator(t.text),
          l = t.text || t.placeholder || "",
          a = !i && t.errorMessage ? t.errorMessage : l;
      return t.renderer ? t.renderer(a) : a;
    }

    return e.createElement("input", {
      className: "rg-input",
      ref: function ref(e) {
        e && (e.focus(), e.setSelectionRange(e.value.length, e.value.length));
      },
      defaultValue: t.text,
      onChange: function onChange(e) {
        return o(r.getCompatibleCell(_C(_C({}, t), {
          text: e.currentTarget.value
        })), !1);
      },
      onBlur: function onBlur(e) {
        o(r.getCompatibleCell(_C(_C({}, t), {
          text: e.currentTarget.value
        })), !r.wasEscKeyPressed), r.wasEscKeyPressed = !1;
      },
      onCopy: function onCopy(e) {
        return e.stopPropagation();
      },
      onCut: function onCut(e) {
        return e.stopPropagation();
      },
      onPaste: function onPaste(e) {
        return e.stopPropagation();
      },
      onPointerDown: function onPointerDown(e) {
        return e.stopPropagation();
      },
      placeholder: t.placeholder,
      onKeyDown: function onKeyDown(e) {
        (Ve(e.keyCode) || Je(e.keyCode)) && e.stopPropagation(), e.keyCode === S.ESCAPE && (r.wasEscKeyPressed = !0);
      }
    });
  }, t;
}(),
    ct = function () {
  function t() {
    this.wasEscKeyPressed = !1;
  }

  return t.prototype.getCompatibleCell = function (e) {
    var n = e.time ? Xe(e, "time", "object") : new Date(NaN),
        o = e.format || new Intl.DateTimeFormat(window.navigator.language),
        r = n.getTime() % t.dayInMillis,
        i = Number.isNaN(r) ? "" : o.format(n);
    return _C(_C({}, e), {
      time: n,
      value: r,
      text: i
    });
  }, t.prototype.handleKeyDown = function (e, t, n, o, r, i) {
    return !n && ze(qe(i)) ? {
      cell: this.getCompatibleCell(_C({}, e)),
      enableEditMode: !0
    } : {
      cell: e,
      enableEditMode: t === S.POINTER || t === S.ENTER
    };
  }, t.prototype.update = function (e, t) {
    var n = je(t.text);
    return "" === t.text || Number.isNaN(n) ? this.getCompatibleCell(_C(_C({}, e), {
      time: new Date(t.value)
    })) : this.getCompatibleCell(_C(_C({}, e), {
      time: new Date(n)
    }));
  }, t.prototype.getClassName = function (e, t) {
    return e.className ? e.className : "";
  }, t.prototype.render = function (t, n, o) {
    var r = this;
    if (!n) return t.text;
    if (!t.time) return '"cell.time" is not initialized with a time value';
    var i = Ue(t.time.getHours()),
        l = Ue(t.time.getMinutes());
    return e.createElement("input", {
      className: "rg-input",
      ref: function ref(e) {
        e && e.focus();
      },
      type: "time",
      defaultValue: "".concat(i, ":").concat(l),
      onChange: function onChange(e) {
        var n = je(e.currentTarget.value);
        Number.isNaN(n) || o(r.getCompatibleCell(_C(_C({}, t), {
          time: new Date(n)
        })), !1);
      },
      onBlur: function onBlur(e) {
        var n = je(e.currentTarget.value);
        Number.isNaN(n) || (o(r.getCompatibleCell(_C(_C({}, t), {
          time: new Date(n)
        })), !r.wasEscKeyPressed), r.wasEscKeyPressed = !1);
      },
      onKeyDown: function onKeyDown(e) {
        (Oe(e.keyCode) || Je(e.keyCode) || e.keyCode === S.COMMA || e.keyCode === S.PERIOD || (e.ctrlKey || e.metaKey) && e.keyCode === S.KEY_A) && e.stopPropagation(), Oe(e.keyCode) || Je(e.keyCode) || e.keyCode === S.COMMA || e.keyCode === S.PERIOD || e.preventDefault(), e.keyCode === S.ESCAPE && (r.wasEscKeyPressed = !0);
      },
      onCopy: function onCopy(e) {
        return e.stopPropagation();
      },
      onCut: function onCut(e) {
        return e.stopPropagation();
      },
      onPaste: function onPaste(e) {
        return e.stopPropagation();
      },
      onPointerDown: function onPointerDown(e) {
        return e.stopPropagation();
      }
    });
  }, t.dayInMillis = 864e5, t.defaultDate = _e(), t;
}();

function st(e) {
  return st = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, st(e);
}

function ut(e) {
  var t = function (e, t) {
    if ("object" != st(e) || !e) return e;
    var n = e[Symbol.toPrimitive];

    if (void 0 !== n) {
      var o = n.call(e, t || "default");
      if ("object" != st(o)) return o;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }

    return ("string" === t ? String : Number)(e);
  }(e, "string");

  return "symbol" == st(t) ? t : t + "";
}

function dt(e, t, n) {
  return (t = ut(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}

function gt(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, o);
  }

  return n;
}

function pt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? gt(Object(n), !0).forEach(function (t) {
      dt(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : gt(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

function ft(e, t) {
  (null == t || t > e.length) && (t = e.length);

  for (var n = 0, o = new Array(t); n < t; n++) {
    o[n] = e[n];
  }

  return o;
}

function ht(e, t) {
  if (e) {
    if ("string" == typeof e) return ft(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? ft(e, t) : void 0;
  }
}

function mt(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

    if (null != n) {
      var o,
          r,
          i,
          l,
          a = [],
          c = !0,
          s = !1;

      try {
        if (i = (n = n.call(e)).next, 0 === t) {
          if (Object(n) !== n) return;
          c = !1;
        } else for (; !(c = (o = i.call(n)).done) && (a.push(o.value), a.length !== t); c = !0) {
          ;
        }
      } catch (e) {
        s = !0, r = e;
      } finally {
        try {
          if (!c && null != n.return && (l = n.return(), Object(l) !== l)) return;
        } finally {
          if (s) throw r;
        }
      }

      return a;
    }
  }(e, t) || ht(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function bt(e, t) {
  if (null == e) return {};

  var n,
      o,
      r = function (e, t) {
    if (null == e) return {};
    var n = {};

    for (var o in e) {
      if (Object.prototype.hasOwnProperty.call(e, o)) {
        if (t.indexOf(o) >= 0) continue;
        n[o] = e[o];
      }
    }

    return n;
  }(e, t);

  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);

    for (o = 0; o < i.length; o++) {
      n = i[o], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
  }

  return r;
}

var vt = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];

function yt() {
  return yt = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var o in n) {
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
      }
    }

    return e;
  }, yt.apply(this, arguments);
}

function It(e, t) {
  for (var n = 0; n < t.length; n++) {
    var o = t[n];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, ut(o.key), o);
  }
}

function xt(e, t) {
  return xt = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  }, xt(e, t);
}

function wt(e) {
  return wt = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, wt(e);
}

function Ct() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (e) {}

  return (Ct = function Ct() {
    return !!e;
  })();
}

function Rt(e, t) {
  if (t && ("object" === st(t) || "function" == typeof t)) return t;
  if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
  return function (e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }(e);
}

function At(e) {
  return function (e) {
    if (Array.isArray(e)) return ft(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || ht(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

var Et = function () {
  function e(e) {
    var t = this;
    this._insertTag = function (e) {
      var n;
      n = 0 === t.tags.length ? t.insertionPoint ? t.insertionPoint.nextSibling : t.prepend ? t.container.firstChild : t.before : t.tags[t.tags.length - 1].nextSibling, t.container.insertBefore(e, n), t.tags.push(e);
    }, this.isSpeedy = void 0 !== e.speedy && e.speedy, this.tags = [], this.ctr = 0, this.nonce = e.nonce, this.key = e.key, this.container = e.container, this.prepend = e.prepend, this.insertionPoint = e.insertionPoint, this.before = null;
  }

  var t = e.prototype;
  return t.hydrate = function (e) {
    e.forEach(this._insertTag);
  }, t.insert = function (e) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) == 0 && this._insertTag(function (e) {
      var t = document.createElement("style");
      return t.setAttribute("data-emotion", e.key), void 0 !== e.nonce && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
    }(this));
    var t = this.tags[this.tags.length - 1],
        n = 64 === e.charCodeAt(0) && 105 === e.charCodeAt(1);

    if (n && this._alreadyInsertedOrderInsensitiveRule && console.error("You're attempting to insert the following rule:\n" + e + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !n, this.isSpeedy) {
      var o = function (e) {
        if (e.sheet) return e.sheet;

        for (var t = 0; t < document.styleSheets.length; t++) {
          if (document.styleSheets[t].ownerNode === e) return document.styleSheets[t];
        }
      }(t);

      try {
        o.insertRule(e, o.cssRules.length);
      } catch (t) {
        /:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(e) || console.error('There was a problem inserting the following rule: "' + e + '"', t);
      }
    } else t.appendChild(document.createTextNode(e));

    this.ctr++;
  }, t.flush = function () {
    this.tags.forEach(function (e) {
      return e.parentNode && e.parentNode.removeChild(e);
    }), this.tags = [], this.ctr = 0, this._alreadyInsertedOrderInsensitiveRule = !1;
  }, e;
}(),
    Mt = "-ms-",
    Gt = "-moz-",
    Nt = "-webkit-",
    kt = "comm",
    Tt = "rule",
    Bt = "decl",
    St = "@keyframes",
    Lt = Math.abs,
    Pt = String.fromCharCode,
    Wt = Object.assign;

function Xt(e) {
  return e.trim();
}

function Ft(e, t, n) {
  return e.replace(t, n);
}

function Vt(e, t) {
  return e.indexOf(t);
}

function Zt(e, t) {
  return 0 | e.charCodeAt(t);
}

function Ht(e, t, n) {
  return e.slice(t, n);
}

function Ot(e) {
  return e.length;
}

function Dt(e) {
  return e.length;
}

function Yt(e, t) {
  return t.push(e), e;
}

var zt = 1,
    Jt = 1,
    jt = 0,
    Ut = 0,
    _t = 0,
    Qt = "";

function Kt(e, t, n, o, r, i, l) {
  return {
    value: e,
    root: t,
    parent: n,
    type: o,
    props: r,
    children: i,
    line: zt,
    column: Jt,
    length: l,
    return: ""
  };
}

function $t(e, t) {
  return Wt(Kt("", null, null, "", null, null, 0), e, {
    length: -e.length
  }, t);
}

function qt() {
  return _t = Ut > 0 ? Zt(Qt, --Ut) : 0, Jt--, 10 === _t && (Jt = 1, zt--), _t;
}

function en() {
  return _t = Ut < jt ? Zt(Qt, Ut++) : 0, Jt++, 10 === _t && (Jt = 1, zt++), _t;
}

function tn() {
  return Zt(Qt, Ut);
}

function nn() {
  return Ut;
}

function on(e, t) {
  return Ht(Qt, e, t);
}

function rn(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;

    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;

    case 58:
      return 3;

    case 34:
    case 39:
    case 40:
    case 91:
      return 2;

    case 41:
    case 93:
      return 1;
  }

  return 0;
}

function ln(e) {
  return zt = Jt = 1, jt = Ot(Qt = e), Ut = 0, [];
}

function an(e) {
  return Qt = "", e;
}

function cn(e) {
  return Xt(on(Ut - 1, dn(91 === e ? e + 2 : 40 === e ? e + 1 : e)));
}

function sn(e) {
  for (; (_t = tn()) && _t < 33;) {
    en();
  }

  return rn(e) > 2 || rn(_t) > 3 ? "" : " ";
}

function un(e, t) {
  for (; --t && en() && !(_t < 48 || _t > 102 || _t > 57 && _t < 65 || _t > 70 && _t < 97);) {
    ;
  }

  return on(e, nn() + (t < 6 && 32 == tn() && 32 == en()));
}

function dn(e) {
  for (; en();) {
    switch (_t) {
      case e:
        return Ut;

      case 34:
      case 39:
        34 !== e && 39 !== e && dn(_t);
        break;

      case 40:
        41 === e && dn(e);
        break;

      case 92:
        en();
    }
  }

  return Ut;
}

function gn(e, t) {
  for (; en() && e + _t !== 57 && (e + _t !== 84 || 47 !== tn());) {
    ;
  }

  return "/*" + on(t, Ut - 1) + "*" + Pt(47 === e ? e : en());
}

function pn(e) {
  for (; !rn(tn());) {
    en();
  }

  return on(e, Ut);
}

function fn(e) {
  return an(hn("", null, null, null, [""], e = ln(e), 0, [0], e));
}

function hn(e, t, n, o, r, i, l, a, c) {
  for (var s = 0, u = 0, d = l, g = 0, p = 0, f = 0, h = 1, m = 1, b = 1, v = 0, y = "", I = r, x = i, w = o, C = y; m;) {
    switch (f = v, v = en()) {
      case 40:
        if (108 != f && 58 == Zt(C, d - 1)) {
          -1 != Vt(C += Ft(cn(v), "&", "&\f"), "&\f") && (b = -1);
          break;
        }

      case 34:
      case 39:
      case 91:
        C += cn(v);
        break;

      case 9:
      case 10:
      case 13:
      case 32:
        C += sn(f);
        break;

      case 92:
        C += un(nn() - 1, 7);
        continue;

      case 47:
        switch (tn()) {
          case 42:
          case 47:
            Yt(bn(gn(en(), nn()), t, n), c);
            break;

          default:
            C += "/";
        }

        break;

      case 123 * h:
        a[s++] = Ot(C) * b;

      case 125 * h:
      case 59:
      case 0:
        switch (v) {
          case 0:
          case 125:
            m = 0;

          case 59 + u:
            -1 == b && (C = Ft(C, /\f/g, "")), p > 0 && Ot(C) - d && Yt(p > 32 ? vn(C + ";", o, n, d - 1) : vn(Ft(C, " ", "") + ";", o, n, d - 2), c);
            break;

          case 59:
            C += ";";

          default:
            if (Yt(w = mn(C, t, n, s, u, r, a, y, I = [], x = [], d), i), 123 === v) if (0 === u) hn(C, t, w, w, I, i, d, a, x);else switch (99 === g && 110 === Zt(C, 3) ? 100 : g) {
              case 100:
              case 108:
              case 109:
              case 115:
                hn(e, w, w, o && Yt(mn(e, w, w, 0, 0, r, a, y, r, I = [], d), x), r, x, d, a, o ? I : x);
                break;

              default:
                hn(C, w, w, w, [""], x, 0, a, x);
            }
        }

        s = u = p = 0, h = b = 1, y = C = "", d = l;
        break;

      case 58:
        d = 1 + Ot(C), p = f;

      default:
        if (h < 1) if (123 == v) --h;else if (125 == v && 0 == h++ && 125 == qt()) continue;

        switch (C += Pt(v), v * h) {
          case 38:
            b = u > 0 ? 1 : (C += "\f", -1);
            break;

          case 44:
            a[s++] = (Ot(C) - 1) * b, b = 1;
            break;

          case 64:
            45 === tn() && (C += cn(en())), g = tn(), u = d = Ot(y = C += pn(nn())), v++;
            break;

          case 45:
            45 === f && 2 == Ot(C) && (h = 0);
        }

    }
  }

  return i;
}

function mn(e, t, n, o, r, i, l, a, c, s, u) {
  for (var d = r - 1, g = 0 === r ? i : [""], p = Dt(g), f = 0, h = 0, m = 0; f < o; ++f) {
    for (var b = 0, v = Ht(e, d + 1, d = Lt(h = l[f])), y = e; b < p; ++b) {
      (y = Xt(h > 0 ? g[b] + " " + v : Ft(v, /&\f/g, g[b]))) && (c[m++] = y);
    }
  }

  return Kt(e, t, n, 0 === r ? Tt : a, c, s, u);
}

function bn(e, t, n) {
  return Kt(e, t, n, kt, Pt(_t), Ht(e, 2, -2), 0);
}

function vn(e, t, n, o) {
  return Kt(e, t, n, Bt, Ht(e, 0, o), Ht(e, o + 1, -1), o);
}

function yn(e, t) {
  for (var n = "", o = Dt(e), r = 0; r < o; r++) {
    n += t(e[r], r, e, t) || "";
  }

  return n;
}

function In(e, t, n, o) {
  switch (e.type) {
    case "@layer":
      if (e.children.length) break;

    case "@import":
    case Bt:
      return e.return = e.return || e.value;

    case kt:
      return "";

    case St:
      return e.return = e.value + "{" + yn(e.children, o) + "}";

    case Tt:
      e.value = e.props.join(",");
  }

  return Ot(n = yn(e.children, o)) ? e.return = e.value + "{" + n + "}" : "";
}

function xn(e) {
  var t = Dt(e);
  return function (n, o, r, i) {
    for (var l = "", a = 0; a < t; a++) {
      l += e[a](n, o, r, i) || "";
    }

    return l;
  };
}

function wn(e) {
  var t = Object.create(null);
  return function (n) {
    return void 0 === t[n] && (t[n] = e(n)), t[n];
  };
}

var Cn = function Cn(e, t, n) {
  for (var o = 0, r = 0; o = r, r = tn(), 38 === o && 12 === r && (t[n] = 1), !rn(r);) {
    en();
  }

  return on(e, Ut);
},
    Rn = function Rn(e, t) {
  return an(function (e, t) {
    var n = -1,
        o = 44;

    do {
      switch (rn(o)) {
        case 0:
          38 === o && 12 === tn() && (t[n] = 1), e[n] += Cn(Ut - 1, t, n);
          break;

        case 2:
          e[n] += cn(o);
          break;

        case 4:
          if (44 === o) {
            e[++n] = 58 === tn() ? "&\f" : "", t[n] = e[n].length;
            break;
          }

        default:
          e[n] += Pt(o);
      }
    } while (o = en());

    return e;
  }(ln(e), t));
},
    An = new WeakMap(),
    En = function En(e) {
  if ("rule" === e.type && e.parent && !(e.length < 1)) {
    for (var t = e.value, n = e.parent, o = e.column === n.column && e.line === n.line; "rule" !== n.type;) {
      if (!(n = n.parent)) return;
    }

    if ((1 !== e.props.length || 58 === t.charCodeAt(0) || An.get(n)) && !o) {
      An.set(e, !0);

      for (var r = [], i = Rn(t, r), l = n.props, a = 0, c = 0; a < i.length; a++) {
        for (var s = 0; s < l.length; s++, c++) {
          e.props[c] = r[a] ? i[a].replace(/&\f/g, l[s]) : l[s] + " " + i[a];
        }
      }
    }
  }
},
    Mn = function Mn(e) {
  if ("decl" === e.type) {
    var t = e.value;
    108 === t.charCodeAt(0) && 98 === t.charCodeAt(2) && (e.return = "", e.value = "");
  }
},
    Gn = function Gn(e) {
  return "comm" === e.type && e.children.indexOf("emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason") > -1;
},
    Nn = function Nn(e) {
  return 105 === e.type.charCodeAt(1) && 64 === e.type.charCodeAt(0);
},
    kn = function kn(e) {
  e.type = "", e.value = "", e.return = "", e.children = "", e.props = "";
},
    Tn = function Tn(e, t, n) {
  Nn(e) && (e.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), kn(e)) : function (e, t) {
    for (var n = e - 1; n >= 0; n--) {
      if (!Nn(t[n])) return !0;
    }

    return !1;
  }(t, n) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), kn(e)));
};

function Bn(e, t) {
  switch (function (e, t) {
    return 45 ^ Zt(e, 0) ? (((t << 2 ^ Zt(e, 0)) << 2 ^ Zt(e, 1)) << 2 ^ Zt(e, 2)) << 2 ^ Zt(e, 3) : 0;
  }(e, t)) {
    case 5103:
      return Nt + "print-" + e + e;

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Nt + e + e;

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Nt + e + Gt + e + Mt + e + e;

    case 6828:
    case 4268:
      return Nt + e + Mt + e + e;

    case 6165:
      return Nt + e + Mt + "flex-" + e + e;

    case 5187:
      return Nt + e + Ft(e, /(\w+).+(:[^]+)/, Nt + "box-$1$2" + Mt + "flex-$1$2") + e;

    case 5443:
      return Nt + e + Mt + "flex-item-" + Ft(e, /flex-|-self/, "") + e;

    case 4675:
      return Nt + e + Mt + "flex-line-pack" + Ft(e, /align-content|flex-|-self/, "") + e;

    case 5548:
      return Nt + e + Mt + Ft(e, "shrink", "negative") + e;

    case 5292:
      return Nt + e + Mt + Ft(e, "basis", "preferred-size") + e;

    case 6060:
      return Nt + "box-" + Ft(e, "-grow", "") + Nt + e + Mt + Ft(e, "grow", "positive") + e;

    case 4554:
      return Nt + Ft(e, /([^-])(transform)/g, "$1" + Nt + "$2") + e;

    case 6187:
      return Ft(Ft(Ft(e, /(zoom-|grab)/, Nt + "$1"), /(image-set)/, Nt + "$1"), e, "") + e;

    case 5495:
    case 3959:
      return Ft(e, /(image-set\([^]*)/, Nt + "$1$`$1");

    case 4968:
      return Ft(Ft(e, /(.+:)(flex-)?(.*)/, Nt + "box-pack:$3" + Mt + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + Nt + e + e;

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Ft(e, /(.+)-inline(.+)/, Nt + "$1$2") + e;

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Ot(e) - 1 - t > 6) switch (Zt(e, t + 1)) {
        case 109:
          if (45 !== Zt(e, t + 4)) break;

        case 102:
          return Ft(e, /(.+:)(.+)-([^]+)/, "$1" + Nt + "$2-$3$1" + Gt + (108 == Zt(e, t + 3) ? "$3" : "$2-$3")) + e;

        case 115:
          return ~Vt(e, "stretch") ? Bn(Ft(e, "stretch", "fill-available"), t) + e : e;
      }
      break;

    case 4949:
      if (115 !== Zt(e, t + 1)) break;

    case 6444:
      switch (Zt(e, Ot(e) - 3 - (~Vt(e, "!important") && 10))) {
        case 107:
          return Ft(e, ":", ":" + Nt) + e;

        case 101:
          return Ft(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + Nt + (45 === Zt(e, 14) ? "inline-" : "") + "box$3$1" + Nt + "$2$3$1" + Mt + "$2box$3") + e;
      }

      break;

    case 5936:
      switch (Zt(e, t + 11)) {
        case 114:
          return Nt + e + Mt + Ft(e, /[svh]\w+-[tblr]{2}/, "tb") + e;

        case 108:
          return Nt + e + Mt + Ft(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;

        case 45:
          return Nt + e + Mt + Ft(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }

      return Nt + e + Mt + e + e;
  }

  return e;
}

var Sn,
    Ln,
    Pn = "undefined" != typeof document,
    Wn = Pn ? void 0 : (Sn = function Sn() {
  return wn(function () {
    var e = {};
    return function (t) {
      return e[t];
    };
  });
}, Ln = new WeakMap(), function (e) {
  if (Ln.has(e)) return Ln.get(e);
  var t = Sn(e);
  return Ln.set(e, t), t;
}),
    Xn = [function (e, t, n, o) {
  if (e.length > -1 && !e.return) switch (e.type) {
    case Bt:
      e.return = Bn(e.value, e.length);
      break;

    case St:
      return yn([$t(e, {
        value: Ft(e.value, "@", "@" + Nt)
      })], o);

    case Tt:
      if (e.length) return function (e, t) {
        return e.map(t).join("");
      }(e.props, function (t) {
        switch (function (e, t) {
          return (e = t.exec(e)) ? e[0] : e;
        }(t, /(::plac\w+|:read-\w+)/)) {
          case ":read-only":
          case ":read-write":
            return yn([$t(e, {
              props: [Ft(t, /:(read-\w+)/, ":-moz-$1")]
            })], o);

          case "::placeholder":
            return yn([$t(e, {
              props: [Ft(t, /:(plac\w+)/, ":" + Nt + "input-$1")]
            }), $t(e, {
              props: [Ft(t, /:(plac\w+)/, ":-moz-$1")]
            }), $t(e, {
              props: [Ft(t, /:(plac\w+)/, Mt + "input-$1")]
            })], o);
        }

        return "";
      });
  }
}],
    Fn = function Fn(e) {
  var t = e.key;
  if (!t) throw new Error("You have to configure `key` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.\nIf multiple caches share the same key they might \"fight\" for each other's style elements.");

  if (Pn && "css" === t) {
    var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(n, function (e) {
      -1 !== e.getAttribute("data-emotion").indexOf(" ") && (document.head.appendChild(e), e.setAttribute("data-s", ""));
    });
  }

  var o = e.stylisPlugins || Xn;
  if (/[^a-z-]/.test(t)) throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + t + '" was passed');
  var r,
      i,
      l = {},
      a = [];
  Pn && (r = e.container || document.head, Array.prototype.forEach.call(document.querySelectorAll('style[data-emotion^="' + t + ' "]'), function (e) {
    for (var t = e.getAttribute("data-emotion").split(" "), n = 1; n < t.length; n++) {
      l[t[n]] = !0;
    }

    a.push(e);
  }));
  var c = [En, Mn];

  if (c.push(function (e) {
    return function (t, n, o) {
      if ("rule" === t.type && !e.compat) {
        var r = t.value.match(/(:first|:nth|:nth-last)-child/g);

        if (r) {
          for (var i = t.parent ? t.parent.children : o, l = i.length - 1; l >= 0; l--) {
            var a = i[l];
            if (a.line < t.line) break;

            if (a.column < t.column) {
              if (Gn(a)) return;
              break;
            }
          }

          r.forEach(function (e) {
            console.error('The pseudo class "' + e + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + e.split("-child")[0] + '-of-type".');
          });
        }
      }
    };
  }({
    get compat() {
      return m.compat;
    }

  }), Tn), Pn) {
    var s,
        u = [In, function (e) {
      e.root || (e.return ? s.insert(e.return) : e.value && e.type !== kt && s.insert(e.value + "{}"));
    }],
        d = xn(c.concat(o, u));

    i = function i(e, t, n, o) {
      s = n, void 0 !== t.map && (s = {
        insert: function insert(e) {
          n.insert(e + t.map);
        }
      }), yn(fn(e ? e + "{" + t.styles + "}" : t.styles), d), o && (m.inserted[t.name] = !0);
    };
  } else {
    var g = [In],
        p = xn(c.concat(o, g)),
        f = Wn(o)(t),
        h = function h(e, t) {
      var n = t.name;
      return void 0 === f[n] && (f[n] = yn(fn(e ? e + "{" + t.styles + "}" : t.styles), p)), f[n];
    };

    i = function i(e, t, n, o) {
      var r = t.name,
          i = h(e, t);
      return void 0 === m.compat ? (o && (m.inserted[r] = !0), void 0 !== t.map ? i + t.map : i) : o ? void (m.inserted[r] = i) : i;
    };
  }

  var m = {
    key: t,
    sheet: new Et({
      key: t,
      container: r,
      nonce: e.nonce,
      speedy: e.speedy,
      prepend: e.prepend,
      insertionPoint: e.insertionPoint
    }),
    nonce: e.nonce,
    inserted: l,
    registered: {},
    insert: i
  };
  return m.sheet.hydrate(a), m;
};

function Vn(e) {
  var t = {
    exports: {}
  };
  return e(t, t.exports), t.exports;
}

var Zn = Vn(function (e, t) {
  !function () {
    var e = "function" == typeof Symbol && Symbol.for,
        n = e ? Symbol.for("react.element") : 60103,
        o = e ? Symbol.for("react.portal") : 60106,
        r = e ? Symbol.for("react.fragment") : 60107,
        i = e ? Symbol.for("react.strict_mode") : 60108,
        l = e ? Symbol.for("react.profiler") : 60114,
        a = e ? Symbol.for("react.provider") : 60109,
        c = e ? Symbol.for("react.context") : 60110,
        s = e ? Symbol.for("react.async_mode") : 60111,
        u = e ? Symbol.for("react.concurrent_mode") : 60111,
        d = e ? Symbol.for("react.forward_ref") : 60112,
        g = e ? Symbol.for("react.suspense") : 60113,
        p = e ? Symbol.for("react.suspense_list") : 60120,
        f = e ? Symbol.for("react.memo") : 60115,
        h = e ? Symbol.for("react.lazy") : 60116,
        m = e ? Symbol.for("react.block") : 60121,
        b = e ? Symbol.for("react.fundamental") : 60117,
        v = e ? Symbol.for("react.responder") : 60118,
        y = e ? Symbol.for("react.scope") : 60119;

    function I(e) {
      if ("object" == typeof e && null !== e) {
        var t = e.$$typeof;

        switch (t) {
          case n:
            var p = e.type;

            switch (p) {
              case s:
              case u:
              case r:
              case l:
              case i:
              case g:
                return p;

              default:
                var m = p && p.$$typeof;

                switch (m) {
                  case c:
                  case d:
                  case h:
                  case f:
                  case a:
                    return m;

                  default:
                    return t;
                }

            }

          case o:
            return t;
        }
      }
    }

    var x = s,
        w = u,
        C = c,
        R = a,
        A = n,
        E = d,
        M = r,
        G = h,
        N = f,
        k = o,
        T = l,
        B = i,
        S = g,
        L = !1;

    function P(e) {
      return I(e) === u;
    }

    t.AsyncMode = x, t.ConcurrentMode = w, t.ContextConsumer = C, t.ContextProvider = R, t.Element = A, t.ForwardRef = E, t.Fragment = M, t.Lazy = G, t.Memo = N, t.Portal = k, t.Profiler = T, t.StrictMode = B, t.Suspense = S, t.isAsyncMode = function (e) {
      return L || (L = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), P(e) || I(e) === s;
    }, t.isConcurrentMode = P, t.isContextConsumer = function (e) {
      return I(e) === c;
    }, t.isContextProvider = function (e) {
      return I(e) === a;
    }, t.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === n;
    }, t.isForwardRef = function (e) {
      return I(e) === d;
    }, t.isFragment = function (e) {
      return I(e) === r;
    }, t.isLazy = function (e) {
      return I(e) === h;
    }, t.isMemo = function (e) {
      return I(e) === f;
    }, t.isPortal = function (e) {
      return I(e) === o;
    }, t.isProfiler = function (e) {
      return I(e) === l;
    }, t.isStrictMode = function (e) {
      return I(e) === i;
    }, t.isSuspense = function (e) {
      return I(e) === g;
    }, t.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === r || e === u || e === l || e === i || e === g || e === p || "object" == typeof e && null !== e && (e.$$typeof === h || e.$$typeof === f || e.$$typeof === a || e.$$typeof === c || e.$$typeof === d || e.$$typeof === b || e.$$typeof === v || e.$$typeof === y || e.$$typeof === m);
    }, t.typeOf = I;
  }();
}),
    Hn = Vn(function (e) {
  e.exports = Zn;
}),
    On = {};
On[Hn.ForwardRef] = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, On[Hn.Memo] = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
};
var Dn = "undefined" != typeof document;

function Yn(e, t, n) {
  var o = "";
  return n.split(" ").forEach(function (n) {
    void 0 !== e[n] ? t.push(e[n] + ";") : o += n + " ";
  }), o;
}

var zn = function zn(e, t, n) {
  var o = e.key + "-" + t.name;
  (!1 === n || !1 === Dn && void 0 !== e.compat) && void 0 === e.registered[o] && (e.registered[o] = t.styles);
},
    Jn = function Jn(e, t, n) {
  zn(e, t, n);
  var o = e.key + "-" + t.name;

  if (void 0 === e.inserted[t.name]) {
    var r = "",
        i = t;

    do {
      var l = e.insert(t === i ? "." + o : "", i, e.sheet, !0);
      Dn || void 0 === l || (r += l), i = i.next;
    } while (void 0 !== i);

    if (!Dn && 0 !== r.length) return r;
  }
};

var jn = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
},
    Un = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences",
    _n = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).",
    Qn = /[A-Z]|^ms/g,
    Kn = /_EMO_([^_]+?)_([^]*?)_EMO_/g,
    $n = function $n(e) {
  return 45 === e.charCodeAt(1);
},
    qn = function qn(e) {
  return null != e && "boolean" != typeof e;
},
    eo = wn(function (e) {
  return $n(e) ? e : e.replace(Qn, "-$&").toLowerCase();
}),
    to = function to(e, t) {
  switch (e) {
    case "animation":
    case "animationName":
      if ("string" == typeof t) return t.replace(Kn, function (e, t, n) {
        return go = {
          name: t,
          styles: n,
          next: go
        }, t;
      });
  }

  return 1 === jn[e] || $n(e) || "number" != typeof t || 0 === t ? t : t + "px";
},
    no = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/,
    oo = ["normal", "none", "initial", "inherit", "unset"],
    ro = to,
    io = /^-ms-/,
    lo = /-(.)/g,
    ao = {};

to = function to(e, t) {
  if ("content" === e && ("string" != typeof t || -1 === oo.indexOf(t) && !no.test(t) && (t.charAt(0) !== t.charAt(t.length - 1) || '"' !== t.charAt(0) && "'" !== t.charAt(0)))) throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + t + "\"'`");
  var n = ro(e, t);
  return "" === n || $n(e) || -1 === e.indexOf("-") || void 0 !== ao[e] || (ao[e] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + e.replace(io, "ms-").replace(lo, function (e, t) {
    return t.toUpperCase();
  }) + "?")), n;
};

var co = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";

function so(e, t, n) {
  if (null == n) return "";

  if (void 0 !== n.__emotion_styles) {
    if ("NO_COMPONENT_SELECTOR" === n.toString()) throw new Error(co);
    return n;
  }

  switch (typeof n) {
    case "boolean":
      return "";

    case "object":
      if (1 === n.anim) return go = {
        name: n.name,
        styles: n.styles,
        next: go
      }, n.name;

      if (void 0 !== n.styles) {
        var o = n.next;
        if (void 0 !== o) for (; void 0 !== o;) {
          go = {
            name: o.name,
            styles: o.styles,
            next: go
          }, o = o.next;
        }
        var r = n.styles + ";";
        return void 0 !== n.map && (r += n.map), r;
      }

      return function (e, t, n) {
        var o = "";
        if (Array.isArray(n)) for (var r = 0; r < n.length; r++) {
          o += so(e, t, n[r]) + ";";
        } else for (var i in n) {
          var l = n[i];
          if ("object" != typeof l) null != t && void 0 !== t[l] ? o += i + "{" + t[l] + "}" : qn(l) && (o += eo(i) + ":" + to(i, l) + ";");else {
            if ("NO_COMPONENT_SELECTOR" === i) throw new Error(co);

            if (!Array.isArray(l) || "string" != typeof l[0] || null != t && void 0 !== t[l[0]]) {
              var a = so(e, t, l);

              switch (i) {
                case "animation":
                case "animationName":
                  o += eo(i) + ":" + a + ";";
                  break;

                default:
                  "undefined" === i && console.error(_n), o += i + "{" + a + "}";
              }
            } else for (var c = 0; c < l.length; c++) {
              qn(l[c]) && (o += eo(i) + ":" + to(i, l[c]) + ";");
            }
          }
        }
        return o;
      }(e, t, n);

    case "function":
      if (void 0 !== e) {
        var i = go,
            l = n(e);
        return go = i, so(e, t, l);
      }

      console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;

    case "string":
      var a = [],
          c = n.replace(Kn, function (e, t, n) {
        var o = "animation" + a.length;
        return a.push("const " + o + " = keyframes`" + n.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + o + "}";
      });
      a.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(a, ["`" + c + "`"]).join("\n") + "\n\nYou should wrap it with `css` like this:\n\ncss`" + c + "`");
  }

  if (null == t) return n;
  var s = t[n];
  return void 0 !== s ? s : n;
}

var uo,
    go,
    po = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
uo = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;

var fo = function fo(e, t, n) {
  if (1 === e.length && "object" == typeof e[0] && null !== e[0] && void 0 !== e[0].styles) return e[0];
  var o = !0,
      r = "";
  go = void 0;
  var i,
      l = e[0];
  null == l || void 0 === l.raw ? (o = !1, r += so(n, t, l)) : (void 0 === l[0] && console.error(Un), r += l[0]);

  for (var a = 1; a < e.length; a++) {
    r += so(n, t, e[a]), o && (void 0 === l[a] && console.error(Un), r += l[a]);
  }

  r = r.replace(uo, function (e) {
    return i = e, "";
  }), po.lastIndex = 0;

  for (var c, s = ""; null !== (c = po.exec(r));) {
    s += "-" + c[1];
  }

  var u = function (e) {
    for (var t, n = 0, o = 0, r = e.length; r >= 4; ++o, r -= 4) {
      t = 1540483477 * (65535 & (t = 255 & e.charCodeAt(o) | (255 & e.charCodeAt(++o)) << 8 | (255 & e.charCodeAt(++o)) << 16 | (255 & e.charCodeAt(++o)) << 24)) + (59797 * (t >>> 16) << 16), n = 1540483477 * (65535 & (t ^= t >>> 24)) + (59797 * (t >>> 16) << 16) ^ 1540483477 * (65535 & n) + (59797 * (n >>> 16) << 16);
    }

    switch (r) {
      case 3:
        n ^= (255 & e.charCodeAt(o + 2)) << 16;

      case 2:
        n ^= (255 & e.charCodeAt(o + 1)) << 8;

      case 1:
        n = 1540483477 * (65535 & (n ^= 255 & e.charCodeAt(o))) + (59797 * (n >>> 16) << 16);
    }

    return (((n = 1540483477 * (65535 & (n ^= n >>> 13)) + (59797 * (n >>> 16) << 16)) ^ n >>> 15) >>> 0).toString(36);
  }(r) + s;

  return {
    name: u,
    styles: r,
    map: i,
    next: go,
    toString: function toString() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  };
},
    ho = "undefined" != typeof document,
    mo = function mo(e) {
  return e();
},
    bo = !!e.useInsertionEffect && e.useInsertionEffect,
    vo = ho && bo || mo,
    yo = bo || e.useLayoutEffect,
    Io = "undefined" != typeof document,
    xo = {}.hasOwnProperty,
    wo = e.createContext("undefined" != typeof HTMLElement ? Fn({
  key: "css"
}) : null);

wo.displayName = "EmotionCacheContext", wo.Provider;

var Co = function Co(e) {
  return r(function (t, n) {
    var o = i(wo);
    return e(t, o, n);
  });
};

Io || (Co = function Co(t) {
  return function (n) {
    var o = i(wo);
    return null === o ? (o = Fn({
      key: "css"
    }), e.createElement(wo.Provider, {
      value: o
    }, t(n, o))) : t(n, o);
  };
});
var Ro = e.createContext({});
Ro.displayName = "EmotionThemeContext";

var Ao = function Ao(e) {
  var t = e.split(".");
  return t[t.length - 1];
},
    Eo = function Eo(e) {
  var t = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(e);
  return t || (t = /^([A-Za-z0-9$.]+)@/.exec(e)) ? Ao(t[1]) : void 0;
},
    Mo = new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]),
    Go = function Go(e) {
  return e.replace(/\$/g, "-");
},
    No = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__",
    ko = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__",
    To = function To(e, t) {
  if ("string" == typeof t.css && -1 !== t.css.indexOf(":")) throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + t.css + "`");
  var n = {};

  for (var o in t) {
    xo.call(t, o) && (n[o] = t[o]);
  }

  if (n[No] = e, t.css && ("object" != typeof t.css || "string" != typeof t.css.name || -1 === t.css.name.indexOf("-"))) {
    var r = function (e) {
      if (e) for (var t = e.split("\n"), n = 0; n < t.length; n++) {
        var o = Eo(t[n]);

        if (o) {
          if (Mo.has(o)) break;
          if (/^[A-Z]/.test(o)) return Go(o);
        }
      }
    }(new Error().stack);

    r && (n[ko] = r);
  }

  return n;
},
    Bo = function Bo(t) {
  var n = t.cache,
      o = t.serialized,
      r = t.isStringTag;
  zn(n, o, r);
  var i = vo(function () {
    return Jn(n, o, r);
  });

  if (!Io && void 0 !== i) {
    for (var l, a = o.name, c = o.next; void 0 !== c;) {
      a += " " + c.name, c = c.next;
    }

    return e.createElement("style", ((l = {})["data-emotion"] = n.key + " " + a, l.dangerouslySetInnerHTML = {
      __html: i
    }, l.nonce = n.sheet.nonce, l));
  }

  return null;
},
    So = Co(function (t, n, o) {
  var r = t.css;
  "string" == typeof r && void 0 !== n.registered[r] && (r = n.registered[r]);
  var i = t[No],
      l = [r],
      a = "";
  "string" == typeof t.className ? a = Yn(n.registered, l, t.className) : null != t.className && (a = t.className + " ");
  var c = fo(l, void 0, e.useContext(Ro));

  if (-1 === c.name.indexOf("-")) {
    var s = t[ko];
    s && (c = fo([c, "label:" + s + ";"]));
  }

  a += n.key + "-" + c.name;
  var u = {};

  for (var d in t) {
    xo.call(t, d) && "css" !== d && d !== No && d !== ko && (u[d] = t[d]);
  }

  return u.ref = o, u.className = a, e.createElement(e.Fragment, null, e.createElement(Bo, {
    cache: n,
    serialized: c,
    isStringTag: "string" == typeof i
  }), e.createElement(i, u));
});

So.displayName = "EmotionCssPropInternal";

var Lo = So,
    Po = function Po(t, n) {
  var o = arguments;
  if (null == n || !xo.call(n, "css")) return e.createElement.apply(void 0, o);
  var r = o.length,
      i = new Array(r);
  i[0] = Lo, i[1] = To(t, n);

  for (var l = 2; l < r; l++) {
    i[l] = o[l];
  }

  return e.createElement.apply(null, i);
},
    Wo = !1,
    Xo = Co(function (t, n) {
  Wo || !t.className && !t.css || (console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?"), Wo = !0);
  var o = t.styles,
      r = fo([o], void 0, e.useContext(Ro));

  if (!Io) {
    for (var i, l = r.name, a = r.styles, c = r.next; void 0 !== c;) {
      l += " " + c.name, a += c.styles, c = c.next;
    }

    var s = !0 === n.compat,
        u = n.insert("", {
      name: l,
      styles: a
    }, n.sheet, s);
    return s ? null : e.createElement("style", ((i = {})["data-emotion"] = n.key + "-global " + l, i.dangerouslySetInnerHTML = {
      __html: u
    }, i.nonce = n.sheet.nonce, i));
  }

  var d = e.useRef();
  return yo(function () {
    var e = n.key + "-global",
        t = new n.sheet.constructor({
      key: e,
      nonce: n.sheet.nonce,
      container: n.sheet.container,
      speedy: n.sheet.isSpeedy
    }),
        o = !1,
        i = document.querySelector('style[data-emotion="' + e + " " + r.name + '"]');
    return n.sheet.tags.length && (t.before = n.sheet.tags[0]), null !== i && (o = !0, i.setAttribute("data-emotion", e), t.hydrate([i])), d.current = [t, o], function () {
      t.flush();
    };
  }, [n]), yo(function () {
    var e = d.current,
        t = e[0];
    if (e[1]) e[1] = !1;else {
      if (void 0 !== r.next && Jn(n, r.next, !0), t.tags.length) {
        var o = t.tags[t.tags.length - 1].nextElementSibling;
        t.before = o, t.flush();
      }

      n.insert("", r, t, !1);
    }
  }, [n, r.name]), null;
});

function Fo() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
    t[n] = arguments[n];
  }

  return fo(t);
}

Xo.displayName = "EmotionGlobal";

var Vo = function e(t) {
  for (var n = t.length, o = 0, r = ""; o < n; o++) {
    var i = t[o];

    if (null != i) {
      var l = void 0;

      switch (typeof i) {
        case "boolean":
          break;

        case "object":
          if (Array.isArray(i)) l = e(i);else for (var a in void 0 !== i.styles && void 0 !== i.name && console.error("You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component."), l = "", i) {
            i[a] && a && (l && (l += " "), l += a);
          }
          break;

        default:
          l = i;
      }

      l && (r && (r += " "), r += l);
    }
  }

  return r;
};

var Zo = function Zo(t) {
  var n,
      o = t.cache,
      r = t.serializedArr,
      i = vo(function () {
    for (var e = "", t = 0; t < r.length; t++) {
      var n = Jn(o, r[t], !1);
      Io || void 0 === n || (e += n);
    }

    if (!Io) return e;
  });
  return Io || 0 === i.length ? null : e.createElement("style", ((n = {})["data-emotion"] = o.key + " " + r.map(function (e) {
    return e.name;
  }).join(" "), n.dangerouslySetInnerHTML = {
    __html: i
  }, n.nonce = o.sheet.nonce, n));
},
    Ho = Co(function (t, n) {
  var o = !1,
      r = [],
      i = function i() {
    if (o) throw new Error("css can only be used during render");

    for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) {
      t[i] = arguments[i];
    }

    var l = fo(t, n.registered);
    return r.push(l), zn(n, l, !1), n.key + "-" + l.name;
  },
      l = {
    css: i,
    cx: function cx() {
      if (o) throw new Error("cx can only be used during render");

      for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) {
        t[r] = arguments[r];
      }

      return function (e, t, n) {
        var o = [],
            r = Yn(e, o, n);
        return o.length < 2 ? n : r + t(o);
      }(n.registered, i, Vo(t));
    },
    theme: e.useContext(Ro)
  },
      a = t.children(l);

  return o = !0, e.createElement(e.Fragment, null, e.createElement(Zo, {
    cache: n,
    serializedArr: r
  }), a);
});

Ho.displayName = "EmotionClassNames";
var Oo = "undefined" != typeof document,
    Do = "undefined" != typeof jest || "undefined" != typeof vi;

if (Oo && !Do) {
  var Yo = "undefined" != typeof globalThis ? globalThis : Oo ? window : global,
      zo = "__EMOTION_REACT_" + "11.11.4".split(".")[0] + "__";
  Yo[zo] && console.warn("You are loading @emotion/react when it is already loaded. Running multiple instances may cause problems. This can happen if multiple versions are used, or if multiple builds of the same version are used."), Yo[zo] = !0;
}

var Jo = Math.min,
    jo = Math.max,
    Uo = Math.round,
    _o = Math.floor,
    Qo = function Qo(e) {
  return {
    x: e,
    y: e
  };
};

function Ko(e) {
  var t = e.x,
      n = e.y,
      o = e.width,
      r = e.height;
  return {
    width: o,
    height: r,
    top: n,
    left: t,
    right: t + o,
    bottom: n + r,
    x: t,
    y: n
  };
}

function $o(e) {
  return tr(e) ? (e.nodeName || "").toLowerCase() : "#document";
}

function qo(e) {
  var t;
  return (null == e || null == (t = e.ownerDocument) ? void 0 : t.defaultView) || window;
}

function er(e) {
  var t;
  return null == (t = (tr(e) ? e.ownerDocument : e.document) || window.document) ? void 0 : t.documentElement;
}

function tr(e) {
  return e instanceof Node || e instanceof qo(e).Node;
}

function nr(e) {
  return e instanceof Element || e instanceof qo(e).Element;
}

function or(e) {
  return e instanceof HTMLElement || e instanceof qo(e).HTMLElement;
}

function rr(e) {
  return "undefined" != typeof ShadowRoot && (e instanceof ShadowRoot || e instanceof qo(e).ShadowRoot);
}

function ir(e) {
  var _lr = lr(e),
      t = _lr.overflow,
      n = _lr.overflowX,
      o = _lr.overflowY,
      r = _lr.display;

  return /auto|scroll|overlay|hidden|clip/.test(t + o + n) && !["inline", "contents"].includes(r);
}

function lr(e) {
  return qo(e).getComputedStyle(e);
}

function ar(e) {
  var t = function (e) {
    if ("html" === $o(e)) return e;
    var t = e.assignedSlot || e.parentNode || rr(e) && e.host || er(e);
    return rr(t) ? t.host : t;
  }(e);

  return function (e) {
    return ["html", "body", "#document"].includes($o(e));
  }(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : or(t) && ir(t) ? t : ar(t);
}

function cr(e, t, n) {
  var o;
  void 0 === t && (t = []), void 0 === n && (n = !0);
  var r = ar(e),
      i = r === (null == (o = e.ownerDocument) ? void 0 : o.body),
      l = qo(r);
  return i ? t.concat(l, l.visualViewport || [], ir(r) ? r : [], l.frameElement && n ? cr(l.frameElement) : []) : t.concat(r, cr(r, [], n));
}

function sr(e) {
  return nr(e) ? e : e.contextElement;
}

function ur(e) {
  var t = sr(e);
  if (!or(t)) return Qo(1);

  var n = t.getBoundingClientRect(),
      _ref = function (e) {
    var t = lr(e);
    var n = parseFloat(t.width) || 0,
        o = parseFloat(t.height) || 0;
    var r = or(e),
        i = r ? e.offsetWidth : n,
        l = r ? e.offsetHeight : o,
        a = Uo(n) !== i || Uo(o) !== l;
    return a && (n = i, o = l), {
      width: n,
      height: o,
      $: a
    };
  }(t),
      o = _ref.width,
      r = _ref.height,
      i = _ref.$;

  var l = (i ? Uo(n.width) : n.width) / o,
      a = (i ? Uo(n.height) : n.height) / r;
  return l && Number.isFinite(l) || (l = 1), a && Number.isFinite(a) || (a = 1), {
    x: l,
    y: a
  };
}

var dr = Qo(0);

function gr(e) {
  var t = qo(e);
  return "undefined" != typeof CSS && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none") && t.visualViewport ? {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  } : dr;
}

function pr(e, t, n, o) {
  void 0 === t && (t = !1), void 0 === n && (n = !1);
  var r = e.getBoundingClientRect(),
      i = sr(e);
  var l = Qo(1);
  t && (o ? nr(o) && (l = ur(o)) : l = ur(e));
  var a = function (e, t, n) {
    return void 0 === t && (t = !1), !(!n || t && n !== qo(e)) && t;
  }(i, n, o) ? gr(i) : Qo(0);
  var c = (r.left + a.x) / l.x,
      s = (r.top + a.y) / l.y,
      u = r.width / l.x,
      d = r.height / l.y;

  if (i) {
    var _e2 = qo(i),
        _t2 = o && nr(o) ? qo(o) : o;

    var _n2 = _e2,
        _r2 = _n2.frameElement;

    for (; _r2 && o && _t2 !== _n2;) {
      var _e3 = ur(_r2),
          _t3 = _r2.getBoundingClientRect(),
          _o2 = lr(_r2),
          _i2 = _t3.left + (_r2.clientLeft + parseFloat(_o2.paddingLeft)) * _e3.x,
          _l2 = _t3.top + (_r2.clientTop + parseFloat(_o2.paddingTop)) * _e3.y;

      c *= _e3.x, s *= _e3.y, u *= _e3.x, d *= _e3.y, c += _i2, s += _l2, _n2 = qo(_r2), _r2 = _n2.frameElement;
    }
  }

  return Ko({
    width: u,
    height: d,
    x: c,
    y: s
  });
}

function fr(e, t, n, o) {
  void 0 === o && (o = {});
  var _o3 = o,
      _o3$ancestorScroll = _o3.ancestorScroll,
      r = _o3$ancestorScroll === void 0 ? !0 : _o3$ancestorScroll,
      _o3$ancestorResize = _o3.ancestorResize,
      i = _o3$ancestorResize === void 0 ? !0 : _o3$ancestorResize,
      _o3$elementResize = _o3.elementResize,
      l = _o3$elementResize === void 0 ? "function" == typeof ResizeObserver : _o3$elementResize,
      _o3$layoutShift = _o3.layoutShift,
      a = _o3$layoutShift === void 0 ? "function" == typeof IntersectionObserver : _o3$layoutShift,
      _o3$animationFrame = _o3.animationFrame,
      c = _o3$animationFrame === void 0 ? !1 : _o3$animationFrame,
      s = sr(e),
      u = r || i ? [].concat(_toConsumableArray(s ? cr(s) : []), _toConsumableArray(cr(t))) : [];
  u.forEach(function (e) {
    r && e.addEventListener("scroll", n, {
      passive: !0
    }), i && e.addEventListener("resize", n);
  });
  var d = s && a ? function (e, t) {
    var n,
        o = null;
    var r = er(e);

    function i() {
      var e;
      clearTimeout(n), null == (e = o) || e.disconnect(), o = null;
    }

    return function l(a, c) {
      void 0 === a && (a = !1), void 0 === c && (c = 1), i();

      var _e$getBoundingClientR = e.getBoundingClientRect(),
          s = _e$getBoundingClientR.left,
          u = _e$getBoundingClientR.top,
          d = _e$getBoundingClientR.width,
          g = _e$getBoundingClientR.height;

      if (a || t(), !d || !g) return;
      var p = {
        rootMargin: -_o(u) + "px " + -_o(r.clientWidth - (s + d)) + "px " + -_o(r.clientHeight - (u + g)) + "px " + -_o(s) + "px",
        threshold: jo(0, Jo(1, c)) || 1
      };
      var f = !0;

      function h(e) {
        var t = e[0].intersectionRatio;

        if (t !== c) {
          if (!f) return l();
          t ? l(!1, t) : n = setTimeout(function () {
            l(!1, 1e-7);
          }, 1e3);
        }

        f = !1;
      }

      try {
        o = new IntersectionObserver(h, _objectSpread({}, p, {
          root: r.ownerDocument
        }));
      } catch (e) {
        o = new IntersectionObserver(h, p);
      }

      o.observe(e);
    }(!0), i;
  }(s, n) : null;
  var g,
      p = -1,
      f = null;
  l && (f = new ResizeObserver(function (e) {
    var _e4 = _slicedToArray(e, 1),
        o = _e4[0];

    o && o.target === s && f && (f.unobserve(t), cancelAnimationFrame(p), p = requestAnimationFrame(function () {
      var e;
      null == (e = f) || e.observe(t);
    })), n();
  }), s && !c && f.observe(s), f.observe(t));
  var h = c ? pr(e) : null;
  return c && function t() {
    var o = pr(e);
    !h || o.x === h.x && o.y === h.y && o.width === h.width && o.height === h.height || n();
    h = o, g = requestAnimationFrame(t);
  }(), n(), function () {
    var e;
    u.forEach(function (e) {
      r && e.removeEventListener("scroll", n), i && e.removeEventListener("resize", n);
    }), null == d || d(), null == (e = f) || e.disconnect(), f = null, c && cancelAnimationFrame(g);
  };
}

var hr = "undefined" != typeof document ? l : a,
    mr = ["className", "clearValue", "cx", "getStyles", "getClassNames", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"],
    br = function br() {};

function vr(e, t) {
  return t ? "-" === t[0] ? e + t : e + "__" + t : e;
}

function yr(e, t) {
  for (var n = arguments.length, o = new Array(n > 2 ? n - 2 : 0), r = 2; r < n; r++) {
    o[r - 2] = arguments[r];
  }

  var i = [].concat(o);
  if (t && e) for (var l in t) {
    t.hasOwnProperty(l) && t[l] && i.push("".concat(vr(e, l)));
  }
  return i.filter(function (e) {
    return e;
  }).map(function (e) {
    return String(e).trim();
  }).join(" ");
}

var Ir = function Ir(e) {
  return t = e, Array.isArray(t) ? e.filter(Boolean) : "object" === st(e) && null !== e ? [e] : [];
  var t;
},
    xr = function xr(e) {
  return e.className, e.clearValue, e.cx, e.getStyles, e.getClassNames, e.getValue, e.hasValue, e.isMulti, e.isRtl, e.options, e.selectOption, e.selectProps, e.setValue, e.theme, pt({}, bt(e, mr));
},
    wr = function wr(e, t, n) {
  var o = e.cx,
      r = e.getStyles,
      i = e.getClassNames,
      l = e.className;
  return {
    css: r(t, e),
    className: o(null != n ? n : {}, i(t, e), l)
  };
};

function Cr(e) {
  return [document.documentElement, document.body, window].indexOf(e) > -1;
}

function Rr(e) {
  return Cr(e) ? window.pageYOffset : e.scrollTop;
}

function Ar(e, t) {
  Cr(e) ? window.scrollTo(0, t) : e.scrollTop = t;
}

function Er(e, t) {
  var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 200,
      o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : br,
      r = Rr(e),
      i = t - r,
      l = 0;
  !function t() {
    var a,
        c = i * ((a = (a = l += 10) / n - 1) * a * a + 1) + r;
    Ar(e, c), l < n ? window.requestAnimationFrame(t) : o(e);
  }();
}

function Mr(e, t) {
  var n = e.getBoundingClientRect(),
      o = t.getBoundingClientRect(),
      r = t.offsetHeight / 3;
  o.bottom + r > n.bottom ? Ar(e, Math.min(t.offsetTop + t.clientHeight - e.offsetHeight + r, e.scrollHeight)) : o.top - r < n.top && Ar(e, Math.max(t.offsetTop - r, 0));
}

function Gr() {
  try {
    return document.createEvent("TouchEvent"), !0;
  } catch (e) {
    return !1;
  }
}

var Nr = !1,
    kr = {
  get passive() {
    return Nr = !0;
  }

},
    Tr = "undefined" != typeof window ? window : {};
Tr.addEventListener && Tr.removeEventListener && (Tr.addEventListener("p", br, kr), Tr.removeEventListener("p", br, !1));
var Br = Nr;

function Sr(e) {
  return null != e;
}

function Lr(e, t, n) {
  return e ? t : n;
}

var Pr = ["children", "innerProps"],
    Wr = ["children", "innerProps"];

function Xr(e) {
  var t = e.maxHeight,
      n = e.menuEl,
      o = e.minHeight,
      r = e.placement,
      i = e.shouldScroll,
      l = e.isFixedPosition,
      a = e.controlHeight,
      c = function (e) {
    var t = getComputedStyle(e),
        n = "absolute" === t.position,
        o = /(auto|scroll)/;
    if ("fixed" === t.position) return document.documentElement;

    for (var r = e; r = r.parentElement;) {
      if (t = getComputedStyle(r), (!n || "static" !== t.position) && o.test(t.overflow + t.overflowY + t.overflowX)) return r;
    }

    return document.documentElement;
  }(n),
      s = {
    placement: "bottom",
    maxHeight: t
  };

  if (!n || !n.offsetParent) return s;
  var u,
      d = c.getBoundingClientRect().height,
      g = n.getBoundingClientRect(),
      p = g.bottom,
      f = g.height,
      h = g.top,
      m = n.offsetParent.getBoundingClientRect().top,
      b = l ? window.innerHeight : Cr(u = c) ? window.innerHeight : u.clientHeight,
      v = Rr(c),
      y = parseInt(getComputedStyle(n).marginBottom, 10),
      I = parseInt(getComputedStyle(n).marginTop, 10),
      x = m - I,
      w = b - h,
      C = x + v,
      R = d - v - h,
      A = p - b + v + y,
      E = v + h - I,
      M = 160;

  switch (r) {
    case "auto":
    case "bottom":
      if (w >= f) return {
        placement: "bottom",
        maxHeight: t
      };
      if (R >= f && !l) return i && Er(c, A, M), {
        placement: "bottom",
        maxHeight: t
      };
      if (!l && R >= o || l && w >= o) return i && Er(c, A, M), {
        placement: "bottom",
        maxHeight: l ? w - y : R - y
      };

      if ("auto" === r || l) {
        var G = t,
            N = l ? x : C;
        return N >= o && (G = Math.min(N - y - a, t)), {
          placement: "top",
          maxHeight: G
        };
      }

      if ("bottom" === r) return i && Ar(c, A), {
        placement: "bottom",
        maxHeight: t
      };
      break;

    case "top":
      if (x >= f) return {
        placement: "top",
        maxHeight: t
      };
      if (C >= f && !l) return i && Er(c, E, M), {
        placement: "top",
        maxHeight: t
      };

      if (!l && C >= o || l && x >= o) {
        var k = t;
        return (!l && C >= o || l && x >= o) && (k = l ? x - I : C - I), i && Er(c, E, M), {
          placement: "top",
          maxHeight: k
        };
      }

      return {
        placement: "bottom",
        maxHeight: t
      };

    default:
      throw new Error('Invalid placement provided "'.concat(r, '".'));
  }

  return s;
}

var Fr,
    Vr = function Vr(e) {
  return "auto" === e ? "bottom" : e;
},
    Zr = s(null),
    Hr = function Hr(e) {
  var t = e.children,
      o = e.minMenuHeight,
      r = e.maxMenuHeight,
      l = e.menuPlacement,
      a = e.menuPosition,
      s = e.menuShouldScrollIntoView,
      u = e.theme,
      d = (i(Zr) || {}).setPortalPlacement,
      g = c(null),
      p = mt(n(r), 2),
      f = p[0],
      h = p[1],
      m = mt(n(null), 2),
      b = m[0],
      v = m[1],
      y = u.spacing.controlHeight;
  return hr(function () {
    var e = g.current;

    if (e) {
      var t = "fixed" === a,
          n = Xr({
        maxHeight: r,
        menuEl: e,
        minHeight: o,
        placement: l,
        shouldScroll: s && !t,
        isFixedPosition: t,
        controlHeight: y
      });
      h(n.maxHeight), v(n.placement), null == d || d(n.placement);
    }
  }, [r, l, a, s, o, d, y]), t({
    ref: g,
    placerProps: pt(pt({}, e), {}, {
      placement: b || Vr(l),
      maxHeight: f
    })
  });
},
    Or = function Or(e) {
  var t = e.children,
      n = e.innerRef,
      o = e.innerProps;
  return Po("div", yt({}, wr(e, "menu", {
    menu: !0
  }), {
    ref: n
  }, o), t);
},
    Dr = function Dr(e, t) {
  var n = e.theme,
      o = n.spacing.baseUnit,
      r = n.colors;
  return pt({
    textAlign: "center"
  }, t ? {} : {
    color: r.neutral40,
    padding: "".concat(2 * o, "px ").concat(3 * o, "px")
  });
},
    Yr = Dr,
    zr = Dr,
    Jr = ["size"],
    jr = ["innerProps", "isRtl", "size"];

var Ur,
    _r,
    Qr = {
  name: "tj5bde-Svg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;label:Svg;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: function toString() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
  }
},
    Kr = function Kr(e) {
  var t = e.size,
      n = bt(e, Jr);
  return Po("svg", yt({
    height: t,
    width: t,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: Qr
  }, n));
},
    $r = function $r(e) {
  return Po(Kr, yt({
    size: 20
  }, e), Po("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
},
    qr = function qr(e) {
  return Po(Kr, yt({
    size: 20
  }, e), Po("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
},
    ei = function ei(e, t) {
  var n = e.isFocused,
      o = e.theme,
      r = o.spacing.baseUnit,
      i = o.colors;
  return pt({
    label: "indicatorContainer",
    display: "flex",
    transition: "color 150ms"
  }, t ? {} : {
    color: n ? i.neutral60 : i.neutral20,
    padding: 2 * r,
    ":hover": {
      color: n ? i.neutral80 : i.neutral40
    }
  });
},
    ti = ei,
    ni = ei,
    oi = function () {
  var e = Fo.apply(void 0, arguments),
      t = "animation-" + e.name;
  return {
    name: t,
    styles: "@keyframes " + t + "{" + e.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}(Fr || (Ur = ["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"], _r || (_r = Ur.slice(0)), Fr = Object.freeze(Object.defineProperties(Ur, {
  raw: {
    value: Object.freeze(_r)
  }
})))),
    ri = function ri(e) {
  var t = e.delay,
      n = e.offset;
  return Po("span", {
    css: Fo({
      animation: "".concat(oi, " 1s ease-in-out ").concat(t, "ms infinite;"),
      backgroundColor: "currentColor",
      borderRadius: "1em",
      display: "inline-block",
      marginLeft: n ? "1em" : void 0,
      height: "1em",
      verticalAlign: "top",
      width: "1em"
    }, ";label:LoadingDot;", "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  });
},
    ii = function ii(e) {
  var t = e.children,
      n = e.isDisabled,
      o = e.isFocused,
      r = e.innerRef,
      i = e.innerProps,
      l = e.menuIsOpen;
  return Po("div", yt({
    ref: r
  }, wr(e, "control", {
    control: !0,
    "control--is-disabled": n,
    "control--is-focused": o,
    "control--menu-is-open": l
  }), i, {
    "aria-disabled": n || void 0
  }), t);
},
    li = ["data"],
    ai = function ai(e) {
  var t = e.children,
      n = e.cx,
      o = e.getStyles,
      r = e.getClassNames,
      i = e.Heading,
      l = e.headingProps,
      a = e.innerProps,
      c = e.label,
      s = e.theme,
      u = e.selectProps;
  return Po("div", yt({}, wr(e, "group", {
    group: !0
  }), a), Po(i, yt({}, l, {
    selectProps: u,
    theme: s,
    getStyles: o,
    getClassNames: r,
    cx: n
  }), c), Po("div", null, t));
},
    ci = ["innerRef", "isDisabled", "isHidden", "inputClassName"],
    si = {
  gridArea: "1 / 2",
  font: "inherit",
  minWidth: "2px",
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
},
    ui = {
  flex: "1 1 auto",
  display: "inline-grid",
  gridArea: "1 / 1 / 2 / 3",
  gridTemplateColumns: "0 min-content",
  "&:after": pt({
    content: 'attr(data-value) " "',
    visibility: "hidden",
    whiteSpace: "pre"
  }, si)
},
    di = function di(e) {
  return pt({
    label: "input",
    color: "inherit",
    background: 0,
    opacity: e ? 0 : 1,
    width: "100%"
  }, si);
},
    gi = function gi(e) {
  var t = e.children,
      n = e.innerProps;
  return Po("div", n, t);
};

var pi = function pi(e) {
  var t = e.children,
      n = e.components,
      o = e.data,
      r = e.innerProps,
      i = e.isDisabled,
      l = e.removeProps,
      a = e.selectProps,
      c = n.Container,
      s = n.Label,
      u = n.Remove;
  return Po(c, {
    data: o,
    innerProps: pt(pt({}, wr(e, "multiValue", {
      "multi-value": !0,
      "multi-value--is-disabled": i
    })), r),
    selectProps: a
  }, Po(s, {
    data: o,
    innerProps: pt({}, wr(e, "multiValueLabel", {
      "multi-value__label": !0
    })),
    selectProps: a
  }, t), Po(u, {
    data: o,
    innerProps: pt(pt({}, wr(e, "multiValueRemove", {
      "multi-value__remove": !0
    })), {}, {
      "aria-label": "Remove ".concat(t || "option")
    }, l),
    selectProps: a
  }));
},
    fi = {
  ClearIndicator: function ClearIndicator(e) {
    var t = e.children,
        n = e.innerProps;
    return Po("div", yt({}, wr(e, "clearIndicator", {
      indicator: !0,
      "clear-indicator": !0
    }), n), t || Po($r, null));
  },
  Control: ii,
  DropdownIndicator: function DropdownIndicator(e) {
    var t = e.children,
        n = e.innerProps;
    return Po("div", yt({}, wr(e, "dropdownIndicator", {
      indicator: !0,
      "dropdown-indicator": !0
    }), n), t || Po(qr, null));
  },
  DownChevron: qr,
  CrossIcon: $r,
  Group: ai,
  GroupHeading: function GroupHeading(e) {
    var t = xr(e);
    t.data;
    var n = bt(t, li);
    return Po("div", yt({}, wr(e, "groupHeading", {
      "group-heading": !0
    }), n));
  },
  IndicatorsContainer: function IndicatorsContainer(e) {
    var t = e.children,
        n = e.innerProps;
    return Po("div", yt({}, wr(e, "indicatorsContainer", {
      indicators: !0
    }), n), t);
  },
  IndicatorSeparator: function IndicatorSeparator(e) {
    var t = e.innerProps;
    return Po("span", yt({}, t, wr(e, "indicatorSeparator", {
      "indicator-separator": !0
    })));
  },
  Input: function Input(e) {
    var t = e.cx,
        n = e.value,
        o = xr(e),
        r = o.innerRef,
        i = o.isDisabled,
        l = o.isHidden,
        a = o.inputClassName,
        c = bt(o, ci);
    return Po("div", yt({}, wr(e, "input", {
      "input-container": !0
    }), {
      "data-value": n || ""
    }), Po("input", yt({
      className: t({
        input: !0
      }, a),
      ref: r,
      style: di(l),
      disabled: i
    }, c)));
  },
  LoadingIndicator: function LoadingIndicator(e) {
    var t = e.innerProps,
        n = e.isRtl,
        o = e.size,
        r = void 0 === o ? 4 : o,
        i = bt(e, jr);
    return Po("div", yt({}, wr(pt(pt({}, i), {}, {
      innerProps: t,
      isRtl: n,
      size: r
    }), "loadingIndicator", {
      indicator: !0,
      "loading-indicator": !0
    }), t), Po(ri, {
      delay: 0,
      offset: n
    }), Po(ri, {
      delay: 160,
      offset: !0
    }), Po(ri, {
      delay: 320,
      offset: !n
    }));
  },
  Menu: Or,
  MenuList: function MenuList(e) {
    var t = e.children,
        n = e.innerProps,
        o = e.innerRef,
        r = e.isMulti;
    return Po("div", yt({}, wr(e, "menuList", {
      "menu-list": !0,
      "menu-list--is-multi": r
    }), {
      ref: o
    }, n), t);
  },
  MenuPortal: function MenuPortal(e) {
    var t = e.appendTo,
        r = e.children,
        i = e.controlElement,
        l = e.innerProps,
        a = e.menuPlacement,
        s = e.menuPosition,
        d = c(null),
        g = c(null),
        f = mt(n(Vr(a)), 2),
        h = f[0],
        m = f[1],
        b = u(function () {
      return {
        setPortalPlacement: m
      };
    }, []),
        v = mt(n(null), 2),
        y = v[0],
        I = v[1],
        x = o(function () {
      if (i) {
        var e = function (e) {
          var t = e.getBoundingClientRect();
          return {
            bottom: t.bottom,
            height: t.height,
            left: t.left,
            right: t.right,
            top: t.top,
            width: t.width
          };
        }(i),
            t = "fixed" === s ? 0 : window.pageYOffset,
            n = e[h] + t;

        n === (null == y ? void 0 : y.offset) && e.left === (null == y ? void 0 : y.rect.left) && e.width === (null == y ? void 0 : y.rect.width) || I({
          offset: n,
          rect: e
        });
      }
    }, [i, s, h, null == y ? void 0 : y.offset, null == y ? void 0 : y.rect.left, null == y ? void 0 : y.rect.width]);
    hr(function () {
      x();
    }, [x]);
    var w = o(function () {
      "function" == typeof g.current && (g.current(), g.current = null), i && d.current && (g.current = fr(i, d.current, x, {
        elementResize: "ResizeObserver" in window
      }));
    }, [i, x]);
    hr(function () {
      w();
    }, [w]);
    var C = o(function (e) {
      d.current = e, w();
    }, [w]);
    if (!t && "fixed" !== s || !y) return null;
    var R = Po("div", yt({
      ref: C
    }, wr(pt(pt({}, e), {}, {
      offset: y.offset,
      position: s,
      rect: y.rect
    }), "menuPortal", {
      "menu-portal": !0
    }), l), r);
    return Po(Zr.Provider, {
      value: b
    }, t ? p(R, t) : R);
  },
  LoadingMessage: function LoadingMessage(e) {
    var t = e.children,
        n = void 0 === t ? "Loading..." : t,
        o = e.innerProps,
        r = bt(e, Wr);
    return Po("div", yt({}, wr(pt(pt({}, r), {}, {
      children: n,
      innerProps: o
    }), "loadingMessage", {
      "menu-notice": !0,
      "menu-notice--loading": !0
    }), o), n);
  },
  NoOptionsMessage: function NoOptionsMessage(e) {
    var t = e.children,
        n = void 0 === t ? "No options" : t,
        o = e.innerProps,
        r = bt(e, Pr);
    return Po("div", yt({}, wr(pt(pt({}, r), {}, {
      children: n,
      innerProps: o
    }), "noOptionsMessage", {
      "menu-notice": !0,
      "menu-notice--no-options": !0
    }), o), n);
  },
  MultiValue: pi,
  MultiValueContainer: gi,
  MultiValueLabel: gi,
  MultiValueRemove: function MultiValueRemove(e) {
    var t = e.children,
        n = e.innerProps;
    return Po("div", yt({
      role: "button"
    }, n), t || Po($r, {
      size: 14
    }));
  },
  Option: function Option(e) {
    var t = e.children,
        n = e.isDisabled,
        o = e.isFocused,
        r = e.isSelected,
        i = e.innerRef,
        l = e.innerProps;
    return Po("div", yt({}, wr(e, "option", {
      option: !0,
      "option--is-disabled": n,
      "option--is-focused": o,
      "option--is-selected": r
    }), {
      ref: i,
      "aria-disabled": n
    }, l), t);
  },
  Placeholder: function Placeholder(e) {
    var t = e.children,
        n = e.innerProps;
    return Po("div", yt({}, wr(e, "placeholder", {
      placeholder: !0
    }), n), t);
  },
  SelectContainer: function SelectContainer(e) {
    var t = e.children,
        n = e.innerProps,
        o = e.isDisabled,
        r = e.isRtl;
    return Po("div", yt({}, wr(e, "container", {
      "--is-disabled": o,
      "--is-rtl": r
    }), n), t);
  },
  SingleValue: function SingleValue(e) {
    var t = e.children,
        n = e.isDisabled,
        o = e.innerProps;
    return Po("div", yt({}, wr(e, "singleValue", {
      "single-value": !0,
      "single-value--is-disabled": n
    }), o), t);
  },
  ValueContainer: function ValueContainer(e) {
    var t = e.children,
        n = e.innerProps,
        o = e.isMulti,
        r = e.hasValue;
    return Po("div", yt({}, wr(e, "valueContainer", {
      "value-container": !0,
      "value-container--is-multi": o,
      "value-container--has-value": r
    }), n), t);
  }
},
    hi = Number.isNaN || function (e) {
  return "number" == typeof e && e != e;
};

function mi(e, t) {
  if (e.length !== t.length) return !1;

  for (var n = 0; n < e.length; n++) {
    if (o = e[n], r = t[n], !(o === r || hi(o) && hi(r))) return !1;
  }

  var o, r;
  return !0;
}

for (var bi = {
  name: "1f43avz-a11yText-A11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;label:A11yText;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNSSIsImZpbGUiOiJBMTF5VGV4dC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuLy8gQXNzaXN0aXZlIHRleHQgdG8gZGVzY3JpYmUgdmlzdWFsIGVsZW1lbnRzLiBIaWRkZW4gZm9yIHNpZ2h0ZWQgdXNlcnMuXG5jb25zdCBBMTF5VGV4dCA9IChwcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ10pID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAnYTExeVRleHQnLFxuICAgICAgekluZGV4OiA5OTk5LFxuICAgICAgYm9yZGVyOiAwLFxuICAgICAgY2xpcDogJ3JlY3QoMXB4LCAxcHgsIDFweCwgMXB4KScsXG4gICAgICBoZWlnaHQ6IDEsXG4gICAgICB3aWR0aDogMSxcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgICAgcGFkZGluZzogMCxcbiAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQTExeVRleHQ7XG4iXX0= */",
  toString: function toString() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
  }
}, yi = function yi(e) {
  return Po("span", yt({
    css: bi
  }, e));
}, Ii = {
  guidance: function guidance(e) {
    var t = e.isSearchable,
        n = e.isMulti,
        o = e.tabSelectsValue,
        r = e.context,
        i = e.isInitialFocus;

    switch (r) {
      case "menu":
        return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(o ? ", press Tab to select the option and exit the menu" : "", ".");

      case "input":
        return i ? "".concat(e["aria-label"] || "Select", " is focused ").concat(t ? ",type to refine list" : "", ", press Down to open the menu, ").concat(n ? " press left to focus selected values" : "") : "";

      case "value":
        return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";

      default:
        return "";
    }
  },
  onChange: function onChange(e) {
    var t = e.action,
        n = e.label,
        o = void 0 === n ? "" : n,
        r = e.labels,
        i = e.isDisabled;

    switch (t) {
      case "deselect-option":
      case "pop-value":
      case "remove-value":
        return "option ".concat(o, ", deselected.");

      case "clear":
        return "All selected options have been cleared.";

      case "initial-input-focus":
        return "option".concat(r.length > 1 ? "s" : "", " ").concat(r.join(","), ", selected.");

      case "select-option":
        return "option ".concat(o, i ? " is disabled. Select another option." : ", selected.");

      default:
        return "";
    }
  },
  onFocus: function onFocus(e) {
    var t = e.context,
        n = e.focused,
        o = e.options,
        r = e.label,
        i = void 0 === r ? "" : r,
        l = e.selectValue,
        a = e.isDisabled,
        c = e.isSelected,
        s = e.isAppleDevice,
        u = function u(e, t) {
      return e && e.length ? "".concat(e.indexOf(t) + 1, " of ").concat(e.length) : "";
    };

    if ("value" === t && l) return "value ".concat(i, " focused, ").concat(u(l, n), ".");

    if ("menu" === t && s) {
      var d = a ? " disabled" : "",
          g = "".concat(c ? " selected" : "").concat(d);
      return "".concat(i).concat(g, ", ").concat(u(o, n), ".");
    }

    return "";
  },
  onFilter: function onFilter(e) {
    var t = e.inputValue,
        n = e.resultsMessage;
    return "".concat(n).concat(t ? " for search term " + t : "", ".");
  }
}, xi = function xi(e) {
  var t = e.ariaSelection,
      n = e.focusedOption,
      o = e.focusedValue,
      r = e.focusableOptions,
      i = e.isFocused,
      l = e.selectValue,
      a = e.selectProps,
      c = e.id,
      s = e.isAppleDevice,
      d = a.ariaLiveMessages,
      p = a.getOptionLabel,
      f = a.inputValue,
      h = a.isMulti,
      m = a.isOptionDisabled,
      b = a.isSearchable,
      v = a.menuIsOpen,
      y = a.options,
      I = a.screenReaderStatus,
      x = a.tabSelectsValue,
      w = a.isLoading,
      C = a["aria-label"],
      R = a["aria-live"],
      A = u(function () {
    return pt(pt({}, Ii), d || {});
  }, [d]),
      E = u(function () {
    var e,
        n = "";

    if (t && A.onChange) {
      var o = t.option,
          r = t.options,
          i = t.removedValue,
          a = t.removedValues,
          c = t.value,
          s = i || o || (e = c, Array.isArray(e) ? null : e),
          u = s ? p(s) : "",
          d = r || a || void 0,
          g = d ? d.map(p) : [],
          f = pt({
        isDisabled: s && m(s, l),
        label: u,
        labels: g
      }, t);
      n = A.onChange(f);
    }

    return n;
  }, [t, A, m, l, p]),
      M = u(function () {
    var e = "",
        t = n || o,
        i = !!(n && l && l.includes(n));

    if (t && A.onFocus) {
      var a = {
        focused: t,
        label: p(t),
        isDisabled: m(t, l),
        isSelected: i,
        options: r,
        context: t === n ? "menu" : "value",
        selectValue: l,
        isAppleDevice: s
      };
      e = A.onFocus(a);
    }

    return e;
  }, [n, o, p, m, A, r, l, s]),
      G = u(function () {
    var e = "";

    if (v && y.length && !w && A.onFilter) {
      var t = I({
        count: r.length
      });
      e = A.onFilter({
        inputValue: f,
        resultsMessage: t
      });
    }

    return e;
  }, [r, f, v, A, y, I, w]),
      N = "initial-input-focus" === (null == t ? void 0 : t.action),
      k = u(function () {
    var e = "";

    if (A.guidance) {
      var t = o ? "value" : v ? "menu" : "input";
      e = A.guidance({
        "aria-label": C,
        context: t,
        isDisabled: n && m(n, l),
        isMulti: h,
        isSearchable: b,
        tabSelectsValue: x,
        isInitialFocus: N
      });
    }

    return e;
  }, [C, n, o, h, m, b, v, A, l, x, N]),
      T = Po(g, null, Po("span", {
    id: "aria-selection"
  }, E), Po("span", {
    id: "aria-focused"
  }, M), Po("span", {
    id: "aria-results"
  }, G), Po("span", {
    id: "aria-guidance"
  }, k));
  return Po(g, null, Po(yi, {
    id: c
  }, N && T), Po(yi, {
    "aria-live": R,
    "aria-atomic": "false",
    "aria-relevant": "additions text",
    role: "log"
  }, i && !N && T));
}, wi = [{
  base: "A",
  letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
}, {
  base: "AA",
  letters: "Ꜳ"
}, {
  base: "AE",
  letters: "ÆǼǢ"
}, {
  base: "AO",
  letters: "Ꜵ"
}, {
  base: "AU",
  letters: "Ꜷ"
}, {
  base: "AV",
  letters: "ꜸꜺ"
}, {
  base: "AY",
  letters: "Ꜽ"
}, {
  base: "B",
  letters: "BⒷＢḂḄḆɃƂƁ"
}, {
  base: "C",
  letters: "CⒸＣĆĈĊČÇḈƇȻꜾ"
}, {
  base: "D",
  letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ"
}, {
  base: "DZ",
  letters: "ǱǄ"
}, {
  base: "Dz",
  letters: "ǲǅ"
}, {
  base: "E",
  letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ"
}, {
  base: "F",
  letters: "FⒻＦḞƑꝻ"
}, {
  base: "G",
  letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ"
}, {
  base: "H",
  letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
}, {
  base: "I",
  letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
}, {
  base: "J",
  letters: "JⒿＪĴɈ"
}, {
  base: "K",
  letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
}, {
  base: "L",
  letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
}, {
  base: "LJ",
  letters: "Ǉ"
}, {
  base: "Lj",
  letters: "ǈ"
}, {
  base: "M",
  letters: "MⓂＭḾṀṂⱮƜ"
}, {
  base: "N",
  letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ"
}, {
  base: "NJ",
  letters: "Ǌ"
}, {
  base: "Nj",
  letters: "ǋ"
}, {
  base: "O",
  letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
}, {
  base: "OI",
  letters: "Ƣ"
}, {
  base: "OO",
  letters: "Ꝏ"
}, {
  base: "OU",
  letters: "Ȣ"
}, {
  base: "P",
  letters: "PⓅＰṔṖƤⱣꝐꝒꝔ"
}, {
  base: "Q",
  letters: "QⓆＱꝖꝘɊ"
}, {
  base: "R",
  letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
}, {
  base: "S",
  letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
}, {
  base: "T",
  letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
}, {
  base: "TZ",
  letters: "Ꜩ"
}, {
  base: "U",
  letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
}, {
  base: "V",
  letters: "VⓋＶṼṾƲꝞɅ"
}, {
  base: "VY",
  letters: "Ꝡ"
}, {
  base: "W",
  letters: "WⓌＷẀẂŴẆẄẈⱲ"
}, {
  base: "X",
  letters: "XⓍＸẊẌ"
}, {
  base: "Y",
  letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
}, {
  base: "Z",
  letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
}, {
  base: "a",
  letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ"
}, {
  base: "aa",
  letters: "ꜳ"
}, {
  base: "ae",
  letters: "æǽǣ"
}, {
  base: "ao",
  letters: "ꜵ"
}, {
  base: "au",
  letters: "ꜷ"
}, {
  base: "av",
  letters: "ꜹꜻ"
}, {
  base: "ay",
  letters: "ꜽ"
}, {
  base: "b",
  letters: "bⓑｂḃḅḇƀƃɓ"
}, {
  base: "c",
  letters: "cⓒｃćĉċčçḉƈȼꜿↄ"
}, {
  base: "d",
  letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ"
}, {
  base: "dz",
  letters: "ǳǆ"
}, {
  base: "e",
  letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ"
}, {
  base: "f",
  letters: "fⓕｆḟƒꝼ"
}, {
  base: "g",
  letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ"
}, {
  base: "h",
  letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
}, {
  base: "hv",
  letters: "ƕ"
}, {
  base: "i",
  letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
}, {
  base: "j",
  letters: "jⓙｊĵǰɉ"
}, {
  base: "k",
  letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
}, {
  base: "l",
  letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ"
}, {
  base: "lj",
  letters: "ǉ"
}, {
  base: "m",
  letters: "mⓜｍḿṁṃɱɯ"
}, {
  base: "n",
  letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ"
}, {
  base: "nj",
  letters: "ǌ"
}, {
  base: "o",
  letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ"
}, {
  base: "oi",
  letters: "ƣ"
}, {
  base: "ou",
  letters: "ȣ"
}, {
  base: "oo",
  letters: "ꝏ"
}, {
  base: "p",
  letters: "pⓟｐṕṗƥᵽꝑꝓꝕ"
}, {
  base: "q",
  letters: "qⓠｑɋꝗꝙ"
}, {
  base: "r",
  letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
}, {
  base: "s",
  letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ"
}, {
  base: "t",
  letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
}, {
  base: "tz",
  letters: "ꜩ"
}, {
  base: "u",
  letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
}, {
  base: "v",
  letters: "vⓥｖṽṿʋꝟʌ"
}, {
  base: "vy",
  letters: "ꝡ"
}, {
  base: "w",
  letters: "wⓦｗẁẃŵẇẅẘẉⱳ"
}, {
  base: "x",
  letters: "xⓧｘẋẍ"
}, {
  base: "y",
  letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
}, {
  base: "z",
  letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ"
}], Ci = new RegExp("[" + wi.map(function (e) {
  return e.letters;
}).join("") + "]", "g"), Ri = {}, Ai = 0; Ai < wi.length; Ai++) {
  for (var Ei = wi[Ai], Mi = 0; Mi < Ei.letters.length; Mi++) {
    Ri[Ei.letters[Mi]] = Ei.base;
  }
}

var Gi = function Gi(e) {
  return e.replace(Ci, function (e) {
    return Ri[e];
  });
},
    Ni = function (e, t) {
  void 0 === t && (t = mi);
  var n = null;

  function o() {
    for (var o = [], r = 0; r < arguments.length; r++) {
      o[r] = arguments[r];
    }

    if (n && n.lastThis === this && t(o, n.lastArgs)) return n.lastResult;
    var i = e.apply(this, o);
    return n = {
      lastResult: i,
      lastArgs: o,
      lastThis: this
    }, i;
  }

  return o.clear = function () {
    n = null;
  }, o;
}(Gi),
    ki = function ki(e) {
  return e.replace(/^\s+|\s+$/g, "");
},
    Ti = function Ti(e) {
  return "".concat(e.label, " ").concat(e.value);
},
    Bi = ["innerRef"];

function Si(e) {
  var t = e.innerRef,
      n = function (e) {
    for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++) {
      n[o - 1] = arguments[o];
    }

    var r = Object.entries(e).filter(function (e) {
      var t = mt(e, 1)[0];
      return !n.includes(t);
    });
    return r.reduce(function (e, t) {
      var n = mt(t, 2),
          o = n[0],
          r = n[1];
      return e[o] = r, e;
    }, {});
  }(bt(e, Bi), "onExited", "in", "enter", "exit", "appear");

  return Po("input", yt({
    ref: t
  }, n, {
    css: Fo({
      label: "dummyInput",
      background: 0,
      border: 0,
      caretColor: "transparent",
      fontSize: "inherit",
      gridArea: "1 / 1 / 2 / 3",
      outline: 0,
      padding: 0,
      width: 1,
      color: "transparent",
      left: -100,
      opacity: 0,
      position: "relative",
      transform: "scale(.01)"
    }, ";label:DummyInput;", "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlCTSIsImZpbGUiOiJEdW1teUlucHV0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgcmVtb3ZlUHJvcHMgfSBmcm9tICcuLi91dGlscyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIER1bW15SW5wdXQoe1xuICBpbm5lclJlZixcbiAgLi4ucHJvcHNcbn06IEpTWC5JbnRyaW5zaWNFbGVtZW50c1snaW5wdXQnXSAmIHtcbiAgcmVhZG9ubHkgaW5uZXJSZWY6IFJlZjxIVE1MSW5wdXRFbGVtZW50Pjtcbn0pIHtcbiAgLy8gUmVtb3ZlIGFuaW1hdGlvbiBwcm9wcyBub3QgbWVhbnQgZm9yIEhUTUwgZWxlbWVudHNcbiAgY29uc3QgZmlsdGVyZWRQcm9wcyA9IHJlbW92ZVByb3BzKFxuICAgIHByb3BzLFxuICAgICdvbkV4aXRlZCcsXG4gICAgJ2luJyxcbiAgICAnZW50ZXInLFxuICAgICdleGl0JyxcbiAgICAnYXBwZWFyJ1xuICApO1xuXG4gIHJldHVybiAoXG4gICAgPGlucHV0XG4gICAgICByZWY9e2lubmVyUmVmfVxuICAgICAgey4uLmZpbHRlcmVkUHJvcHN9XG4gICAgICBjc3M9e3tcbiAgICAgICAgbGFiZWw6ICdkdW1teUlucHV0JyxcbiAgICAgICAgLy8gZ2V0IHJpZCBvZiBhbnkgZGVmYXVsdCBzdHlsZXNcbiAgICAgICAgYmFja2dyb3VuZDogMCxcbiAgICAgICAgYm9yZGVyOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHRoaXMgaGlkZXMgdGhlIGZsYXNoaW5nIGN1cnNvclxuICAgICAgICBjYXJldENvbG9yOiAndHJhbnNwYXJlbnQnLFxuICAgICAgICBmb250U2l6ZTogJ2luaGVyaXQnLFxuICAgICAgICBncmlkQXJlYTogJzEgLyAxIC8gMiAvIDMnLFxuICAgICAgICBvdXRsaW5lOiAwLFxuICAgICAgICBwYWRkaW5nOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHdpdGhvdXQgYHdpZHRoYCBicm93c2VycyB3b24ndCBhbGxvdyBmb2N1c1xuICAgICAgICB3aWR0aDogMSxcblxuICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIGRlc2t0b3BcbiAgICAgICAgY29sb3I6ICd0cmFuc3BhcmVudCcsXG5cbiAgICAgICAgLy8gcmVtb3ZlIGN1cnNvciBvbiBtb2JpbGUgd2hpbHN0IG1haW50YWluaW5nIFwic2Nyb2xsIGludG8gdmlld1wiIGJlaGF2aW91clxuICAgICAgICBsZWZ0OiAtMTAwLFxuICAgICAgICBvcGFjaXR5OiAwLFxuICAgICAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcbiAgICAgICAgdHJhbnNmb3JtOiAnc2NhbGUoLjAxKScsXG4gICAgICB9fVxuICAgIC8+XG4gICk7XG59XG4iXX0= */")
  }));
}

var Li = function Li(e) {
  e.cancelable && e.preventDefault(), e.stopPropagation();
};

var Pi = ["boxSizing", "height", "overflow", "paddingRight", "position"],
    Wi = {
  boxSizing: "border-box",
  overflow: "hidden",
  position: "relative",
  height: "100%"
};

function Xi(e) {
  e.preventDefault();
}

function Fi(e) {
  e.stopPropagation();
}

function Vi() {
  var e = this.scrollTop,
      t = this.scrollHeight,
      n = e + this.offsetHeight;
  0 === e ? this.scrollTop = 1 : n === t && (this.scrollTop = e - 1);
}

function Zi() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}

var Hi = !("undefined" == typeof window || !window.document || !window.document.createElement),
    Oi = 0,
    Di = {
  capture: !1,
  passive: !1
};

var Yi = function Yi(e) {
  var t = e.target;
  return t.ownerDocument.activeElement && t.ownerDocument.activeElement.blur();
},
    zi = {
  name: "bp8cua-ScrollManager",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;label:ScrollManager;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: function toString() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
  }
};

function Ji(e) {
  var t = e.children,
      n = e.lockEnabled,
      r = e.captureEnabled,
      i = function (e) {
    var t = e.isEnabled,
        n = e.onBottomArrive,
        r = e.onBottomLeave,
        i = e.onTopArrive,
        l = e.onTopLeave,
        s = c(!1),
        u = c(!1),
        d = c(0),
        g = c(null),
        p = o(function (e, t) {
      if (null !== g.current) {
        var o = g.current,
            a = o.scrollTop,
            c = o.scrollHeight,
            d = o.clientHeight,
            p = g.current,
            f = t > 0,
            h = c - d - a,
            m = !1;
        h > t && s.current && (r && r(e), s.current = !1), f && u.current && (l && l(e), u.current = !1), f && t > h ? (n && !s.current && n(e), p.scrollTop = c, m = !0, s.current = !0) : !f && -t > a && (i && !u.current && i(e), p.scrollTop = 0, m = !0, u.current = !0), m && Li(e);
      }
    }, [n, r, i, l]),
        f = o(function (e) {
      p(e, e.deltaY);
    }, [p]),
        h = o(function (e) {
      d.current = e.changedTouches[0].clientY;
    }, []),
        m = o(function (e) {
      var t = d.current - e.changedTouches[0].clientY;
      p(e, t);
    }, [p]),
        b = o(function (e) {
      if (e) {
        var t = !!Br && {
          passive: !1
        };
        e.addEventListener("wheel", f, t), e.addEventListener("touchstart", h, t), e.addEventListener("touchmove", m, t);
      }
    }, [m, h, f]),
        v = o(function (e) {
      e && (e.removeEventListener("wheel", f, !1), e.removeEventListener("touchstart", h, !1), e.removeEventListener("touchmove", m, !1));
    }, [m, h, f]);
    return a(function () {
      if (t) {
        var e = g.current;
        return b(e), function () {
          v(e);
        };
      }
    }, [t, b, v]), function (e) {
      g.current = e;
    };
  }({
    isEnabled: void 0 === r || r,
    onBottomArrive: e.onBottomArrive,
    onBottomLeave: e.onBottomLeave,
    onTopArrive: e.onTopArrive,
    onTopLeave: e.onTopLeave
  }),
      l = function (e) {
    var t = e.isEnabled,
        n = e.accountForScrollbars,
        r = void 0 === n || n,
        i = c({}),
        l = c(null),
        s = o(function (e) {
      if (Hi) {
        var t = document.body,
            n = t && t.style;

        if (r && Pi.forEach(function (e) {
          var t = n && n[e];
          i.current[e] = t;
        }), r && Oi < 1) {
          var o = parseInt(i.current.paddingRight, 10) || 0,
              l = document.body ? document.body.clientWidth : 0,
              a = window.innerWidth - l + o || 0;
          Object.keys(Wi).forEach(function (e) {
            var t = Wi[e];
            n && (n[e] = t);
          }), n && (n.paddingRight = "".concat(a, "px"));
        }

        t && Zi() && (t.addEventListener("touchmove", Xi, Di), e && (e.addEventListener("touchstart", Vi, Di), e.addEventListener("touchmove", Fi, Di))), Oi += 1;
      }
    }, [r]),
        u = o(function (e) {
      if (Hi) {
        var t = document.body,
            n = t && t.style;
        Oi = Math.max(Oi - 1, 0), r && Oi < 1 && Pi.forEach(function (e) {
          var t = i.current[e];
          n && (n[e] = t);
        }), t && Zi() && (t.removeEventListener("touchmove", Xi, Di), e && (e.removeEventListener("touchstart", Vi, Di), e.removeEventListener("touchmove", Fi, Di)));
      }
    }, [r]);
    return a(function () {
      if (t) {
        var e = l.current;
        return s(e), function () {
          u(e);
        };
      }
    }, [t, s, u]), function (e) {
      l.current = e;
    };
  }({
    isEnabled: n
  });

  return Po(g, null, n && Po("div", {
    onClick: Yi,
    css: zi
  }), t(function (e) {
    i(e), l(e);
  }));
}

var ji = {
  name: "5kkxb2-requiredInput-RequiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%;label:RequiredInput;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJlcXVpcmVkSW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWNJIiwiZmlsZSI6IlJlcXVpcmVkSW5wdXQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBGb2N1c0V2ZW50SGFuZGxlciwgRnVuY3Rpb25Db21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmNvbnN0IFJlcXVpcmVkSW5wdXQ6IEZ1bmN0aW9uQ29tcG9uZW50PHtcbiAgcmVhZG9ubHkgbmFtZT86IHN0cmluZztcbiAgcmVhZG9ubHkgb25Gb2N1czogRm9jdXNFdmVudEhhbmRsZXI8SFRNTElucHV0RWxlbWVudD47XG59PiA9ICh7IG5hbWUsIG9uRm9jdXMgfSkgPT4gKFxuICA8aW5wdXRcbiAgICByZXF1aXJlZFxuICAgIG5hbWU9e25hbWV9XG4gICAgdGFiSW5kZXg9ey0xfVxuICAgIGFyaWEtaGlkZGVuPVwidHJ1ZVwiXG4gICAgb25Gb2N1cz17b25Gb2N1c31cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAncmVxdWlyZWRJbnB1dCcsXG4gICAgICBvcGFjaXR5OiAwLFxuICAgICAgcG9pbnRlckV2ZW50czogJ25vbmUnLFxuICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICBib3R0b206IDAsXG4gICAgICBsZWZ0OiAwLFxuICAgICAgcmlnaHQ6IDAsXG4gICAgICB3aWR0aDogJzEwMCUnLFxuICAgIH19XG4gICAgLy8gUHJldmVudCBgU3dpdGNoaW5nIGZyb20gdW5jb250cm9sbGVkIHRvIGNvbnRyb2xsZWRgIGVycm9yXG4gICAgdmFsdWU9XCJcIlxuICAgIG9uQ2hhbmdlPXsoKSA9PiB7fX1cbiAgLz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IFJlcXVpcmVkSW5wdXQ7XG4iXX0= */",
  toString: function toString() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
  }
},
    Ui = function Ui(e) {
  var t = e.name,
      n = e.onFocus;
  return Po("input", {
    required: !0,
    name: t,
    tabIndex: -1,
    "aria-hidden": "true",
    onFocus: n,
    css: ji,
    value: "",
    onChange: function onChange() {}
  });
};

function _i(e) {
  var t;
  return "undefined" != typeof window && null != window.navigator && e.test((null === (t = window.navigator.userAgentData) || void 0 === t ? void 0 : t.platform) || window.navigator.platform);
}

function Qi() {
  return _i(/^Mac/i);
}

function Ki() {
  return _i(/^iPhone/i) || _i(/^iPad/i) || Qi() && navigator.maxTouchPoints > 1;
}

var $i,
    qi = {
  clearIndicator: ni,
  container: function container(e) {
    var t = e.isDisabled;
    return {
      label: "container",
      direction: e.isRtl ? "rtl" : void 0,
      pointerEvents: t ? "none" : void 0,
      position: "relative"
    };
  },
  control: function control(e, t) {
    var n = e.isDisabled,
        o = e.isFocused,
        r = e.theme,
        i = r.colors,
        l = r.borderRadius;
    return pt({
      label: "control",
      alignItems: "center",
      cursor: "default",
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-between",
      minHeight: r.spacing.controlHeight,
      outline: "0 !important",
      position: "relative",
      transition: "all 100ms"
    }, t ? {} : {
      backgroundColor: n ? i.neutral5 : i.neutral0,
      borderColor: n ? i.neutral10 : o ? i.primary : i.neutral20,
      borderRadius: l,
      borderStyle: "solid",
      borderWidth: 1,
      boxShadow: o ? "0 0 0 1px ".concat(i.primary) : void 0,
      "&:hover": {
        borderColor: o ? i.primary : i.neutral30
      }
    });
  },
  dropdownIndicator: ti,
  group: function group(e, t) {
    var n = e.theme.spacing;
    return t ? {} : {
      paddingBottom: 2 * n.baseUnit,
      paddingTop: 2 * n.baseUnit
    };
  },
  groupHeading: function groupHeading(e, t) {
    var n = e.theme,
        o = n.colors,
        r = n.spacing;
    return pt({
      label: "group",
      cursor: "default",
      display: "block"
    }, t ? {} : {
      color: o.neutral40,
      fontSize: "75%",
      fontWeight: 500,
      marginBottom: "0.25em",
      paddingLeft: 3 * r.baseUnit,
      paddingRight: 3 * r.baseUnit,
      textTransform: "uppercase"
    });
  },
  indicatorsContainer: function indicatorsContainer() {
    return {
      alignItems: "center",
      alignSelf: "stretch",
      display: "flex",
      flexShrink: 0
    };
  },
  indicatorSeparator: function indicatorSeparator(e, t) {
    var n = e.isDisabled,
        o = e.theme,
        r = o.spacing.baseUnit,
        i = o.colors;
    return pt({
      label: "indicatorSeparator",
      alignSelf: "stretch",
      width: 1
    }, t ? {} : {
      backgroundColor: n ? i.neutral10 : i.neutral20,
      marginBottom: 2 * r,
      marginTop: 2 * r
    });
  },
  input: function input(e, t) {
    var n = e.isDisabled,
        o = e.value,
        r = e.theme,
        i = r.spacing,
        l = r.colors;
    return pt(pt({
      visibility: n ? "hidden" : "visible",
      transform: o ? "translateZ(0)" : ""
    }, ui), t ? {} : {
      margin: i.baseUnit / 2,
      paddingBottom: i.baseUnit / 2,
      paddingTop: i.baseUnit / 2,
      color: l.neutral80
    });
  },
  loadingIndicator: function loadingIndicator(e, t) {
    var n = e.isFocused,
        o = e.size,
        r = e.theme,
        i = r.colors,
        l = r.spacing.baseUnit;
    return pt({
      label: "loadingIndicator",
      display: "flex",
      transition: "color 150ms",
      alignSelf: "center",
      fontSize: o,
      lineHeight: 1,
      marginRight: o,
      textAlign: "center",
      verticalAlign: "middle"
    }, t ? {} : {
      color: n ? i.neutral60 : i.neutral20,
      padding: 2 * l
    });
  },
  loadingMessage: zr,
  menu: function menu(e, t) {
    var n,
        o = e.placement,
        r = e.theme,
        i = r.borderRadius,
        l = r.spacing,
        a = r.colors;
    return pt((dt(n = {
      label: "menu"
    }, function (e) {
      return e ? {
        bottom: "top",
        top: "bottom"
      }[e] : "bottom";
    }(o), "100%"), dt(n, "position", "absolute"), dt(n, "width", "100%"), dt(n, "zIndex", 1), n), t ? {} : {
      backgroundColor: a.neutral0,
      borderRadius: i,
      boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
      marginBottom: l.menuGutter,
      marginTop: l.menuGutter
    });
  },
  menuList: function menuList(e, t) {
    var n = e.maxHeight,
        o = e.theme.spacing.baseUnit;
    return pt({
      maxHeight: n,
      overflowY: "auto",
      position: "relative",
      WebkitOverflowScrolling: "touch"
    }, t ? {} : {
      paddingBottom: o,
      paddingTop: o
    });
  },
  menuPortal: function menuPortal(e) {
    var t = e.rect,
        n = e.offset,
        o = e.position;
    return {
      left: t.left,
      position: o,
      top: n,
      width: t.width,
      zIndex: 1
    };
  },
  multiValue: function multiValue(e, t) {
    var n = e.theme,
        o = n.spacing,
        r = n.borderRadius,
        i = n.colors;
    return pt({
      label: "multiValue",
      display: "flex",
      minWidth: 0
    }, t ? {} : {
      backgroundColor: i.neutral10,
      borderRadius: r / 2,
      margin: o.baseUnit / 2
    });
  },
  multiValueLabel: function multiValueLabel(e, t) {
    var n = e.theme,
        o = n.borderRadius,
        r = n.colors,
        i = e.cropWithEllipsis;
    return pt({
      overflow: "hidden",
      textOverflow: i || void 0 === i ? "ellipsis" : void 0,
      whiteSpace: "nowrap"
    }, t ? {} : {
      borderRadius: o / 2,
      color: r.neutral80,
      fontSize: "85%",
      padding: 3,
      paddingLeft: 6
    });
  },
  multiValueRemove: function multiValueRemove(e, t) {
    var n = e.theme,
        o = n.spacing,
        r = n.borderRadius,
        i = n.colors,
        l = e.isFocused;
    return pt({
      alignItems: "center",
      display: "flex"
    }, t ? {} : {
      borderRadius: r / 2,
      backgroundColor: l ? i.dangerLight : void 0,
      paddingLeft: o.baseUnit,
      paddingRight: o.baseUnit,
      ":hover": {
        backgroundColor: i.dangerLight,
        color: i.danger
      }
    });
  },
  noOptionsMessage: Yr,
  option: function option(e, t) {
    var n = e.isDisabled,
        o = e.isFocused,
        r = e.isSelected,
        i = e.theme,
        l = i.spacing,
        a = i.colors;
    return pt({
      label: "option",
      cursor: "default",
      display: "block",
      fontSize: "inherit",
      width: "100%",
      userSelect: "none",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
    }, t ? {} : {
      backgroundColor: r ? a.primary : o ? a.primary25 : "transparent",
      color: n ? a.neutral20 : r ? a.neutral0 : "inherit",
      padding: "".concat(2 * l.baseUnit, "px ").concat(3 * l.baseUnit, "px"),
      ":active": {
        backgroundColor: n ? void 0 : r ? a.primary : a.primary50
      }
    });
  },
  placeholder: function placeholder(e, t) {
    var n = e.theme,
        o = n.spacing,
        r = n.colors;
    return pt({
      label: "placeholder",
      gridArea: "1 / 1 / 2 / 3"
    }, t ? {} : {
      color: r.neutral50,
      marginLeft: o.baseUnit / 2,
      marginRight: o.baseUnit / 2
    });
  },
  singleValue: function singleValue(e, t) {
    var n = e.isDisabled,
        o = e.theme,
        r = o.spacing,
        i = o.colors;
    return pt({
      label: "singleValue",
      gridArea: "1 / 1 / 2 / 3",
      maxWidth: "100%",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    }, t ? {} : {
      color: n ? i.neutral40 : i.neutral80,
      marginLeft: r.baseUnit / 2,
      marginRight: r.baseUnit / 2
    });
  },
  valueContainer: function valueContainer(e, t) {
    var n = e.theme.spacing,
        o = e.isMulti,
        r = e.hasValue,
        i = e.selectProps.controlShouldRenderValue;
    return pt({
      alignItems: "center",
      display: o && r && i ? "flex" : "grid",
      flex: 1,
      flexWrap: "wrap",
      WebkitOverflowScrolling: "touch",
      position: "relative",
      overflow: "hidden"
    }, t ? {} : {
      padding: "".concat(n.baseUnit / 2, "px ").concat(2 * n.baseUnit, "px")
    });
  }
},
    el = {
  borderRadius: 4,
  colors: {
    primary: "#2684FF",
    primary75: "#4C9AFF",
    primary50: "#B2D4FF",
    primary25: "#DEEBFF",
    danger: "#DE350B",
    dangerLight: "#FFBDAD",
    neutral0: "hsl(0, 0%, 100%)",
    neutral5: "hsl(0, 0%, 95%)",
    neutral10: "hsl(0, 0%, 90%)",
    neutral20: "hsl(0, 0%, 80%)",
    neutral30: "hsl(0, 0%, 70%)",
    neutral40: "hsl(0, 0%, 60%)",
    neutral50: "hsl(0, 0%, 50%)",
    neutral60: "hsl(0, 0%, 40%)",
    neutral70: "hsl(0, 0%, 30%)",
    neutral80: "hsl(0, 0%, 20%)",
    neutral90: "hsl(0, 0%, 10%)"
  },
  spacing: {
    baseUnit: 4,
    controlHeight: 38,
    menuGutter: 8
  }
},
    tl = {
  "aria-live": "polite",
  backspaceRemovesValue: !0,
  blurInputOnSelect: Gr(),
  captureMenuScroll: !Gr(),
  classNames: {},
  closeMenuOnSelect: !0,
  closeMenuOnScroll: !1,
  components: {},
  controlShouldRenderValue: !0,
  escapeClearsValue: !1,
  filterOption: function filterOption(e, t) {
    if (e.data.__isNew__) return !0;
    var n = pt({
      ignoreCase: !0,
      ignoreAccents: !0,
      stringify: Ti,
      trim: !0,
      matchFrom: "any"
    }, $i),
        o = n.ignoreCase,
        r = n.ignoreAccents,
        i = n.stringify,
        l = n.trim,
        a = n.matchFrom,
        c = l ? ki(t) : t,
        s = l ? ki(i(e)) : i(e);
    return o && (c = c.toLowerCase(), s = s.toLowerCase()), r && (c = Ni(c), s = Gi(s)), "start" === a ? s.substr(0, c.length) === c : s.indexOf(c) > -1;
  },
  formatGroupLabel: function formatGroupLabel(e) {
    return e.label;
  },
  getOptionLabel: function getOptionLabel(e) {
    return e.label;
  },
  getOptionValue: function getOptionValue(e) {
    return e.value;
  },
  isDisabled: !1,
  isLoading: !1,
  isMulti: !1,
  isRtl: !1,
  isSearchable: !0,
  isOptionDisabled: function isOptionDisabled(e) {
    return !!e.isDisabled;
  },
  loadingMessage: function loadingMessage() {
    return "Loading...";
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: !1,
  menuPlacement: "bottom",
  menuPosition: "absolute",
  menuShouldBlockScroll: !1,
  menuShouldScrollIntoView: !function () {
    try {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
      return !1;
    }
  }(),
  noOptionsMessage: function noOptionsMessage() {
    return "No options";
  },
  openMenuOnFocus: !1,
  openMenuOnClick: !0,
  options: [],
  pageSize: 5,
  placeholder: "Select...",
  screenReaderStatus: function screenReaderStatus(e) {
    var t = e.count;
    return "".concat(t, " result").concat(1 !== t ? "s" : "", " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: !0,
  unstyled: !1
};

function nl(e, t, n, o) {
  return {
    type: "option",
    data: t,
    isDisabled: ul(e, t, n),
    isSelected: dl(e, t, n),
    label: cl(e, t),
    value: sl(e, t),
    index: o
  };
}

function ol(e, t) {
  return e.options.map(function (n, o) {
    if ("options" in n) {
      var r = n.options.map(function (n, o) {
        return nl(e, n, t, o);
      }).filter(function (t) {
        return ll(e, t);
      });
      return r.length > 0 ? {
        type: "group",
        data: n,
        options: r,
        index: o
      } : void 0;
    }

    var i = nl(e, n, t, o);
    return ll(e, i) ? i : void 0;
  }).filter(Sr);
}

function rl(e) {
  return e.reduce(function (e, t) {
    return "group" === t.type ? e.push.apply(e, At(t.options.map(function (e) {
      return e.data;
    }))) : e.push(t.data), e;
  }, []);
}

function il(e, t) {
  return e.reduce(function (e, n) {
    return "group" === n.type ? e.push.apply(e, At(n.options.map(function (e) {
      return {
        data: e.data,
        id: "".concat(t, "-").concat(n.index, "-").concat(e.index)
      };
    }))) : e.push({
      data: n.data,
      id: "".concat(t, "-").concat(n.index)
    }), e;
  }, []);
}

function ll(e, t) {
  var n = e.inputValue,
      o = void 0 === n ? "" : n,
      r = t.data,
      i = t.isSelected,
      l = t.label,
      a = t.value;
  return (!pl(e) || !i) && gl(e, {
    label: l,
    value: a,
    data: r
  }, o);
}

var al = function al(e, t) {
  var n;
  return (null === (n = e.find(function (e) {
    return e.data === t;
  })) || void 0 === n ? void 0 : n.id) || null;
},
    cl = function cl(e, t) {
  return e.getOptionLabel(t);
},
    sl = function sl(e, t) {
  return e.getOptionValue(t);
};

function ul(e, t, n) {
  return "function" == typeof e.isOptionDisabled && e.isOptionDisabled(t, n);
}

function dl(e, t, n) {
  if (n.indexOf(t) > -1) return !0;
  if ("function" == typeof e.isOptionSelected) return e.isOptionSelected(t, n);
  var o = sl(e, t);
  return n.some(function (t) {
    return sl(e, t) === o;
  });
}

function gl(e, t, n) {
  return !e.filterOption || e.filterOption(t, n);
}

var pl = function pl(e) {
  var t = e.hideSelectedOptions,
      n = e.isMulti;
  return void 0 === t ? n : t;
},
    fl = 1,
    hl = function (t) {
  !function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), Object.defineProperty(e, "prototype", {
      writable: !1
    }), t && xt(e, t);
  }(c, d);
  var n,
      o,
      r,
      i,
      l,
      a = (n = c, o = Ct(), function () {
    var e,
        t = wt(n);

    if (o) {
      var r = wt(this).constructor;
      e = Reflect.construct(t, arguments, r);
    } else e = t.apply(this, arguments);

    return Rt(this, e);
  });

  function c(e) {
    var t;

    if (function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }(this, c), (t = a.call(this, e)).state = {
      ariaSelection: null,
      focusedOption: null,
      focusedOptionId: null,
      focusableOptionsWithIds: [],
      focusedValue: null,
      inputIsHidden: !1,
      isFocused: !1,
      selectValue: [],
      clearFocusValueOnUpdate: !1,
      prevWasFocused: !1,
      inputIsHiddenAfterUpdate: void 0,
      prevProps: void 0,
      instancePrefix: ""
    }, t.blockOptionHover = !1, t.isComposing = !1, t.commonProps = void 0, t.initialTouchX = 0, t.initialTouchY = 0, t.openAfterFocus = !1, t.scrollToFocusedOptionOnUpdate = !1, t.userIsDragging = void 0, t.isAppleDevice = Qi() || Ki(), t.controlRef = null, t.getControlRef = function (e) {
      t.controlRef = e;
    }, t.focusedOptionRef = null, t.getFocusedOptionRef = function (e) {
      t.focusedOptionRef = e;
    }, t.menuListRef = null, t.getMenuListRef = function (e) {
      t.menuListRef = e;
    }, t.inputRef = null, t.getInputRef = function (e) {
      t.inputRef = e;
    }, t.focus = t.focusInput, t.blur = t.blurInput, t.onChange = function (e, n) {
      var o = t.props,
          r = o.onChange,
          i = o.name;
      n.name = i, t.ariaOnChange(e, n), r(e, n);
    }, t.setValue = function (e, n, o) {
      var r = t.props,
          i = r.closeMenuOnSelect,
          l = r.isMulti,
          a = r.inputValue;
      t.onInputChange("", {
        action: "set-value",
        prevInputValue: a
      }), i && (t.setState({
        inputIsHiddenAfterUpdate: !l
      }), t.onMenuClose()), t.setState({
        clearFocusValueOnUpdate: !0
      }), t.onChange(e, {
        action: n,
        option: o
      });
    }, t.selectOption = function (e) {
      var n = t.props,
          o = n.blurInputOnSelect,
          r = n.isMulti,
          i = n.name,
          l = t.state.selectValue,
          a = r && t.isOptionSelected(e, l),
          c = t.isOptionDisabled(e, l);

      if (a) {
        var s = t.getOptionValue(e);
        t.setValue(l.filter(function (e) {
          return t.getOptionValue(e) !== s;
        }), "deselect-option", e);
      } else {
        if (c) return void t.ariaOnChange(e, {
          action: "select-option",
          option: e,
          name: i
        });
        r ? t.setValue([].concat(At(l), [e]), "select-option", e) : t.setValue(e, "select-option");
      }

      o && t.blurInput();
    }, t.removeValue = function (e) {
      var n = t.props.isMulti,
          o = t.state.selectValue,
          r = t.getOptionValue(e),
          i = o.filter(function (e) {
        return t.getOptionValue(e) !== r;
      }),
          l = Lr(n, i, i[0] || null);
      t.onChange(l, {
        action: "remove-value",
        removedValue: e
      }), t.focusInput();
    }, t.clearValue = function () {
      var e = t.state.selectValue;
      t.onChange(Lr(t.props.isMulti, [], null), {
        action: "clear",
        removedValues: e
      });
    }, t.popValue = function () {
      var e = t.props.isMulti,
          n = t.state.selectValue,
          o = n[n.length - 1],
          r = n.slice(0, n.length - 1),
          i = Lr(e, r, r[0] || null);
      t.onChange(i, {
        action: "pop-value",
        removedValue: o
      });
    }, t.getFocusedOptionId = function (e) {
      return al(t.state.focusableOptionsWithIds, e);
    }, t.getFocusableOptionsWithIds = function () {
      return il(ol(t.props, t.state.selectValue), t.getElementId("option"));
    }, t.getValue = function () {
      return t.state.selectValue;
    }, t.cx = function () {
      for (var e = arguments.length, n = new Array(e), o = 0; o < e; o++) {
        n[o] = arguments[o];
      }

      return yr.apply(void 0, [t.props.classNamePrefix].concat(n));
    }, t.getOptionLabel = function (e) {
      return cl(t.props, e);
    }, t.getOptionValue = function (e) {
      return sl(t.props, e);
    }, t.getStyles = function (e, n) {
      var o = t.props.unstyled,
          r = qi[e](n, o);
      r.boxSizing = "border-box";
      var i = t.props.styles[e];
      return i ? i(r, n) : r;
    }, t.getClassNames = function (e, n) {
      var o, r;
      return null === (o = (r = t.props.classNames)[e]) || void 0 === o ? void 0 : o.call(r, n);
    }, t.getElementId = function (e) {
      return "".concat(t.state.instancePrefix, "-").concat(e);
    }, t.getComponents = function () {
      return e = t.props, pt(pt({}, fi), e.components);
      var e;
    }, t.buildCategorizedOptions = function () {
      return ol(t.props, t.state.selectValue);
    }, t.getCategorizedOptions = function () {
      return t.props.menuIsOpen ? t.buildCategorizedOptions() : [];
    }, t.buildFocusableOptions = function () {
      return rl(t.buildCategorizedOptions());
    }, t.getFocusableOptions = function () {
      return t.props.menuIsOpen ? t.buildFocusableOptions() : [];
    }, t.ariaOnChange = function (e, n) {
      t.setState({
        ariaSelection: pt({
          value: e
        }, n)
      });
    }, t.onMenuMouseDown = function (e) {
      0 === e.button && (e.stopPropagation(), e.preventDefault(), t.focusInput());
    }, t.onMenuMouseMove = function (e) {
      t.blockOptionHover = !1;
    }, t.onControlMouseDown = function (e) {
      if (!e.defaultPrevented) {
        var n = t.props.openMenuOnClick;
        t.state.isFocused ? t.props.menuIsOpen ? "INPUT" !== e.target.tagName && "TEXTAREA" !== e.target.tagName && t.onMenuClose() : n && t.openMenu("first") : (n && (t.openAfterFocus = !0), t.focusInput()), "INPUT" !== e.target.tagName && "TEXTAREA" !== e.target.tagName && e.preventDefault();
      }
    }, t.onDropdownIndicatorMouseDown = function (e) {
      if (!(e && "mousedown" === e.type && 0 !== e.button || t.props.isDisabled)) {
        var n = t.props,
            o = n.isMulti,
            r = n.menuIsOpen;
        t.focusInput(), r ? (t.setState({
          inputIsHiddenAfterUpdate: !o
        }), t.onMenuClose()) : t.openMenu("first"), e.preventDefault();
      }
    }, t.onClearIndicatorMouseDown = function (e) {
      e && "mousedown" === e.type && 0 !== e.button || (t.clearValue(), e.preventDefault(), t.openAfterFocus = !1, "touchend" === e.type ? t.focusInput() : setTimeout(function () {
        return t.focusInput();
      }));
    }, t.onScroll = function (e) {
      "boolean" == typeof t.props.closeMenuOnScroll ? e.target instanceof HTMLElement && Cr(e.target) && t.props.onMenuClose() : "function" == typeof t.props.closeMenuOnScroll && t.props.closeMenuOnScroll(e) && t.props.onMenuClose();
    }, t.onCompositionStart = function () {
      t.isComposing = !0;
    }, t.onCompositionEnd = function () {
      t.isComposing = !1;
    }, t.onTouchStart = function (e) {
      var n = e.touches,
          o = n && n.item(0);
      o && (t.initialTouchX = o.clientX, t.initialTouchY = o.clientY, t.userIsDragging = !1);
    }, t.onTouchMove = function (e) {
      var n = e.touches,
          o = n && n.item(0);

      if (o) {
        var r = Math.abs(o.clientX - t.initialTouchX),
            i = Math.abs(o.clientY - t.initialTouchY);
        t.userIsDragging = r > 5 || i > 5;
      }
    }, t.onTouchEnd = function (e) {
      t.userIsDragging || (t.controlRef && !t.controlRef.contains(e.target) && t.menuListRef && !t.menuListRef.contains(e.target) && t.blurInput(), t.initialTouchX = 0, t.initialTouchY = 0);
    }, t.onControlTouchEnd = function (e) {
      t.userIsDragging || t.onControlMouseDown(e);
    }, t.onClearIndicatorTouchEnd = function (e) {
      t.userIsDragging || t.onClearIndicatorMouseDown(e);
    }, t.onDropdownIndicatorTouchEnd = function (e) {
      t.userIsDragging || t.onDropdownIndicatorMouseDown(e);
    }, t.handleInputChange = function (e) {
      var n = t.props.inputValue,
          o = e.currentTarget.value;
      t.setState({
        inputIsHiddenAfterUpdate: !1
      }), t.onInputChange(o, {
        action: "input-change",
        prevInputValue: n
      }), t.props.menuIsOpen || t.onMenuOpen();
    }, t.onInputFocus = function (e) {
      t.props.onFocus && t.props.onFocus(e), t.setState({
        inputIsHiddenAfterUpdate: !1,
        isFocused: !0
      }), (t.openAfterFocus || t.props.openMenuOnFocus) && t.openMenu("first"), t.openAfterFocus = !1;
    }, t.onInputBlur = function (e) {
      var n = t.props.inputValue;
      t.menuListRef && t.menuListRef.contains(document.activeElement) ? t.inputRef.focus() : (t.props.onBlur && t.props.onBlur(e), t.onInputChange("", {
        action: "input-blur",
        prevInputValue: n
      }), t.onMenuClose(), t.setState({
        focusedValue: null,
        isFocused: !1
      }));
    }, t.onOptionHover = function (e) {
      if (!t.blockOptionHover && t.state.focusedOption !== e) {
        var n = t.getFocusableOptions().indexOf(e);
        t.setState({
          focusedOption: e,
          focusedOptionId: n > -1 ? t.getFocusedOptionId(e) : null
        });
      }
    }, t.shouldHideSelectedOptions = function () {
      return pl(t.props);
    }, t.onValueInputFocus = function (e) {
      e.preventDefault(), e.stopPropagation(), t.focus();
    }, t.onKeyDown = function (e) {
      var n = t.props,
          o = n.isMulti,
          r = n.backspaceRemovesValue,
          i = n.escapeClearsValue,
          l = n.inputValue,
          a = n.isClearable,
          c = n.isDisabled,
          s = n.menuIsOpen,
          u = n.onKeyDown,
          d = n.tabSelectsValue,
          g = n.openMenuOnFocus,
          p = t.state,
          f = p.focusedOption,
          h = p.focusedValue,
          m = p.selectValue;

      if (!(c || "function" == typeof u && (u(e), e.defaultPrevented))) {
        switch (t.blockOptionHover = !0, e.key) {
          case "ArrowLeft":
            if (!o || l) return;
            t.focusValue("previous");
            break;

          case "ArrowRight":
            if (!o || l) return;
            t.focusValue("next");
            break;

          case "Delete":
          case "Backspace":
            if (l) return;
            if (h) t.removeValue(h);else {
              if (!r) return;
              o ? t.popValue() : a && t.clearValue();
            }
            break;

          case "Tab":
            if (t.isComposing) return;
            if (e.shiftKey || !s || !d || !f || g && t.isOptionSelected(f, m)) return;
            t.selectOption(f);
            break;

          case "Enter":
            if (229 === e.keyCode) break;

            if (s) {
              if (!f) return;
              if (t.isComposing) return;
              t.selectOption(f);
              break;
            }

            return;

          case "Escape":
            s ? (t.setState({
              inputIsHiddenAfterUpdate: !1
            }), t.onInputChange("", {
              action: "menu-close",
              prevInputValue: l
            }), t.onMenuClose()) : a && i && t.clearValue();
            break;

          case " ":
            if (l) return;

            if (!s) {
              t.openMenu("first");
              break;
            }

            if (!f) return;
            t.selectOption(f);
            break;

          case "ArrowUp":
            s ? t.focusOption("up") : t.openMenu("last");
            break;

          case "ArrowDown":
            s ? t.focusOption("down") : t.openMenu("first");
            break;

          case "PageUp":
            if (!s) return;
            t.focusOption("pageup");
            break;

          case "PageDown":
            if (!s) return;
            t.focusOption("pagedown");
            break;

          case "Home":
            if (!s) return;
            t.focusOption("first");
            break;

          case "End":
            if (!s) return;
            t.focusOption("last");
            break;

          default:
            return;
        }

        e.preventDefault();
      }
    }, t.state.instancePrefix = "react-select-" + (t.props.instanceId || ++fl), t.state.selectValue = Ir(e.value), e.menuIsOpen && t.state.selectValue.length) {
      var n = t.getFocusableOptionsWithIds(),
          o = t.buildFocusableOptions(),
          r = o.indexOf(t.state.selectValue[0]);
      t.state.focusableOptionsWithIds = n, t.state.focusedOption = o[r], t.state.focusedOptionId = al(n, o[r]);
    }

    return t;
  }

  return r = c, i = [{
    key: "componentDidMount",
    value: function value() {
      this.startListeningComposition(), this.startListeningToTouch(), this.props.closeMenuOnScroll && document && document.addEventListener && document.addEventListener("scroll", this.onScroll, !0), this.props.autoFocus && this.focusInput(), this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef && Mr(this.menuListRef, this.focusedOptionRef);
    }
  }, {
    key: "componentDidUpdate",
    value: function value(e) {
      var t = this.props,
          n = t.isDisabled,
          o = t.menuIsOpen,
          r = this.state.isFocused;
      (r && !n && e.isDisabled || r && o && !e.menuIsOpen) && this.focusInput(), r && n && !e.isDisabled ? this.setState({
        isFocused: !1
      }, this.onMenuClose) : r || n || !e.isDisabled || this.inputRef !== document.activeElement || this.setState({
        isFocused: !0
      }), this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate && (Mr(this.menuListRef, this.focusedOptionRef), this.scrollToFocusedOptionOnUpdate = !1);
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      this.stopListeningComposition(), this.stopListeningToTouch(), document.removeEventListener("scroll", this.onScroll, !0);
    }
  }, {
    key: "onMenuOpen",
    value: function value() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function value() {
      this.onInputChange("", {
        action: "menu-close",
        prevInputValue: this.props.inputValue
      }), this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function value(e, t) {
      this.props.onInputChange(e, t);
    }
  }, {
    key: "focusInput",
    value: function value() {
      this.inputRef && this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function value() {
      this.inputRef && this.inputRef.blur();
    }
  }, {
    key: "openMenu",
    value: function value(e) {
      var t = this,
          n = this.state,
          o = n.selectValue,
          r = n.isFocused,
          i = this.buildFocusableOptions(),
          l = "first" === e ? 0 : i.length - 1;

      if (!this.props.isMulti) {
        var a = i.indexOf(o[0]);
        a > -1 && (l = a);
      }

      this.scrollToFocusedOptionOnUpdate = !(r && this.menuListRef), this.setState({
        inputIsHiddenAfterUpdate: !1,
        focusedValue: null,
        focusedOption: i[l],
        focusedOptionId: this.getFocusedOptionId(i[l])
      }, function () {
        return t.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function value(e) {
      var t = this.state,
          n = t.selectValue,
          o = t.focusedValue;

      if (this.props.isMulti) {
        this.setState({
          focusedOption: null
        });
        var r = n.indexOf(o);
        o || (r = -1);
        var i = n.length - 1,
            l = -1;

        if (n.length) {
          switch (e) {
            case "previous":
              l = 0 === r ? 0 : -1 === r ? i : r - 1;
              break;

            case "next":
              r > -1 && r < i && (l = r + 1);
          }

          this.setState({
            inputIsHidden: -1 !== l,
            focusedValue: n[l]
          });
        }
      }
    }
  }, {
    key: "focusOption",
    value: function value() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "first",
          t = this.props.pageSize,
          n = this.state.focusedOption,
          o = this.getFocusableOptions();

      if (o.length) {
        var r = 0,
            i = o.indexOf(n);
        n || (i = -1), "up" === e ? r = i > 0 ? i - 1 : o.length - 1 : "down" === e ? r = (i + 1) % o.length : "pageup" === e ? (r = i - t) < 0 && (r = 0) : "pagedown" === e ? (r = i + t) > o.length - 1 && (r = o.length - 1) : "last" === e && (r = o.length - 1), this.scrollToFocusedOptionOnUpdate = !0, this.setState({
          focusedOption: o[r],
          focusedValue: null,
          focusedOptionId: this.getFocusedOptionId(o[r])
        });
      }
    }
  }, {
    key: "getTheme",
    value: function value() {
      return this.props.theme ? "function" == typeof this.props.theme ? this.props.theme(el) : pt(pt({}, el), this.props.theme) : el;
    }
  }, {
    key: "getCommonProps",
    value: function value() {
      var e = this.clearValue,
          t = this.cx,
          n = this.getStyles,
          o = this.getClassNames,
          r = this.getValue,
          i = this.selectOption,
          l = this.setValue,
          a = this.props,
          c = a.isMulti,
          s = a.isRtl,
          u = a.options;
      return {
        clearValue: e,
        cx: t,
        getStyles: n,
        getClassNames: o,
        getValue: r,
        hasValue: this.hasValue(),
        isMulti: c,
        isRtl: s,
        options: u,
        selectOption: i,
        selectProps: a,
        setValue: l,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function value() {
      return this.state.selectValue.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function value() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function value() {
      var e = this.props,
          t = e.isClearable,
          n = e.isMulti;
      return void 0 === t ? n : t;
    }
  }, {
    key: "isOptionDisabled",
    value: function value(e, t) {
      return ul(this.props, e, t);
    }
  }, {
    key: "isOptionSelected",
    value: function value(e, t) {
      return dl(this.props, e, t);
    }
  }, {
    key: "filterOption",
    value: function value(e, t) {
      return gl(this.props, e, t);
    }
  }, {
    key: "formatOptionLabel",
    value: function value(e, t) {
      if ("function" == typeof this.props.formatOptionLabel) {
        var n = this.props.inputValue,
            o = this.state.selectValue;
        return this.props.formatOptionLabel(e, {
          context: t,
          inputValue: n,
          selectValue: o
        });
      }

      return this.getOptionLabel(e);
    }
  }, {
    key: "formatGroupLabel",
    value: function value(e) {
      return this.props.formatGroupLabel(e);
    }
  }, {
    key: "startListeningComposition",
    value: function value() {
      document && document.addEventListener && (document.addEventListener("compositionstart", this.onCompositionStart, !1), document.addEventListener("compositionend", this.onCompositionEnd, !1));
    }
  }, {
    key: "stopListeningComposition",
    value: function value() {
      document && document.removeEventListener && (document.removeEventListener("compositionstart", this.onCompositionStart), document.removeEventListener("compositionend", this.onCompositionEnd));
    }
  }, {
    key: "startListeningToTouch",
    value: function value() {
      document && document.addEventListener && (document.addEventListener("touchstart", this.onTouchStart, !1), document.addEventListener("touchmove", this.onTouchMove, !1), document.addEventListener("touchend", this.onTouchEnd, !1));
    }
  }, {
    key: "stopListeningToTouch",
    value: function value() {
      document && document.removeEventListener && (document.removeEventListener("touchstart", this.onTouchStart), document.removeEventListener("touchmove", this.onTouchMove), document.removeEventListener("touchend", this.onTouchEnd));
    }
  }, {
    key: "renderInput",
    value: function value() {
      var t = this.props,
          n = t.isDisabled,
          o = t.isSearchable,
          r = t.inputId,
          i = t.inputValue,
          l = t.tabIndex,
          a = t.form,
          c = t.menuIsOpen,
          s = t.required,
          u = this.getComponents().Input,
          d = this.state,
          g = d.inputIsHidden,
          p = d.ariaSelection,
          f = this.commonProps,
          h = r || this.getElementId("input"),
          m = pt(pt(pt({
        "aria-autocomplete": "list",
        "aria-expanded": c,
        "aria-haspopup": !0,
        "aria-errormessage": this.props["aria-errormessage"],
        "aria-invalid": this.props["aria-invalid"],
        "aria-label": this.props["aria-label"],
        "aria-labelledby": this.props["aria-labelledby"],
        "aria-required": s,
        role: "combobox",
        "aria-activedescendant": this.isAppleDevice ? void 0 : this.state.focusedOptionId || ""
      }, c && {
        "aria-controls": this.getElementId("listbox")
      }), !o && {
        "aria-readonly": !0
      }), this.hasValue() ? "initial-input-focus" === (null == p ? void 0 : p.action) && {
        "aria-describedby": this.getElementId("live-region")
      } : {
        "aria-describedby": this.getElementId("placeholder")
      });
      return o ? e.createElement(u, yt({}, f, {
        autoCapitalize: "none",
        autoComplete: "off",
        autoCorrect: "off",
        id: h,
        innerRef: this.getInputRef,
        isDisabled: n,
        isHidden: g,
        onBlur: this.onInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.onInputFocus,
        spellCheck: "false",
        tabIndex: l,
        form: a,
        type: "text",
        value: i
      }, m)) : e.createElement(Si, yt({
        id: h,
        innerRef: this.getInputRef,
        onBlur: this.onInputBlur,
        onChange: br,
        onFocus: this.onInputFocus,
        disabled: n,
        tabIndex: l,
        inputMode: "none",
        form: a,
        value: ""
      }, m));
    }
  }, {
    key: "renderPlaceholderOrValue",
    value: function value() {
      var t = this,
          n = this.getComponents(),
          o = n.MultiValue,
          r = n.MultiValueContainer,
          i = n.MultiValueLabel,
          l = n.MultiValueRemove,
          a = n.SingleValue,
          c = n.Placeholder,
          s = this.commonProps,
          u = this.props,
          d = u.controlShouldRenderValue,
          g = u.isDisabled,
          p = u.isMulti,
          f = u.inputValue,
          h = u.placeholder,
          m = this.state,
          b = m.selectValue,
          v = m.focusedValue,
          y = m.isFocused;
      if (!this.hasValue() || !d) return f ? null : e.createElement(c, yt({}, s, {
        key: "placeholder",
        isDisabled: g,
        isFocused: y,
        innerProps: {
          id: this.getElementId("placeholder")
        }
      }), h);
      if (p) return b.map(function (n, a) {
        var c = n === v,
            u = "".concat(t.getOptionLabel(n), "-").concat(t.getOptionValue(n));
        return e.createElement(o, yt({}, s, {
          components: {
            Container: r,
            Label: i,
            Remove: l
          },
          isFocused: c,
          isDisabled: g,
          key: u,
          index: a,
          removeProps: {
            onClick: function onClick() {
              return t.removeValue(n);
            },
            onTouchEnd: function onTouchEnd() {
              return t.removeValue(n);
            },
            onMouseDown: function onMouseDown(e) {
              e.preventDefault();
            }
          },
          data: n
        }), t.formatOptionLabel(n, "value"));
      });
      if (f) return null;
      var I = b[0];
      return e.createElement(a, yt({}, s, {
        data: I,
        isDisabled: g
      }), this.formatOptionLabel(I, "value"));
    }
  }, {
    key: "renderClearIndicator",
    value: function value() {
      var t = this.getComponents().ClearIndicator,
          n = this.commonProps,
          o = this.props,
          r = o.isDisabled,
          i = o.isLoading,
          l = this.state.isFocused;
      if (!this.isClearable() || !t || r || !this.hasValue() || i) return null;
      var a = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return e.createElement(t, yt({}, n, {
        innerProps: a,
        isFocused: l
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function value() {
      var t = this.getComponents().LoadingIndicator,
          n = this.commonProps,
          o = this.props,
          r = o.isDisabled,
          i = o.isLoading,
          l = this.state.isFocused;
      return t && i ? e.createElement(t, yt({}, n, {
        innerProps: {
          "aria-hidden": "true"
        },
        isDisabled: r,
        isFocused: l
      })) : null;
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function value() {
      var t = this.getComponents(),
          n = t.DropdownIndicator,
          o = t.IndicatorSeparator;
      if (!n || !o) return null;
      var r = this.commonProps,
          i = this.props.isDisabled,
          l = this.state.isFocused;
      return e.createElement(o, yt({}, r, {
        isDisabled: i,
        isFocused: l
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function value() {
      var t = this.getComponents().DropdownIndicator;
      if (!t) return null;
      var n = this.commonProps,
          o = this.props.isDisabled,
          r = this.state.isFocused,
          i = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return e.createElement(t, yt({}, n, {
        innerProps: i,
        isDisabled: o,
        isFocused: r
      }));
    }
  }, {
    key: "renderMenu",
    value: function value() {
      var t = this,
          n = this.getComponents(),
          o = n.Group,
          r = n.GroupHeading,
          i = n.Menu,
          l = n.MenuList,
          a = n.MenuPortal,
          c = n.LoadingMessage,
          s = n.NoOptionsMessage,
          u = n.Option,
          d = this.commonProps,
          g = this.state.focusedOption,
          p = this.props,
          f = p.captureMenuScroll,
          h = p.inputValue,
          m = p.isLoading,
          b = p.loadingMessage,
          v = p.minMenuHeight,
          y = p.maxMenuHeight,
          I = p.menuIsOpen,
          x = p.menuPlacement,
          w = p.menuPosition,
          C = p.menuPortalTarget,
          R = p.menuShouldBlockScroll,
          A = p.menuShouldScrollIntoView,
          E = p.noOptionsMessage,
          M = p.onMenuScrollToTop,
          G = p.onMenuScrollToBottom;
      if (!I) return null;

      var N,
          k = function k(n, o) {
        var r = n.type,
            i = n.data,
            l = n.isDisabled,
            a = n.isSelected,
            c = n.label,
            s = n.value,
            p = g === i,
            f = l ? void 0 : function () {
          return t.onOptionHover(i);
        },
            h = l ? void 0 : function () {
          return t.selectOption(i);
        },
            m = "".concat(t.getElementId("option"), "-").concat(o),
            b = {
          id: m,
          onClick: h,
          onMouseMove: f,
          onMouseOver: f,
          tabIndex: -1,
          role: "option",
          "aria-selected": t.isAppleDevice ? void 0 : a
        };
        return e.createElement(u, yt({}, d, {
          innerProps: b,
          data: i,
          isDisabled: l,
          isSelected: a,
          key: m,
          label: c,
          type: r,
          value: s,
          isFocused: p,
          innerRef: p ? t.getFocusedOptionRef : void 0
        }), t.formatOptionLabel(n.data, "menu"));
      };

      if (this.hasOptions()) N = this.getCategorizedOptions().map(function (n) {
        if ("group" === n.type) {
          var i = n.data,
              l = n.options,
              a = n.index,
              c = "".concat(t.getElementId("group"), "-").concat(a),
              s = "".concat(c, "-heading");
          return e.createElement(o, yt({}, d, {
            key: c,
            data: i,
            options: l,
            Heading: r,
            headingProps: {
              id: s,
              data: n.data
            },
            label: t.formatGroupLabel(n.data)
          }), n.options.map(function (e) {
            return k(e, "".concat(a, "-").concat(e.index));
          }));
        }

        if ("option" === n.type) return k(n, "".concat(n.index));
      });else if (m) {
        var T = b({
          inputValue: h
        });
        if (null === T) return null;
        N = e.createElement(c, d, T);
      } else {
        var B = E({
          inputValue: h
        });
        if (null === B) return null;
        N = e.createElement(s, d, B);
      }
      var S = {
        minMenuHeight: v,
        maxMenuHeight: y,
        menuPlacement: x,
        menuPosition: w,
        menuShouldScrollIntoView: A
      },
          L = e.createElement(Hr, yt({}, d, S), function (n) {
        var o = n.ref,
            r = n.placerProps,
            a = r.placement,
            c = r.maxHeight;
        return e.createElement(i, yt({}, d, S, {
          innerRef: o,
          innerProps: {
            onMouseDown: t.onMenuMouseDown,
            onMouseMove: t.onMenuMouseMove
          },
          isLoading: m,
          placement: a
        }), e.createElement(Ji, {
          captureEnabled: f,
          onTopArrive: M,
          onBottomArrive: G,
          lockEnabled: R
        }, function (n) {
          return e.createElement(l, yt({}, d, {
            innerRef: function innerRef(e) {
              t.getMenuListRef(e), n(e);
            },
            innerProps: {
              role: "listbox",
              "aria-multiselectable": d.isMulti,
              id: t.getElementId("listbox")
            },
            isLoading: m,
            maxHeight: c,
            focusedOption: g
          }), N);
        }));
      });
      return C || "fixed" === w ? e.createElement(a, yt({}, d, {
        appendTo: C,
        controlElement: this.controlRef,
        menuPlacement: x,
        menuPosition: w
      }), L) : L;
    }
  }, {
    key: "renderFormField",
    value: function value() {
      var t = this,
          n = this.props,
          o = n.delimiter,
          r = n.isDisabled,
          i = n.isMulti,
          l = n.name,
          a = n.required,
          c = this.state.selectValue;
      if (a && !this.hasValue() && !r) return e.createElement(Ui, {
        name: l,
        onFocus: this.onValueInputFocus
      });

      if (l && !r) {
        if (i) {
          if (o) {
            var s = c.map(function (e) {
              return t.getOptionValue(e);
            }).join(o);
            return e.createElement("input", {
              name: l,
              type: "hidden",
              value: s
            });
          }

          var u = c.length > 0 ? c.map(function (n, o) {
            return e.createElement("input", {
              key: "i-".concat(o),
              name: l,
              type: "hidden",
              value: t.getOptionValue(n)
            });
          }) : e.createElement("input", {
            name: l,
            type: "hidden",
            value: ""
          });
          return e.createElement("div", null, u);
        }

        var d = c[0] ? this.getOptionValue(c[0]) : "";
        return e.createElement("input", {
          name: l,
          type: "hidden",
          value: d
        });
      }
    }
  }, {
    key: "renderLiveRegion",
    value: function value() {
      var t = this.commonProps,
          n = this.state,
          o = n.ariaSelection,
          r = n.focusedOption,
          i = n.focusedValue,
          l = n.isFocused,
          a = n.selectValue,
          c = this.getFocusableOptions();
      return e.createElement(xi, yt({}, t, {
        id: this.getElementId("live-region"),
        ariaSelection: o,
        focusedOption: r,
        focusedValue: i,
        isFocused: l,
        selectValue: a,
        focusableOptions: c,
        isAppleDevice: this.isAppleDevice
      }));
    }
  }, {
    key: "render",
    value: function value() {
      var t = this.getComponents(),
          n = t.Control,
          o = t.IndicatorsContainer,
          r = t.SelectContainer,
          i = t.ValueContainer,
          l = this.props,
          a = l.className,
          c = l.id,
          s = l.isDisabled,
          u = l.menuIsOpen,
          d = this.state.isFocused,
          g = this.commonProps = this.getCommonProps();
      return e.createElement(r, yt({}, g, {
        className: a,
        innerProps: {
          id: c,
          onKeyDown: this.onKeyDown
        },
        isDisabled: s,
        isFocused: d
      }), this.renderLiveRegion(), e.createElement(n, yt({}, g, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: s,
        isFocused: d,
        menuIsOpen: u
      }), e.createElement(i, yt({}, g, {
        isDisabled: s
      }), this.renderPlaceholderOrValue(), this.renderInput()), e.createElement(o, yt({}, g, {
        isDisabled: s
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], l = [{
    key: "getDerivedStateFromProps",
    value: function value(e, t) {
      var n = t.prevProps,
          o = t.clearFocusValueOnUpdate,
          r = t.inputIsHiddenAfterUpdate,
          i = t.ariaSelection,
          l = t.isFocused,
          a = t.prevWasFocused,
          c = t.instancePrefix,
          s = e.options,
          u = e.value,
          d = e.menuIsOpen,
          g = e.inputValue,
          p = e.isMulti,
          f = Ir(u),
          h = {};

      if (n && (u !== n.value || s !== n.options || d !== n.menuIsOpen || g !== n.inputValue)) {
        var m = d ? function (e, t) {
          return rl(ol(e, t));
        }(e, f) : [],
            b = d ? il(ol(e, f), "".concat(c, "-option")) : [],
            v = o ? function (e, t) {
          var n = e.focusedValue,
              o = e.selectValue.indexOf(n);

          if (o > -1) {
            if (t.indexOf(n) > -1) return n;
            if (o < t.length) return t[o];
          }

          return null;
        }(t, f) : null,
            y = function (e, t) {
          var n = e.focusedOption;
          return n && t.indexOf(n) > -1 ? n : t[0];
        }(t, m);

        h = {
          selectValue: f,
          focusedOption: y,
          focusedOptionId: al(b, y),
          focusableOptionsWithIds: b,
          focusedValue: v,
          clearFocusValueOnUpdate: !1
        };
      }

      var I = null != r && e !== n ? {
        inputIsHidden: r,
        inputIsHiddenAfterUpdate: void 0
      } : {},
          x = i,
          w = l && a;
      return l && !w && (x = {
        value: Lr(p, f, f[0] || null),
        options: f,
        action: "initial-input-focus"
      }, w = !a), "initial-input-focus" === (null == i ? void 0 : i.action) && (x = null), pt(pt(pt({}, h), I), {}, {
        prevProps: e,
        ariaSelection: x,
        prevWasFocused: w
      });
    }
  }], i && It(r.prototype, i), l && It(r, l), Object.defineProperty(r, "prototype", {
    writable: !1
  }), c;
}();

hl.defaultProps = tl;

var ml = r(function (t, r) {
  var i = function (e) {
    var t = e.defaultInputValue,
        r = void 0 === t ? "" : t,
        i = e.defaultMenuIsOpen,
        l = void 0 !== i && i,
        a = e.defaultValue,
        c = void 0 === a ? null : a,
        s = e.inputValue,
        u = e.menuIsOpen,
        d = e.onChange,
        g = e.onInputChange,
        p = e.onMenuClose,
        f = e.onMenuOpen,
        h = e.value,
        m = bt(e, vt),
        b = mt(n(void 0 !== s ? s : r), 2),
        v = b[0],
        y = b[1],
        I = mt(n(void 0 !== u ? u : l), 2),
        x = I[0],
        w = I[1],
        C = mt(n(void 0 !== h ? h : c), 2),
        R = C[0],
        A = C[1],
        E = o(function (e, t) {
      "function" == typeof d && d(e, t), A(e);
    }, [d]),
        M = o(function (e, t) {
      var n;
      "function" == typeof g && (n = g(e, t)), y(void 0 !== n ? n : e);
    }, [g]),
        G = o(function () {
      "function" == typeof f && f(), w(!0);
    }, [f]),
        N = o(function () {
      "function" == typeof p && p(), w(!1);
    }, [p]),
        k = void 0 !== s ? s : v,
        T = void 0 !== u ? u : x,
        B = void 0 !== h ? h : R;
    return pt(pt({}, m), {}, {
      inputValue: k,
      menuIsOpen: T,
      onChange: E,
      onInputChange: M,
      onMenuClose: N,
      onMenuOpen: G,
      value: B
    });
  }(t);

  return e.createElement(hl, yt({
    ref: r
  }, i));
}),
    bl = ml,
    vl = function () {
  function t() {}

  return t.prototype.getCompatibleCell = function (e) {
    var t;

    try {
      t = Xe(e, "selectedValue", "string");
    } catch (e) {
      t = void 0;
    }

    var n,
        o,
        r = Xe(e, "values", "object"),
        i = t ? parseFloat(t) : NaN,
        l = !0;

    try {
      l = Xe(e, "isDisabled", "boolean");
    } catch (e) {
      l = !1;
    }

    try {
      n = Xe(e, "inputValue", "string");
    } catch (e) {
      n = void 0;
    }

    try {
      o = Xe(e, "isOpen", "boolean");
    } catch (e) {
      o = !1;
    }

    var a = t || "";
    return _C(_C({}, e), {
      selectedValue: t,
      text: a,
      value: i,
      values: r,
      isDisabled: l,
      isOpen: o,
      inputValue: n
    });
  }, t.prototype.update = function (e, t) {
    var n = e.values.some(function (e) {
      return e.value === t.text;
    }) ? t.text : void 0;
    return this.getCompatibleCell(_C(_C({}, e), {
      selectedValue: n,
      isOpen: t.isOpen,
      inputValue: t.inputValue
    }));
  }, t.prototype.getClassName = function (e, t) {
    var n = e.isOpen ? "open" : "closed";
    return "".concat(e.className ? e.className : "").concat(n);
  }, t.prototype.handleKeyDown = function (e, t, n, o, r, i, l) {
    if ((t === S.SPACE || t === S.ENTER) && !o) return {
      cell: this.getCompatibleCell(_C(_C({}, e), {
        isOpen: !e.isOpen
      })),
      enableEditMode: !1
    };
    var a = qe(i, o, l);
    return n || r || !Ve(t) || o && t === S.SPACE ? {
      cell: e,
      enableEditMode: !1
    } : {
      cell: this.getCompatibleCell(_C(_C({}, e), {
        inputValue: a,
        isOpen: !e.isOpen
      })),
      enableEditMode: !1
    };
  }, t.prototype.handleCompositionEnd = function (e, t) {
    return {
      cell: _C(_C({}, e), {
        inputValue: t,
        isOpen: !e.isOpen
      }),
      enableEditMode: !1
    };
  }, t.prototype.render = function (t, n, o) {
    var r = this;
    return e.createElement(yl, {
      onCellChanged: function onCellChanged(e) {
        return o(r.getCompatibleCell(e), !0);
      },
      cell: t
    });
  }, t;
}(),
    yl = function yl(t) {
  var n = t.onCellChanged,
      o = t.cell,
      r = e.useRef(null),
      i = e.useState(o.inputValue),
      l = i[0],
      a = i[1],
      c = e.useMemo(function () {
    return o.values.find(function (e) {
      return e.value === o.text;
    });
  }, [o.text, o.values]);
  return e.useEffect(function () {
    o.isOpen && r.current && (r.current.focus(), a(o.inputValue));
  }, [o.isOpen, o.inputValue]), e.createElement("div", {
    style: {
      width: "100%"
    },
    onPointerDown: function onPointerDown(e) {
      return n(_C(_C({}, o), {
        isOpen: !0
      }));
    }
  }, e.createElement(bl, _C({}, o.inputValue && {
    inputValue: l,
    defaultInputValue: l,
    onInputChange: function onInputChange(e) {
      return a(e);
    }
  }, {
    isSearchable: !0,
    ref: r
  }, void 0 !== o.isOpen && {
    menuIsOpen: o.isOpen
  }, {
    onMenuClose: function onMenuClose() {
      return n(_C(_C({}, o), {
        isOpen: !o.isOpen,
        inputValue: void 0
      }));
    },
    onMenuOpen: function onMenuOpen() {
      return n(_C(_C({}, o), {
        isOpen: !0
      }));
    },
    onChange: function onChange(e) {
      return n(_C(_C({}, o), {
        selectedValue: e.value,
        isOpen: !1,
        inputValue: void 0
      }));
    },
    blurInputOnSelect: !0,
    defaultValue: c,
    value: c,
    isDisabled: o.isDisabled,
    options: o.values,
    onKeyDown: function onKeyDown(e) {
      if (e.stopPropagation(), "Escape" === e.key) return r.current.blur(), n(_C(_C({}, o), {
        isOpen: !1,
        inputValue: void 0
      }));
    },
    components: {
      Option: Il,
      Menu: xl
    },
    styles: {
      container: function container(e) {
        var t;
        return _C(_C(_C({}, e), {
          width: "100%",
          height: "100%"
        }), null === (t = o.styles) || void 0 === t ? void 0 : t.container);
      },
      control: function control(e) {
        var t;
        return _C(_C(_C({}, e), {
          border: "none",
          borderColor: "transparent",
          minHeight: "25px",
          background: "transparent",
          boxShadow: "none"
        }), null === (t = o.styles) || void 0 === t ? void 0 : t.control);
      },
      indicatorsContainer: function indicatorsContainer(e) {
        var t;
        return _C(_C(_C({}, e), {
          paddingTop: "0px"
        }), null === (t = o.styles) || void 0 === t ? void 0 : t.indicatorsContainer);
      },
      dropdownIndicator: function dropdownIndicator(e) {
        var t;
        return _C(_C(_C({}, e), {
          padding: "0px 4px"
        }), null === (t = o.styles) || void 0 === t ? void 0 : t.dropdownIndicator);
      },
      singleValue: function singleValue(e) {
        var t;
        return _C(_C(_C({}, e), {
          color: "inherit"
        }), null === (t = o.styles) || void 0 === t ? void 0 : t.singleValue);
      },
      indicatorSeparator: function indicatorSeparator(e) {
        var t;
        return _C(_C(_C({}, e), {
          marginTop: "4px",
          marginBottom: "4px"
        }), null === (t = o.styles) || void 0 === t ? void 0 : t.indicatorSeparator);
      },
      input: function input(e) {
        var t;
        return _C(_C(_C({}, e), {
          padding: 0
        }), null === (t = o.styles) || void 0 === t ? void 0 : t.input);
      },
      valueContainer: function valueContainer(e) {
        var t;
        return _C(_C(_C({}, e), {
          padding: "0 8px"
        }), null === (t = o.styles) || void 0 === t ? void 0 : t.valueContainer);
      }
    }
  })));
},
    Il = function Il(t) {
  var n = t.innerProps,
      o = t.label,
      r = t.isSelected,
      i = t.isFocused,
      l = t.isDisabled;
  return e.createElement("div", _C({}, n, {
    onPointerDown: function onPointerDown(e) {
      return e.stopPropagation();
    },
    className: "rg-dropdown-option".concat(r ? " selected" : "").concat(i ? " focused" : "").concat(l ? " disabled" : "")
  }), o);
},
    xl = function xl(t) {
  var n = t.innerProps,
      o = t.children;
  return e.createElement("div", _C({}, n, {
    className: "rg-dropdown-menu",
    onPointerDown: function onPointerDown(e) {
      return e.stopPropagation();
    }
  }), o);
},
    wl = {
  text: new at(),
  number: new lt(),
  header: new ot(),
  checkbox: new Fe(),
  date: new et(),
  email: new tt(),
  time: new ct(),
  chevron: new nt(),
  dropdown: new vl()
};

var Cl = function Cl(e) {
  var t = [],
      n = 0;
  return e.forEach(function (o, r) {
    if (e[r - 1]) {
      var i = e[r - 1];
      o.idx - i.idx == 1 ? t[n] ? t[n].push(o) : t.push([i, o]) : (t.push([o]), n += 1);
    } else t.push([o]);
  }), t;
},
    Rl = function Rl(e) {
  var t = [],
      n = 0;
  return e.forEach(function (o, r) {
    if (e[r - 1]) {
      var i = e[r - 1];
      o.idx - i.idx == 1 ? t[n] ? t[n].push(o) : t.push([i, o]) : (t.push([o]), n += 1);
    } else t.push([o]);
  }), t;
};

function Al(e, t) {
  var n = Nl(e);
  Tl(e, t) && (t = n(t)(Vl)), t = n(t)(Bl), t = n(t)(Wl), t = n(t)(Xl);
  var o = kl(e, t);
  return t = n(t)(Le), t = n(t)(Fl), o && (t = n(t)(Sl)), t = n(t)(El), t = n(t)(Ll), o && (t = n(t)(Pl)), t = n(t)(Zl), Gl(e, t) && (t = n(t)(Hl)), t = n(t)(Ml);
}

function El(e, t) {
  return t = "row" === t.selectionMode && t.selectedIds.length > 0 ? function (e) {
    var t = e.cellMatrix.first.column,
        n = e.cellMatrix.last.column,
        o = e.cellMatrix.rows.filter(function (t) {
      return e.selectedIds.includes(t.rowId);
    }).sort(function (e, t) {
      return e.idx - t.idx;
    }),
        r = Cl(o).map(function (o) {
      return e.cellMatrix.getRange(M(o[0], t), M(o[o.length - 1], n));
    }),
        i = e.selectedRanges.length - 1;
    return e.focusedLocation && r.forEach(function (t, n) {
      t.rows.forEach(function (t) {
        var o;
        (null === (o = e.focusedLocation) || void 0 === o ? void 0 : o.row.rowId) === t.rowId && (i = n);
      });
    }), _C(_C({}, e), {
      selectionMode: "row",
      activeSelectedRangeIdx: i,
      selectedRanges: E([], r, !0),
      selectedIndexes: o.map(function (e) {
        return e.idx;
      }),
      selectedIds: o.map(function (e) {
        return e.rowId;
      })
    });
  }(t) : "column" === t.selectionMode && t.selectedIds.length > 0 ? function (e) {
    var t = e.cellMatrix.first.row,
        n = e.cellMatrix.last.row,
        o = e.cellMatrix.columns.filter(function (t) {
      return e.selectedIds.includes(t.columnId);
    }).sort(function (e, t) {
      return e.idx - t.idx;
    }),
        r = Rl(o).map(function (o) {
      return e.cellMatrix.getRange(M(t, o[0]), M(n, o[o.length - 1]));
    }),
        i = e.selectedRanges.length - 1;
    return e.focusedLocation && r.forEach(function (t, n) {
      t.columns.forEach(function (t) {
        var o;
        (null === (o = e.focusedLocation) || void 0 === o ? void 0 : o.column.columnId) === t.columnId && (i = n);
      });
    }), _C(_C({}, e), {
      selectionMode: "column",
      activeSelectedRangeIdx: i,
      selectedRanges: E([], r, !0),
      selectedIndexes: o.map(function (e) {
        return e.idx;
      }),
      selectedIds: o.map(function (e) {
        return e.columnId;
      })
    });
  }(t) : _C(_C({}, t), {
    selectedRanges: E([], t.selectedRanges, !0).map(function (e) {
      return t.cellMatrix.validateRange(e);
    })
  });
}

function Ml(e, t) {
  return _C(_C({}, t), {
    enableFillHandle: !!e.enableFillHandle,
    enableRangeSelection: !!e.enableRangeSelection,
    enableColumnSelection: !!e.enableColumnSelection,
    enableRowSelection: !!e.enableRowSelection
  });
}

var Gl = function Gl(e, t) {
  var n, o, r, i;
  return (null === (n = e.focusLocation) || void 0 === n ? void 0 : n.columnId) !== (null === (o = t.focusedLocation) || void 0 === o ? void 0 : o.column.columnId) || (null === (r = e.focusLocation) || void 0 === r ? void 0 : r.rowId) !== (null === (i = t.focusedLocation) || void 0 === i ? void 0 : i.row.rowId) || void 0 !== e.stickyRightColumns && e.stickyRightColumns !== t.rightStickyColumns || void 0 !== e.stickyBottomRows && e.stickyBottomRows !== t.bottomStickyRows;
},
    Nl = function Nl(e) {
  return function (t) {
    return function (n) {
      return n(e, t);
    };
  };
},
    kl = function kl(e, t) {
  return !t.cellMatrix || e !== t.cellMatrix.props || void 0 !== e.stickyLeftColumns && e.stickyLeftColumns !== t.leftStickyColumns || void 0 !== e.stickyTopRows && e.stickyTopRows !== t.topStickyRows || void 0 !== e.stickyBottomRows && e.stickyBottomRows !== t.bottomStickyRows || void 0 !== e.stickyRightColumns && e.stickyRightColumns !== t.rightStickyColumns;
},
    Tl = function Tl(e, t) {
  var n;
  return e.highlights !== (null === (n = t.props) || void 0 === n ? void 0 : n.highlights);
};

function Bl(e, t) {
  return t.props !== e && (t = _C(_C({}, t), {
    props: e
  })), t;
}

function Sl(e, t) {
  var n = new We();
  return _C(_C({}, t), {
    cellMatrix: n.setProps(e).fillRowsAndCols({
      leftStickyColumns: t.leftStickyColumns || 0,
      topStickyRows: t.topStickyRows || 0,
      rightStickyColumns: t.rightStickyColumns || 0,
      bottomStickyRows: t.bottomStickyRows || 0
    }).setRangesToRenderLookup().fillSticky({
      leftStickyColumns: t.leftStickyColumns || 0,
      topStickyRows: t.topStickyRows || 0,
      rightStickyColumns: t.rightStickyColumns || 0,
      bottomStickyRows: t.bottomStickyRows || 0
    }).fillScrollableRange({
      leftStickyColumns: t.leftStickyColumns || 0,
      topStickyRows: t.topStickyRows || 0,
      rightStickyColumns: t.rightStickyColumns || 0,
      bottomStickyRows: t.bottomStickyRows || 0
    }).setEdgeLocations().getCellMatrix()
  });
}

function Ll(e, t) {
  return t.cellMatrix.columns.length > 0 && t.focusedLocation && !t.currentlyEditedCell && (t = _C(_C({}, t), {
    focusedLocation: t.cellMatrix.validateLocation(t.focusedLocation)
  })), t;
}

function Pl(e, t) {
  return t.visibleRange && (t = Me(t)), t;
}

function Wl(e, t) {
  return _C(_C({}, t), {
    cellTemplates: _C(_C({}, wl), e.customCellTemplates)
  });
}

function Xl(e, t) {
  return _C(_C({}, t), {
    enableGroupIdRender: !!e.enableGroupIdRender
  });
}

function Fl(e, t) {
  return _C(_C({}, t), {
    disableVirtualScrolling: !!e.disableVirtualScrolling
  });
}

function Vl(e, t) {
  var n,
      o,
      r = null === (n = e.highlights) || void 0 === n ? void 0 : n.filter(function (e) {
    return void 0 !== t.cellMatrix.rowIndexLookup[e.rowId] && void 0 !== t.cellMatrix.columnIndexLookup[e.columnId];
  });
  return (null == r ? void 0 : r.length) !== (null === (o = e.highlights) || void 0 === o ? void 0 : o.length) && console.error('Data inconsistency in ReactGrid "highlights" prop'), _C(_C({}, t), {
    highlightLocations: r || []
  });
}

function Zl(e, t) {
  var n = e.initialFocusLocation,
      o = !!t.focusedLocation;
  if (n && !t.focusedLocation) if (Ol(t, n)) console.error('Data inconsistency in ReactGrid "initialFocusLocation" prop');else {
    var r = t.cellMatrix.getLocationById(n.rowId, n.columnId);
    t = X(t, r);
  }
  var i = t.focusedLocation;
  return !o && i && (t = G(t, i)), t;
}

function Hl(e, t) {
  var n = e.focusLocation,
      o = !!t.focusedLocation;
  if (n) if (Ol(t, n)) console.error('Data inconsistency in ReactGrid "focusLocation" prop');else {
    var r = t.cellMatrix.getLocationById(n.rowId, n.columnId);
    t = X(t, r);
  }
  var i = t.focusedLocation;
  return !o && i && e.focusLocation && t.selectedRanges.length <= 1 && (t = G(t, i)), t;
}

function Ol(e, t) {
  return !(void 0 !== e.cellMatrix.columnIndexLookup[t.columnId] && void 0 !== e.cellMatrix.rowIndexLookup[t.rowId]);
}

function Dl(e) {
  return e.cellMatrix.ranges.stickyTopRange.height > 0;
}

function Yl(e) {
  return e.cellMatrix.ranges.stickyLeftRange.width > 0;
}

function zl(e) {
  return !!(e.visibleRange && e.visibleRange.width > 0);
}

function Jl(e) {
  return !!(e.cellMatrix.scrollableRange.height > 0 && e.cellMatrix.scrollableRange.first.column && e.cellMatrix.scrollableRange.first.row && e.cellMatrix.scrollableRange.last.row && e.visibleRange && e.visibleRange.height > 0);
}

function jl(e) {
  return !!(e.cellMatrix.ranges.stickyBottomRange.height > 0 && e.cellMatrix.rows.length > 0);
}

function Ul(e) {
  return !!(e.cellMatrix.ranges.stickyRightRange.width > 0);
}

var _l = s({}),
    Ql = function Ql(e) {
  var n = e.children,
      o = e.state;
  return t.createElement(_l.Provider, {
    value: o
  }, n);
},
    Kl = function Kl() {
  return t.useContext(_l);
},
    $l = function $l(t) {
  var n,
      o,
      r,
      i,
      l,
      a,
      c,
      s,
      u,
      d,
      g,
      p,
      f,
      h,
      m = t.cellRenderer,
      b = Kl(),
      v = b.cellMatrix,
      y = Dl(b),
      I = Jl(b),
      x = Yl(b),
      w = zl(b),
      C = jl(b),
      R = Ul(b);
  if (!(y || I || x || w)) return null;
  var A = void 0,
      E = b.visibleRange;
  I && (A = v.scrollableRange.slice(E, "rows"));
  var M = v.ranges.stickyTopRange.height ? -v.ranges.stickyBottomRange.height : 0,
      G = v.ranges.stickyLeftRange.width ? -v.ranges.stickyRightRange.width : 0,
      N = v.ranges.stickyRightRange.width ? -v.ranges.stickyLeftRange.width : 0,
      k = v.ranges.stickyBottomRange.height ? -v.ranges.stickyTopRange.height : 0,
      T = 0 !== v.scrollableRange.rows.length ? v.ranges.stickyTopRange.height : 0,
      B = 0 !== v.scrollableRange.columns.length ? v.ranges.stickyLeftRange.width : 0,
      S = 0 !== v.scrollableRange.rows.length ? v.ranges.stickyBottomRange.height : 0,
      L = 0 !== v.scrollableRange.columns.length ? v.ranges.stickyRightRange.width : 0;
  return e.createElement(e.Fragment, null, e.createElement(Xc, {
    renderChildren: I && w,
    className: "rg-pane-center-middle",
    style: {
      position: "relative",
      width: "calc(100% - ".concat(v.ranges.stickyLeftRange.width + v.ranges.stickyRightRange.width, "px)"),
      height: v.scrollableRange.height,
      marginLeft: G,
      marginRight: N,
      marginTop: M,
      marginBottom: k,
      order: 4
    }
  }, e.createElement(Fc, {
    state: b,
    range: jc(A)(E),
    borders: {
      bottom: !C,
      right: !R,
      left: !x,
      top: !y
    },
    cellRenderer: m
  })), e.createElement(Zc, {
    renderCondition: x,
    className: "shadow-left",
    zIndex: 2,
    style: {
      width: v.ranges.stickyLeftRange.width,
      height: v.height,
      marginTop: -v.height,
      order: 9
    }
  }), e.createElement(Zc, {
    renderCondition: R,
    className: "shadow-right",
    zIndex: 2,
    style: {
      width: v.ranges.stickyRightRange.width,
      height: v.height,
      marginLeft: -v.ranges.stickyRightRange.width,
      marginTop: y || C ? -v.height : 0,
      order: y || C ? 12 : 8
    }
  }), e.createElement(Zc, {
    renderCondition: y,
    className: "shadow-top",
    zIndex: 1,
    style: {
      width: (null === (n = b.props) || void 0 === n ? void 0 : n.enableFullWidthHeader) ? "calc(100%)" : v.width,
      height: v.ranges.stickyTopRange.height,
      marginTop: -v.height,
      order: 10
    }
  }), e.createElement(Zc, {
    renderCondition: C,
    className: "shadow-bottom",
    zIndex: 1,
    style: {
      width: (null === (o = b.props) || void 0 === o ? void 0 : o.enableFullWidthHeader) ? "calc(100%)" : v.width,
      height: v.ranges.stickyBottomRange.height,
      marginTop: -v.ranges.stickyBottomRange.height,
      order: 11
    }
  }), e.createElement(Xc, {
    renderChildren: w && C,
    className: "rg-pane-bottom",
    style: {
      width: "calc(100% - ".concat(v.ranges.stickyLeftRange.width + v.ranges.stickyRightRange.width, "px)"),
      height: v.ranges.stickyBottomRange.height,
      marginLeft: G,
      marginRight: N,
      marginTop: T,
      order: 7
    }
  }, e.createElement(Fc, {
    state: b,
    range: jc(v.ranges.stickyBottomRange)(E),
    borders: {
      top: !0,
      bottom: !0,
      right: !R,
      left: !x
    },
    cellRenderer: m
  })), e.createElement(Xc, {
    renderChildren: I && R || !A,
    className: "rg-pane-right",
    style: {
      height: v.scrollableRange.height,
      width: v.width - v.ranges.stickyLeftRange.width - v.scrollableRange.width,
      marginTop: M,
      marginBottom: k,
      marginLeft: B,
      order: 5
    }
  }, e.createElement(Fc, {
    state: b,
    range: Uc(v.ranges.stickyRightRange)(A || v.ranges.stickyLeftRange),
    borders: {
      left: !0,
      top: !y,
      bottom: !C
    },
    cellRenderer: m
  })), e.createElement(Xc, {
    renderChildren: y && w,
    className: "rg-pane-top",
    style: {
      width: "calc(100% - ".concat(v.ranges.stickyLeftRange.width + v.ranges.stickyRightRange.width, "px)"),
      height: v.ranges.stickyTopRange.height,
      marginBottom: S,
      marginLeft: G,
      marginRight: N,
      order: 1,
      zIndex: (null !== (i = null === (r = b.props) || void 0 === r ? void 0 : r.zIndexBase) && void 0 !== i ? i : 0) + 1
    }
  }, e.createElement(Fc, {
    state: b,
    range: jc(v.ranges.stickyTopRange)(E),
    borders: {
      top: !0,
      right: !R,
      left: !x
    },
    cellRenderer: m
  })), e.createElement(Xc, {
    renderChildren: I && x || !A,
    className: "rg-pane-left",
    style: {
      height: v.scrollableRange.height,
      width: v.width - v.scrollableRange.width - v.ranges.stickyRightRange.width,
      marginRight: L,
      marginBottom: k,
      marginTop: M,
      order: 3,
      zIndex: (null !== (a = null === (l = b.props) || void 0 === l ? void 0 : l.zIndexBase) && void 0 !== a ? a : 0) + 1
    }
  }, e.createElement(Fc, {
    state: b,
    range: Uc(v.ranges.stickyLeftRange)(A || v.ranges.stickyLeftRange),
    borders: {
      bottom: !C,
      top: !y,
      left: !0
    },
    cellRenderer: m
  })), e.createElement(Xc, {
    renderChildren: C && R,
    className: "rg-pane-bottom rg-pane-right rg-pane-shadow shadow-bottom-right-corner",
    style: {
      height: v.ranges.stickyBottomRange.height,
      width: v.width - v.ranges.stickyLeftRange.width - v.scrollableRange.width,
      marginTop: T,
      marginLeft: B,
      order: 8,
      zIndex: (null !== (s = null === (c = b.props) || void 0 === c ? void 0 : c.zIndexBase) && void 0 !== s ? s : 0) + 1
    }
  }, e.createElement(Fc, {
    state: b,
    range: Uc(v.ranges.stickyRightRange)(v.ranges.stickyBottomRange),
    borders: {
      top: !0,
      left: !0,
      right: !0,
      bottom: !0
    },
    cellRenderer: m
  })), e.createElement(Xc, {
    renderChildren: C && x,
    className: "rg-pane-bottom rg-pane-left rg-pane-shadow shadow-bottom-left-corner",
    style: {
      height: v.ranges.stickyBottomRange.height,
      width: v.width - v.ranges.stickyRightRange.width - v.scrollableRange.width,
      marginRight: L,
      marginTop: T,
      order: 6,
      zIndex: (null !== (d = null === (u = b.props) || void 0 === u ? void 0 : u.zIndexBase) && void 0 !== d ? d : 0) + 2
    }
  }, e.createElement(Fc, {
    state: b,
    range: Uc(v.ranges.stickyLeftRange)(v.ranges.stickyBottomRange),
    borders: {
      top: !0,
      left: !0,
      right: !0,
      bottom: !0
    },
    cellRenderer: m
  })), e.createElement(Xc, {
    renderChildren: y && R,
    className: "rg-pane-top rg-pane-right rg-pane-shadow shadow-top-right-corner",
    style: {
      height: v.ranges.stickyTopRange.height,
      width: v.width - v.scrollableRange.width - v.ranges.stickyLeftRange.width,
      marginLeft: B,
      marginBottom: S,
      order: 2,
      zIndex: (null !== (p = null === (g = b.props) || void 0 === g ? void 0 : g.zIndexBase) && void 0 !== p ? p : 0) + 2
    }
  }, e.createElement(Fc, {
    state: b,
    range: Uc(v.ranges.stickyRightRange)(v.ranges.stickyTopRange),
    borders: {
      top: !0,
      left: !0,
      right: !0,
      bottom: !0
    },
    cellRenderer: m
  })), e.createElement(Xc, {
    renderChildren: y && x,
    className: "rg-pane-top rg-pane-left rg-pane-shadow shadow-top-left-corner",
    style: {
      height: v.ranges.stickyTopRange.height,
      width: v.width - v.scrollableRange.width - v.ranges.stickyRightRange.width,
      marginRight: L,
      marginBottom: S,
      order: 0,
      zIndex: (null !== (h = null === (f = b.props) || void 0 === f ? void 0 : f.zIndexBase) && void 0 !== h ? h : 0) + 3
    }
  }, e.createElement(Fc, {
    state: b,
    range: Uc(v.ranges.stickyLeftRange)(v.ranges.stickyTopRange),
    borders: {
      top: !0,
      left: !0,
      right: !0,
      bottom: !0
    },
    cellRenderer: m
  })));
},
    ql = function ql() {
  var t = Kl(),
      n = t.linePosition,
      o = t.lineOrientation,
      r = t.cellMatrix,
      i = "vertical" === o,
      l = Object.assign({}, i ? {
    left: n,
    height: r.height
  } : {
    top: n,
    width: r.width
  });
  return -1 === n ? null : e.createElement("div", {
    className: "rg-line ".concat(i ? "rg-line-vertical" : "rg-line-horizontal"),
    style: l
  });
},
    ea = function ea() {
  var e = Kl(),
      n = e.lineOrientation,
      o = e.shadowSize,
      r = e.shadowPosition,
      i = e.shadowCursor,
      l = e.cellMatrix,
      a = "vertical" === n;
  return -1 === r ? null : t.createElement("div", {
    className: "rg-shadow",
    style: {
      cursor: i,
      top: a ? 0 : r,
      left: a ? r : 0,
      width: a ? o : l.width,
      height: a ? l.height : o
    }
  });
};

function ta(e) {
  return e.selectedRanges[e.activeSelectedRangeIdx];
}

var na = {
  type: "",
  text: "",
  value: NaN
};

function oa(e, t, n) {
  void 0 === n && (n = !1);
  var o = ia(t),
      r = o.div,
      i = o.table,
      l = (o.location, function (e, t, n, o, r) {
    var i = "",
        l = "";
    return n.rows.forEach(function (t) {
      var a = o.insertRow();
      n.columns.forEach(function (n) {
        var o = a.insertCell(),
            c = P(e, {
          row: t,
          column: n
        }).cell,
            s = c.text || " ";
        o.textContent = s, i = "" === l ? c.text : i + (l === t.rowId ? "\t" : "\n") + s, l = t.rowId, o.setAttribute("data-reactgrid", JSON.stringify(c)), o.style.color = "initial", o.style.border = "initial", o.style.fontSize = "initial", o.style.backgroundColor = "initial", aa(e, {
          row: t,
          column: n
        }, r);
      });
    }), i;
  }(e, 0, t, i, n));
  return la(r, i), {
    div: r,
    text: l
  };
}

function ra(e, t, n) {
  var o = e.insertCell(),
      r = P(t, n).cell;
  o.textContent = r.text ? r.text : " ", o.setAttribute("data-reactgrid", JSON.stringify(r)), o.style.border = "initial";
}

function ia(e) {
  var t = document.createElement("div"),
      n = document.createElement("table");
  return n.setAttribute("empty-cells", "show"), n.setAttribute("data-reactgrid", "reactgrid-content"), {
    div: t,
    table: n,
    location: {
      row: e.first.row,
      column: e.first.column
    }
  };
}

function la(e, t) {
  e.setAttribute("contenteditable", "true"), e.style.position = "fixed", e.style.top = "50%", e.style.left = "50%", e.appendChild(t);
}

function aa(e, t, n) {
  n && (e = W(e, t, na));
}

function ca(e, t, n) {
  return P(e, t).cell.groupId === n.groupId ? W(e, t, n) : (console.warn("New cells data can't be appended into location: ('".concat(t.column.columnId, "', '").concat(t.row.rowId, "'). Cell's 'groupId' field doesn't match!")), e);
}

function sa(e, t) {
  var n,
      o,
      r = ta(e);

  if (1 !== t.length || 1 !== t[0].length) {
    var i,
        l = e.cellMatrix;
    if (t.forEach(function (t, n) {
      return t.forEach(function (t, o) {
        var a = r.first.row.idx + n,
            c = r.first.column.idx + o;
        a <= l.last.row.idx && c <= l.last.column.idx && (i = l.getLocation(a, c), e = ca(e, i, t));
      });
    }), !i) return e;
    var a = l.getRange(r.first, i);
    return (null === (n = null == e ? void 0 : e.props) || void 0 === n ? void 0 : n.onSelectionChanging) && !e.props.onSelectionChanging([a]) ? e : ((null === (o = null == e ? void 0 : e.props) || void 0 === o ? void 0 : o.onSelectionChanged) && e.props.onSelectionChanged([a]), _C(_C({}, e), {
      selectedRanges: [l.getRange(r.first, i)],
      activeSelectedRangeIdx: 0
    }));
  }

  return r.rows.forEach(function (n) {
    return r.columns.forEach(function (o) {
      e = ca(e, M(n, o), t[0][0]);
    });
  }), e;
}

function ua(e) {
  return e.selectedRanges.map(function (e) {
    return e.rows.flatMap(function (t) {
      return e.columns.map(function (e) {
        return {
          columnId: e.columnId,
          rowId: t.rowId
        };
      });
    });
  });
}

function da() {
  return R(this, void 0, void 0, function () {
    return A(this, function (e) {
      switch (e.label) {
        case 0:
          return [4, navigator.clipboard.readText().catch(function () {
            throw new Error("Failed to read textual data from clipboard!");
          })];

        case 1:
          return [2, e.sent().split("\n").map(function (e) {
            return e.split("\t").map(function (e) {
              return {
                type: "text",
                text: e,
                value: it(e)
              };
            });
          })];
      }
    });
  });
}

function ga(e) {
  return R(this, void 0, void 0, function () {
    var t;
    return A(this, function (n) {
      switch (n.label) {
        case 0:
          return [4, e.getType("text/html").catch(function () {
            throw new Error("Failed to get HTML Blob data from clipboard!");
          })];

        case 1:
          return [4, n.sent().text().catch(function () {
            throw new Error("Failed to parse HTML Blob to text!");
          })];

        case 2:
          t = n.sent();

          try {
            return [2, new DOMParser().parseFromString(t, "text/html")];
          } catch (e) {
            throw new Error("Failed to parse HTML string to DOM!");
          }

          return [2];
      }
    });
  });
}

function pa(e) {
  var t, n;
  return R(this, void 0, void 0, function () {
    var o, r, i, l, a, c, s, u;
    return A(this, function (d) {
      switch (d.label) {
        case 0:
          return o = [], (null === (t = e.firstElementChild) || void 0 === t ? void 0 : t.firstElementChild) ? [3, 2] : [4, da()];

        case 1:
          return [2, d.sent()];

        case 2:
          for (r = e.firstElementChild.firstElementChild.children, i = 0; i < r.length; i++) {
            for (l = [], a = 0; a < r[i].children.length; a++) {
              c = r[i].children[a].getAttribute("data-reactgrid"), s = c && JSON.parse(c), u = null !== (n = r[i].children[a].textContent) && void 0 !== n ? n : "", l.push(s || {
                type: "text",
                text: u,
                value: it(u)
              });
            }

            o.push(l);
          }

          return [2, o];
      }
    });
  });
}

var fa = function fa() {
  return R(void 0, void 0, void 0, function () {
    var e, t, n, o, r;
    return A(this, function (i) {
      switch (i.label) {
        case 0:
          return [4, navigator.clipboard.read()];

        case 1:
          return e = i.sent(), (t = e.find(function (e) {
            return e.types.includes("text/html");
          })) ? [4, ga(t)] : [3, 3];

        case 2:
          return o = i.sent(), [3, 4];

        case 3:
          o = null, i.label = 4;

        case 4:
          return "reactgrid-content" === (null === (r = null == (n = o) ? void 0 : n.body.firstElementChild) || void 0 === r ? void 0 : r.getAttribute("data-reactgrid")) ? [2, pa(n.body)] : [4, da()];

        case 5:
          return [2, i.sent()];
      }
    });
  });
},
    ha = function ha() {
  var t = e.useRef(null),
      n = Kl(),
      o = n.contextMenuPosition,
      r = n.selectedIds,
      i = n.selectionMode,
      l = o.left,
      a = o.top;

  if (-1 !== a && -1 !== l && t.current) {
    var c = window.innerWidth,
        s = window.innerHeight,
        u = t.current.offsetWidth,
        d = t.current.offsetHeight;
    o.top = s - a < d ? s - d - 20 : a, o.left = c - l < u ? c - u - 20 : l;
  }

  var g,
      p,
      f,
      h,
      m = function (e) {
    var t = xc(e),
        n = t.copyLabel,
        o = t.cutLabel,
        r = t.pasteLabel;
    return [{
      id: "copy",
      label: n,
      handler: function handler() {
        return ma(e, !1);
      }
    }, {
      id: "cut",
      label: o,
      handler: function handler() {
        return ma(e, !0);
      }
    }, {
      id: "paste",
      label: r,
      handler: function handler() {
        return function (e) {
          var t = O() || D();

          if (vc() || t) {
            var n = xc(e),
                o = n.appleMobileDeviceContextMenuPasteAlert,
                r = n.otherBrowsersContextMenuPasteAlert,
                i = n.actionNotSupported;
            alert("".concat(i, " ").concat(t ? o : r));
          } else fa().then(function (t) {
            e.update(function (e) {
              return sa(e, t);
            });
          });
        }(e);
      }
    }];
  }(n),
      b = (g = m, null !== (h = null === (f = null === (p = n.props) || void 0 === p ? void 0 : p.onContextMenu) || void 0 === f ? void 0 : f.call(p, "row" === n.selectionMode ? n.selectedIds : [], "column" === n.selectionMode ? n.selectedIds : [], n.selectionMode, g, ua(n))) && void 0 !== h ? h : []);

  return b.length >= 0 && (m = b), e.createElement("div", {
    ref: t,
    className: "rg-context-menu",
    style: {
      visibility: -1 === a && -1 === l ? "hidden" : "visible",
      top: o.top + "px",
      left: o.left + "px"
    }
  }, m.map(function (t, o) {
    var l = t.handler,
        a = t.id,
        c = t.label;
    return e.createElement("div", {
      key: o,
      className: "rg-context-menu-option",
      onPointerDown: function onPointerDown(e) {
        return e.stopPropagation();
      },
      onClick: function onClick() {
        l("row" === i ? r : [], "column" === i ? r : [], i, ua(n)), n.update(function (e) {
          return _C(_C(_C({}, e), {
            contextMenuPosition: {
              top: -1,
              left: -1
            }
          }), ("copy" === a || "cut" === a) && {
            copyRange: ta(e)
          });
        });
      }
    }, c);
  }));
};

function ma(e, t) {
  void 0 === t && (t = !1), function (e, t) {
    var n;
    void 0 === t && (t = !1);
    var o = ta(e);

    if (o) {
      var r = oa(e, o, t).div;
      document.body.appendChild(r), r.focus(), document.execCommand("selectAll", !1, void 0), document.execCommand("copy"), document.body.removeChild(r), null === (n = e.hiddenFocusElement) || void 0 === n || n.focus();
    }
  }(e, t);
}

var ba = function (t) {
  function n() {
    var e = null !== t && t.apply(this, arguments) || this;
    return e.updateState = function (t) {
      return e.setState(t);
    }, e.stateUpdater = function (t) {
      return _c(t(e.state), e.state, e.props, e.updateState);
    }, e.pointerEventsController = new Ce(e.stateUpdater), e.eventHandlers = new Pe(e.stateUpdater, e.pointerEventsController), e.cellMatrixBuilder = new We(), e.state = _C(_C({
      update: e.stateUpdater
    }, oc), {
      currentBehavior: new nc(),
      cellMatrix: e.cellMatrixBuilder.setProps(e.props).fillRowsAndCols().setRangesToRenderLookup().fillSticky().fillScrollableRange().setEdgeLocations().getCellMatrix()
    }), e.clearSelections = function () {
      e.setState(function (e) {
        return 0 === e.selectedIds.length && 0 === e.selectedIndexes.length && 0 === e.selectedRanges.length ? null : {
          selectedIds: [],
          selectedIndexes: [],
          selectedRanges: []
        };
      });
    }, e;
  }

  return w(n, t), n.getDerivedStateFromProps = function (e, t) {
    try {
      return Al(e, t);
    } catch (e) {
      return console.error(e), null;
    }
  }, n.prototype.componentDidUpdate = function (e, t) {
    var n;
    !t.reactGridElement && this.state.reactGridElement && (null === (n = this.state.scrollableElement) || void 0 === n || n.addEventListener("scroll", this.eventHandlers.scrollHandler)), ve(0, t, this.state);
  }, n.prototype.componentDidMount = function () {
    window.addEventListener("resize", this.eventHandlers.windowResizeHandler);
  }, n.prototype.componentWillUnmount = function () {
    var e;
    window.removeEventListener("resize", this.eventHandlers.windowResizeHandler), null === (e = this.state.scrollableElement) || void 0 === e || e.removeEventListener("scroll", this.eventHandlers.scrollHandler), this.setState({
      contextMenuPosition: {
        top: -1,
        left: -1
      }
    });
  }, n.prototype.render = function () {
    var t = this.state,
        n = this.eventHandlers;
    return t.legacyBrowserMode ? e.createElement(Ql, {
      state: t
    }, e.createElement(wc, {
      eventHandlers: n
    })) : e.createElement(Ql, {
      state: t
    }, e.createElement(yc, {
      eventHandlers: n
    }, e.createElement($l, {
      cellRenderer: Mc
    }), e.createElement(ql, null), e.createElement(ea, null), e.createElement(ha, null), t.currentlyEditedCell && e.createElement(ac, null)));
  }, n;
}(e.Component);

var va = Ga(X),
    ya = ka(va),
    Ia = Na(va),
    xa = Ta(va),
    wa = La(va),
    Ca = Wa(va),
    Ra = Fa(va),
    Aa = Za(va),
    Ea = Aa(function (e, t) {
  var n,
      o = Ha(e, e.cellMatrix.ranges.stickyTopRange.height + e.cellMatrix.ranges.stickyBottomRange.height),
      r = e.cellMatrix.ranges.stickyTopRange.rows.length > 0,
      i = r && de(e, t),
      l = e.cellMatrix.scrollableRange.rows.length > 0,
      a = l && t.row.idx > e.cellMatrix.scrollableRange.first.row.idx && t.row.idx <= e.cellMatrix.scrollableRange.last.row.idx,
      c = l && t.row.idx === e.cellMatrix.scrollableRange.first.row.idx,
      s = e.cellMatrix.ranges.stickyBottomRange.rows.length > 0,
      u = s && t.row.idx >= e.cellMatrix.ranges.stickyBottomRange.first.row.idx,
      d = s && (null == t ? void 0 : t.row.idx) === (null === (n = e.cellMatrix.ranges) || void 0 === n ? void 0 : n.stickyBottomRange.first.row.idx),
      g = e.cellMatrix.scrollableRange.rows.filter(function (e) {
    return e.top + e.height < o;
  }),
      p = 0;
  u ? p = u && !d ? e.cellMatrix.ranges.stickyBottomRange.first.row.idx : l ? e.cellMatrix.scrollableRange.last.row.idx : r ? e.cellMatrix.ranges.stickyTopRange.last.row.idx : e.cellMatrix.ranges.stickyBottomRange.first.row.idx : a ? p = t.row.idx - g.length < e.cellMatrix.scrollableRange.first.row.idx ? e.cellMatrix.scrollableRange.first.row.idx : t.row.idx - g.length : c ? p = r ? e.cellMatrix.ranges.stickyTopRange.last.row.idx : e.cellMatrix.scrollableRange.first.row.idx : i && (p = e.cellMatrix.ranges.stickyTopRange.first.row.idx);

  if (!Ba(e, p, t.column.idx)) {
    var f = e.cellMatrix.getLocation(p, t.column.idx),
        h = Va(e, f);
    return h ? h.row.idx : t.row.idx;
  }

  return p;
}),
    Ma = Aa(function (e, t) {
  var n,
      o = e.cellMatrix.ranges.stickyTopRange.rows.length > 0,
      r = o && de(e, t),
      i = o && t.row.idx === (null === (n = e.cellMatrix.ranges) || void 0 === n ? void 0 : n.stickyTopRange.last.row.idx),
      l = e.cellMatrix.scrollableRange.rows.length > 0,
      a = l && t.row.idx >= e.cellMatrix.scrollableRange.first.row.idx && t.row.idx < e.cellMatrix.scrollableRange.last.row.idx,
      c = l && t.row.idx === e.cellMatrix.scrollableRange.last.row.idx,
      s = e.cellMatrix.ranges.stickyBottomRange.rows.length > 0,
      u = s && t.row.idx >= e.cellMatrix.ranges.stickyBottomRange.first.row.idx,
      d = Ha(e, e.cellMatrix.ranges.stickyTopRange.height + e.cellMatrix.ranges.stickyBottomRange.height),
      g = e.cellMatrix.scrollableRange.rows.filter(function (e) {
    return e.top + e.height < d;
  }),
      p = 0;
  r ? p = r && !i ? e.cellMatrix.ranges.stickyTopRange.last.row.idx : l ? e.cellMatrix.scrollableRange.first.row.idx : s ? e.cellMatrix.ranges.stickyBottomRange.first.row.idx : e.cellMatrix.ranges.stickyTopRange.last.row.idx : a ? p = t.row.idx + g.length < e.cellMatrix.scrollableRange.rows.length ? t.row.idx + g.length : e.cellMatrix.scrollableRange.last.row.idx : c ? p = s ? e.cellMatrix.ranges.stickyBottomRange.first.row.idx : e.cellMatrix.scrollableRange.last.row.idx : u && (p = e.cellMatrix.ranges.stickyBottomRange.last.row.idx);

  if (!Ba(e, p, t.column.idx)) {
    var f = e.cellMatrix.getLocation(p, t.column.idx),
        h = Xa(e, f);
    return h ? h.row.idx : t.row.idx;
  }

  return p;
});

function Ga(e) {
  return function (t, n, o, r) {
    return e(o, o.cellMatrix.getLocation(n, t), !0, r);
  };
}

function Na(e) {
  return function (t) {
    if (t.focusedLocation) {
      var n = Ba(t, t.focusedLocation.row.idx, t.cellMatrix.columns.length - 1);

      if (!n) {
        var o = t.cellMatrix.getLocation(t.focusedLocation.row.idx, t.cellMatrix.columns.length - 1),
            r = Sa(t, o);
        return r ? e(r.column.idx, r.row.idx, t) : t;
      }

      return e(n.column.idx, n.row.idx, t);
    }

    return t;
  };
}

function ka(e) {
  return function (t) {
    if (t.focusedLocation) {
      var n = Ba(t, t.focusedLocation.row.idx, 0);

      if (!n) {
        var o = t.cellMatrix.getLocation(t.focusedLocation.row.idx, 0),
            r = Pa(t, o);
        return r ? e(r.column.idx, r.row.idx, t) : t;
      }

      return e(n.column.idx, n.row.idx, t);
    }

    return t;
  };
}

function Ta(e) {
  return function (t) {
    var n = Sa(t, t.focusedLocation);
    return n ? e(n.column.idx, n.row.idx, t) : t;
  };
}

function Ba(e, t, n) {
  var o = e.cellMatrix.getLocation(t, n),
      r = P(e, o),
      i = r.cell,
      l = r.cellTemplate;
  if (!e.props) throw new Error('"props" field on "state" object should be initiated before possible location focus');
  var a = e.props.onFocusLocationChanging,
      c = {
    rowId: o.row.rowId,
    columnId: o.column.columnId
  },
      s = !a || a(c);
  return (!l.isFocusable || l.isFocusable(i)) && s ? o : void 0;
}

function Sa(e, t) {
  if (t) for (var n = t.column.idx - 1; n >= e.cellMatrix.first.column.idx; --n) {
    var o = Ba(e, t.row.idx, n);
    if (o) return o;
  }
}

function La(e) {
  return function (t, n) {
    var o = Pa(t, t.focusedLocation);
    return o ? e(o.column.idx, o.row.idx, t, n) : t;
  };
}

function Pa(e, t) {
  if (t) for (var n = t.column.idx + 1; n <= e.cellMatrix.last.column.idx; ++n) {
    var o = Ba(e, t.row.idx, n);
    if (o) return o;
  }
}

function Wa(e) {
  return function (t) {
    var n = Xa(t, t.focusedLocation);
    return n ? e(n.column.idx, n.row.idx, t) : t;
  };
}

function Xa(e, t) {
  if (t) for (var n = t.row.idx - 1; n >= e.cellMatrix.first.row.idx; --n) {
    var o = Ba(e, n, t.column.idx);
    if (o) return o;
  }
}

function Fa(e) {
  return function (t, n) {
    var o = Va(t, t.focusedLocation);
    return o ? e(o.column.idx, o.row.idx, t, n) : t;
  };
}

function Va(e, t) {
  if (t) for (var n = t.row.idx + 1; n <= e.cellMatrix.last.row.idx; ++n) {
    var o = Ba(e, n, t.column.idx);
    if (o) return o;
  }
}

function Za(e) {
  return function (t) {
    return function (n) {
      var o = n.focusedLocation;
      if (!o) return n;
      var r = t(n, o);
      return e(o.column.idx, r, n);
    };
  };
}

function Ha(e, t) {
  return le(e, t);
}

function Oa(e, t) {
  var n = function (e, t) {
    var n,
        o,
        r,
        i,
        l,
        a,
        c,
        s,
        u,
        d,
        g,
        p,
        f,
        h,
        m,
        v,
        y,
        I,
        x = e.focusedLocation;
    if (!x) return e;
    var w = null !== (n = ta(e)) && void 0 !== n ? n : e.cellMatrix.getRange(x, x);
    if (t.ctrlKey && H() && t.keyCode === S.SPACE) return za(e, w.first.column.idx, w.last.column.idx, 0, e.cellMatrix.last.row.idx);
    var R = 1 === e.selectedRanges.length && b(w.first, w.last),
        A = zc(e, t);

    if (A !== e) {
      if (!R && t.keyCode === S.ENTER) {
        var E = t.shiftKey ? "up" : (null === (o = e.props) || void 0 === o ? void 0 : o.moveRightOnEnter) ? "right" : "down";
        return null === (r = e.hiddenFocusElement) || void 0 === r || r.focus(), Da(e, E, w, x);
      }

      return A;
    }

    if (t.altKey) return e;
    if (Hc(t) && t.shiftKey) switch (t.keyCode) {
      case S.HOME:
        return za(e, w.first.column.idx, w.last.column.idx, 0, w.last.row.idx);

      case S.END:
        return za(e, w.first.column.idx, w.last.column.idx, w.first.row.idx, e.cellMatrix.last.row.idx);
    } else if (Hc(t)) {
      var M = e.cellMatrix;

      switch (t.keyCode) {
        case S.KEY_A:
          if (1 === e.selectedRanges.length && b(e.selectedRanges[0].first, M.first) && b(e.selectedRanges[0].last, M.last)) return G(e, x);
          var N = M.getRange(M.first, M.last);
          return (null === (i = e.props) || void 0 === i ? void 0 : i.onSelectionChanging) && !e.props.onSelectionChanging([N]) ? e : _C(_C({}, e), {
            selectedRanges: [N],
            selectionMode: "range",
            activeSelectedRangeIdx: 0
          });

        case S.HOME:
          return X(e, e.cellMatrix.first);

        case S.END:
          return X(e, e.cellMatrix.last);

        case S.SPACE:
          return za(e, w.first.column.idx, w.last.column.idx, 0, e.cellMatrix.last.row.idx);
      }
    } else if (t.shiftKey) switch (t.keyCode) {
      case S.UP_ARROW:
        return function (e, t, n) {
          return t.first.row.idx >= 0 ? t.last.row.idx > n.row.idx ? za(e, t.first.column.idx, t.last.column.idx, t.first.row.idx, t.last.row.idx > 0 ? t.last.row.idx - 1 : 0, "vertical") : za(e, t.last.column.idx, t.first.column.idx, t.last.row.idx, t.first.row.idx > 0 ? t.first.row.idx - 1 : 0, "vertical") : e;
        }(e, w, x);

      case S.DOWN_ARROW:
        return function (e, t, n) {
          return t.last.row.idx <= e.cellMatrix.last.row.idx ? t.first.row.idx < n.row.idx ? za(e, t.last.column.idx, t.first.column.idx, t.last.row.idx, t.first.row.idx >= e.cellMatrix.last.row.idx ? e.cellMatrix.last.row.idx : t.first.row.idx + 1, "vertical") : za(e, t.first.column.idx, t.last.column.idx, t.first.row.idx, t.last.row.idx >= e.cellMatrix.last.row.idx ? e.cellMatrix.last.row.idx : t.last.row.idx + 1, "vertical") : e;
        }(e, w, x);

      case S.LEFT_ARROW:
        return function (e, t, n) {
          return t.first.column.idx >= 0 ? t.last.column.idx > n.column.idx ? za(e, t.first.column.idx, t.last.column.idx > 0 ? t.last.column.idx - 1 : 0, t.first.row.idx, t.last.row.idx, "horizontal") : za(e, t.last.column.idx, t.first.column.idx > 0 ? t.first.column.idx - 1 : 0, t.last.row.idx, t.first.row.idx, "horizontal") : e;
        }(e, w, x);

      case S.RIGHT_ARROW:
        return function (e, t, n) {
          return t.last.column.idx <= e.cellMatrix.last.column.idx ? t.first.column.idx < n.column.idx ? za(e, t.last.column.idx, t.first.column.idx >= e.cellMatrix.last.column.idx ? e.cellMatrix.last.column.idx : t.first.column.idx + 1, t.last.row.idx, t.first.row.idx, "horizontal") : za(e, t.first.column.idx, t.last.column.idx >= e.cellMatrix.last.column.idx ? e.cellMatrix.last.column.idx : t.last.column.idx + 1, t.first.row.idx, t.last.row.idx, "horizontal") : e;
        }(e, w, x);

      case S.TAB:
        return t.preventDefault(), R ? xa(e) : Da(e, "left", w, x);

      case S.ENTER:
        return null === (l = e.hiddenFocusElement) || void 0 === l || l.focus(), R ? Ca(e) : Da(e, "up", w, x);

      case S.SPACE:
        return za(e, 0, e.cellMatrix.last.column.idx, w.first.row.idx, w.last.row.idx);

      case S.HOME:
        return za(e, 0, w.last.column.idx, w.first.row.idx, w.last.row.idx);

      case S.END:
        return za(e, w.first.column.idx, e.cellMatrix.last.column.idx, w.first.row.idx, w.last.row.idx);

      case S.PAGE_UP:
        return function (e, t, n) {
          var o = Ya(e),
              r = e.cellMatrix.ranges.stickyBottomRange.rows.length > 0 && t.first.row.idx > e.cellMatrix.ranges.stickyBottomRange.first.row.idx,
              i = e.cellMatrix.ranges.stickyBottomRange.rows.length > 0 && t.last.row.idx === e.cellMatrix.ranges.stickyBottomRange.last.row.idx,
              l = e.cellMatrix.ranges.stickyBottomRange.rows.length > 0 && t.last.row.idx === e.cellMatrix.ranges.stickyBottomRange.first.row.idx,
              a = e.cellMatrix.ranges.stickyBottomRange.rows.length > 0 && t.first.row.idx === e.cellMatrix.ranges.stickyBottomRange.first.row.idx,
              c = e.cellMatrix.ranges.stickyTopRange.rows.length > 0 && t.last.row.idx === e.cellMatrix.ranges.stickyTopRange.last.row.idx,
              s = e.cellMatrix.scrollableRange.rows.length > 0 && e.cellMatrix.ranges.stickyTopRange.rows.length > 0 && t.first.row.idx === e.cellMatrix.scrollableRange.first.row.idx,
              u = e.cellMatrix.scrollableRange.rows.length > 0 && e.cellMatrix.ranges.stickyTopRange.rows.length > 0 && t.last.row.idx === e.cellMatrix.scrollableRange.first.row.idx,
              d = e.cellMatrix.ranges.stickyTopRange.rows.length > 0 && t.first.row.idx <= e.cellMatrix.ranges.stickyTopRange.last.row.idx,
              g = e.cellMatrix.scrollableRange.rows.filter(function (e) {
            return e.top + e.height < o;
          });
          return t.first.row.idx >= 0 ? t.last.row.idx > n.row.idx ? za(e, t.first.column.idx, t.last.column.idx, t.first.row.idx, i ? e.cellMatrix.ranges.stickyBottomRange.first.row.idx : l ? e.cellMatrix.scrollableRange.rows.length > 0 ? e.cellMatrix.scrollableRange.last.row.idx : e.cellMatrix.ranges.stickyTopRange.first.row.idx : u ? e.cellMatrix.ranges.stickyTopRange.last.row.idx : c ? e.cellMatrix.ranges.stickyTopRange.first.row.idx : t.last.row.idx - g.length > e.cellMatrix.scrollableRange.first.row.idx ? t.last.row.idx - g.length : e.cellMatrix.scrollableRange.first.row.idx, "vertical") : za(e, t.last.column.idx, t.first.column.idx, t.last.row.idx, r ? e.cellMatrix.ranges.stickyBottomRange.first.row.idx : a ? e.cellMatrix.scrollableRange.rows.length > 0 ? e.cellMatrix.scrollableRange.last.row.idx : e.cellMatrix.ranges.stickyTopRange.rows.length > 0 ? e.cellMatrix.ranges.stickyTopRange.first.row.idx : e.cellMatrix.ranges.stickyBottomRange.first.row.idx : s ? e.cellMatrix.ranges.stickyTopRange.last.row.idx : d ? e.cellMatrix.ranges.stickyTopRange.first.row.idx : r ? e.cellMatrix.ranges.stickyBottomRange.first.row.idx : t.first.row.idx - g.length > e.cellMatrix.scrollableRange.first.row.idx ? t.first.row.idx - g.length : e.cellMatrix.scrollableRange.first.row.idx, "vertical") : e;
        }(e, w, x);

      case S.PAGE_DOWN:
        return function (e, t, n) {
          var o = Ya(e),
              r = e.cellMatrix.ranges.stickyTopRange.rows.length > 0 && t.last.row.idx < e.cellMatrix.ranges.stickyTopRange.last.row.idx,
              i = e.cellMatrix.ranges.stickyTopRange.rows.length > 0 && t.first.row.idx < e.cellMatrix.ranges.stickyTopRange.last.row.idx,
              l = e.cellMatrix.ranges.stickyTopRange.rows.length > 0 && t.last.row.idx === e.cellMatrix.ranges.stickyTopRange.last.row.idx,
              a = e.cellMatrix.ranges.stickyTopRange.rows.length > 0 && t.first.row.idx === e.cellMatrix.ranges.stickyTopRange.last.row.idx,
              c = e.cellMatrix.scrollableRange.rows.length > 0 && e.cellMatrix.ranges.stickyBottomRange.rows.length > 0 && t.last.row.idx === e.cellMatrix.scrollableRange.last.row.idx,
              s = e.cellMatrix.scrollableRange.rows.length > 0 && e.cellMatrix.ranges.stickyBottomRange.rows.length > 0 && t.first.row.idx === e.cellMatrix.scrollableRange.last.row.idx,
              u = e.cellMatrix.ranges.stickyBottomRange.rows.length > 0 && t.last.row.idx >= e.cellMatrix.ranges.stickyBottomRange.first.row.idx,
              d = e.cellMatrix.ranges.stickyBottomRange.rows.length > 0 && t.first.row.idx >= e.cellMatrix.ranges.stickyBottomRange.first.row.idx,
              g = e.cellMatrix.scrollableRange.rows.filter(function (e) {
            return e.top + e.height < o;
          });
          return t.last.row.idx <= e.cellMatrix.last.row.idx ? t.first.row.idx < n.row.idx ? za(e, t.last.column.idx, t.first.column.idx, t.last.row.idx, i ? e.cellMatrix.ranges.stickyTopRange.last.row.idx : a ? e.cellMatrix.scrollableRange.rows.length > 0 ? e.cellMatrix.scrollableRange.first.row.idx : e.cellMatrix.ranges.stickyBottomRange.first.row.idx : s ? e.cellMatrix.ranges.stickyBottomRange.first.row.idx : d ? e.cellMatrix.ranges.stickyBottomRange.last.row.idx : t.first.row.idx + g.length >= e.cellMatrix.scrollableRange.last.row.idx ? e.cellMatrix.scrollableRange.last.row.idx : t.first.row.idx + g.length, "vertical") : za(e, t.first.column.idx, t.last.column.idx, t.first.row.idx, u ? e.cellMatrix.ranges.stickyBottomRange.last.row.idx : l ? e.cellMatrix.scrollableRange.rows.length > 0 ? e.cellMatrix.scrollableRange.first.row.idx : e.cellMatrix.ranges.stickyBottomRange.rows.length > 0 ? e.cellMatrix.ranges.stickyBottomRange.first.row.idx : e.cellMatrix.ranges.stickyTopRange.last.row.idx : c ? e.cellMatrix.ranges.stickyBottomRange.first.row.idx : r ? e.cellMatrix.ranges.stickyTopRange.last.row.idx : t.last.row.idx + g.length >= e.cellMatrix.scrollableRange.last.row.idx ? e.cellMatrix.scrollableRange.last.row.idx : t.last.row.idx + g.length, "vertical") : e;
        }(e, w, x);
    } else switch (t.keyCode) {
      case S.DELETE:
      case S.BACKSPACE:
        return null === (a = e.hiddenFocusElement) || void 0 === a || a.focus(), function (e) {
          return e.selectedRanges.forEach(function (t) {
            return t.rows.forEach(function (n) {
              return t.columns.forEach(function (t) {
                return e = W(e, {
                  row: n,
                  column: t
                }, na);
              });
            });
          }), e;
        }(e);

      case S.UP_ARROW:
        return null === (c = e.hiddenFocusElement) || void 0 === c || c.focus(), Ca(e);

      case S.DOWN_ARROW:
        return null === (s = e.hiddenFocusElement) || void 0 === s || s.focus(), Ra(e);

      case S.LEFT_ARROW:
        return null === (u = e.hiddenFocusElement) || void 0 === u || u.focus(), xa(e);

      case S.RIGHT_ARROW:
        return null === (d = e.hiddenFocusElement) || void 0 === d || d.focus(), wa(e);

      case S.TAB:
        return null === (g = e.hiddenFocusElement) || void 0 === g || g.focus(), t.preventDefault(), R ? wa(e) : Da(e, "right", w, x);

      case S.HOME:
        return null === (p = e.hiddenFocusElement) || void 0 === p || p.focus(), ya(e);

      case S.END:
        return null === (f = e.hiddenFocusElement) || void 0 === f || f.focus(), Ia(e);

      case S.PAGE_UP:
        return null === (h = e.hiddenFocusElement) || void 0 === h || h.focus(), Ea(e);

      case S.PAGE_DOWN:
        return null === (m = e.hiddenFocusElement) || void 0 === m || m.focus(), Ma(e);

      case S.ENTER:
        var k = (null === (v = e.props) || void 0 === v ? void 0 : v.moveRightOnEnter) ? _C(_C({}, wa(e, t.keyCode)), {
          currentlyEditedCell: void 0
        }) : _C(_C({}, Ra(e, t.keyCode)), {
          currentlyEditedCell: void 0
        });
        return null === (y = e.hiddenFocusElement) || void 0 === y || y.focus(), R ? k : Da(e, "right", w, x);

      case S.ESCAPE:
        return t.preventDefault(), null === (I = e.hiddenFocusElement) || void 0 === I || I.focus(), e.currentlyEditedCell ? _C(_C({}, e), {
          currentlyEditedCell: void 0
        }) : e;
    }
    return e;
  }(e, t);

  return n !== e && (t.stopPropagation(), t.preventDefault()), n;
}

function Da(e, t, n, o) {
  var r = e.activeSelectedRangeIdx,
      i = n ? n.columns.length : 0,
      l = n ? n.rows.length : 0,
      a = "up" === t || "left" === t ? -1 : 1,
      c = "up" === t || "down" === t ? o.row.idx - n.first.row.idx + (o.column.idx - n.first.column.idx) * l : (o.row.idx - n.first.row.idx) * i + (o.column.idx - n.first.column.idx),
      s = (c + a) % (n.rows.length * n.columns.length),
      u = s < 0 && 0 === c || 1 === l && 1 === i && -1 === a,
      d = 0 === s && c === n.rows.length * n.columns.length - 1 && (l >= 3 && i >= 1 || l >= 1 && i >= 3) || 0 === s && c === n.rows.length * n.columns.length - 1 && (2 === l && i >= 1 || l >= 1 && 2 === i) && 1 === a || s < 0 && 0 === c || 1 === l && 1 === i && 1 === a;

  if (u) {
    var g = 0 === r ? e.selectedRanges.length - 1 : (r - 1) % e.selectedRanges.length,
        p = e.selectedRanges[g];
    return e = X(e, M(p.last.row, p.last.column), !1), _C(_C({}, e), {
      activeSelectedRangeIdx: g
    });
  }

  if (d) {
    g = (r + 1) % e.selectedRanges.length, p = e.selectedRanges[g];
    return e = X(e, M(p.first.row, p.first.column), !1), _C(_C({}, e), {
      activeSelectedRangeIdx: g
    });
  }

  var f = "up" === t || "down" === t ? Math.floor(s / l) : s % i,
      h = "up" === t || "down" === t ? s % l : Math.floor(s / i),
      m = n.first.column.idx + f,
      b = n.first.row.idx + h;
  return e = X(e, e.cellMatrix.getLocation(b, m), !n || !(n.columns.length > 1 || n.rows.length > 1));
}

function Ya(e) {
  var t = e.cellMatrix.ranges,
      n = t.stickyBottomRange,
      o = t.stickyTopRange;
  return le(e, n.height + o.height);
}

function za(e, t, n, o, r, i) {
  var l, a, c;
  if (!e.enableRangeSelection) return e;
  var s = e.cellMatrix.getLocation(o, t),
      u = e.cellMatrix.getLocation(r, n),
      d = e.selectedRanges.slice();

  if (d[e.activeSelectedRangeIdx] = e.cellMatrix.getRange(s, u), i) {
    var g = e.focusedLocation;
    if (!g) return e;
    var p = 0,
        f = 0;

    switch (i) {
      case "horizontal":
        p = g.row.idx, f = g.column.idx !== t ? t : n;
        break;

      case "vertical":
        p = g.row.idx !== o ? o : r, f = g.column.idx;
    }

    var h = ye(e, e.cellMatrix.getLocation(p, f), i),
        m = h.left;
    ie(e, h.top, m);
  }

  return (null === (l = e.props) || void 0 === l ? void 0 : l.onSelectionChanging) && !e.props.onSelectionChanging(d) ? e : (null === (c = null === (a = e.props) || void 0 === a ? void 0 : a.onSelectionChanged) || void 0 === c || c.call(a, d), _C(_C({}, e), {
    selectedRanges: d
  }));
}

var Ja = function (e) {
  function t() {
    var t = null !== e && e.apply(this, arguments) || this;
    return t.autoScrollDirection = "horizontal", t;
  }

  return w(t, e), t.prototype.handlePointerDown = function (e, t, n) {
    return this.initialColumn = t.column, n = Hc(e) && "column" === n.selectionMode && n.selectedIds.some(function (e) {
      return e === t.column.columnId;
    }) ? function (e, t) {
      var n = e.selectedIndexes.filter(function (e) {
        return e !== t.idx;
      }),
          o = e.selectedIds.filter(function (e) {
        return e !== t.columnId;
      });
      return _C(_C({}, e), {
        selectionMode: "column",
        selectedIndexes: n,
        selectedIds: o
      });
    }(n, t.column) : e.shiftKey && n.focusedLocation ? T(n, n.focusedLocation.column, t.column, Hc(e)) : function (e, t, n) {
      return _C(_C({}, e), {
        selectionMode: "column",
        selectedIndexes: (n && "column" === e.selectionMode ? e.selectedIndexes : []).concat(t.idx),
        selectedIds: (n && "column" === e.selectionMode ? e.selectedIds : []).concat(t.columnId)
      });
    }(n = X(n, t, !1), t.column, Hc(e));
  }, t.prototype.handlePointerEnter = function (e, t, n) {
    return T(n, this.initialColumn, t.column, Hc(e));
  }, t.prototype.handlePointerUp = function (e, t, n) {
    var o, r;

    if ((null === (o = n.props) || void 0 === o ? void 0 : o.onSelectionChanging) && !n.props.onSelectionChanging(n.selectedRanges)) {
      var i = E([], n.selectedRanges, !0).filter(function (e, t) {
        return t !== n.activeSelectedRangeIdx;
      });
      return _C(_C({}, n), {
        selectedRanges: i,
        activeSelectedRangeIdx: i.length - 1
      });
    }

    return (null === (r = n.props) || void 0 === r ? void 0 : r.onSelectionChanged) && n.props.onSelectionChanged(n.selectedRanges), n;
  }, t.prototype.handleContextMenu = function (e, t) {
    return ee(e, t);
  }, t;
}(L),
    ja = function (e) {
  function t() {
    var t = null !== e && e.apply(this, arguments) || this;
    return t.autoScrollDirection = "vertical", t;
  }

  return w(t, e), t.prototype.handlePointerDown = function (e, t, n) {
    return this.initialRow = t.row, n = Hc(e) && "row" === n.selectionMode && n.selectedIds.some(function (e) {
      return e === t.row.rowId;
    }) ? function (e, t) {
      var n = e.selectedIndexes.filter(function (e) {
        return e !== t.idx;
      }),
          o = e.selectedIds.filter(function (e) {
        return e !== t.rowId;
      });
      return _C(_C({}, e), {
        selectionMode: "row",
        selectedIndexes: n,
        selectedIds: o
      });
    }(n, t.row) : e.shiftKey && n.focusedLocation ? B(n, n.focusedLocation.row, t.row, Hc(e)) : function (e, t, n) {
      return _C(_C({}, e), {
        selectionMode: "row",
        selectedIndexes: (n && "row" === e.selectionMode ? e.selectedIndexes : []).concat(t.idx),
        selectedIds: (n && "row" === e.selectionMode ? e.selectedIds : []).concat(t.rowId)
      });
    }(n = X(n, t, !1), t.row, Hc(e));
  }, t.prototype.handlePointerEnter = function (e, t, n) {
    return B(n, this.initialRow, t.row, Hc(e));
  }, t.prototype.handlePointerUp = function (e, t, n) {
    var o, r;

    if ((null === (o = n.props) || void 0 === o ? void 0 : o.onSelectionChanging) && !n.props.onSelectionChanging(n.selectedRanges)) {
      var i = E([], n.selectedRanges, !0).filter(function (e, t) {
        return t !== n.activeSelectedRangeIdx;
      });
      return _C(_C({}, n), {
        selectedRanges: i,
        activeSelectedRangeIdx: i.length - 1
      });
    }

    return (null === (r = n.props) || void 0 === r ? void 0 : r.onSelectionChanged) && n.props.onSelectionChanged(n.selectedRanges), n;
  }, t.prototype.handleContextMenu = function (e, t) {
    return ee(e, t);
  }, t;
}(L),
    Ua = function Ua(t) {
  var n = t.range,
      o = t.pane,
      r = t.style,
      i = t.className,
      l = n.first.row.idx <= o.first.row.idx ? o.first.row.top : n.first.row.top,
      a = n.first.column.idx <= o.first.column.idx ? o.first.column.left : n.first.column.left,
      c = (n.last.column.idx > o.last.column.idx ? o.last.column.right : n.last.column.right) - a,
      s = (n.last.row.idx > o.last.row.idx ? o.last.row.bottom : n.last.row.bottom) - l,
      u = n.first.row.idx >= o.first.row.idx,
      d = n.last.row.idx <= o.last.row.idx,
      g = n.last.column.idx <= o.last.column.idx,
      p = n.first.column.idx >= o.first.column.idx;
  return e.createElement("div", {
    className: "rg-partial-area ".concat(i),
    key: n.first.column.idx + o.last.column.idx,
    style: _C(_C({}, r), {
      top: l - (0 === l ? 0 : 1),
      left: a - (0 === a ? 0 : 1),
      width: c + (0 === a ? 0 : 1),
      height: s + (0 === l ? 0 : 1),
      borderTop: u ? r.borderTop : "unset",
      borderBottom: d ? r.borderBottom : "unset",
      borderRight: g ? r.borderRight : "unset",
      borderLeft: p ? r.borderLeft : "unset"
    })
  });
};

function _a(e, t) {
  return t.first.column.idx <= e.last.column.idx && t.first.row.idx <= e.last.row.idx && t.last.column.idx >= e.first.column.idx && t.last.row.idx >= e.first.row.idx;
}

var Qa = function (e) {
  function n() {
    var t = null !== e && e.apply(this, arguments) || this;
    return t.fillDirection = "", t;
  }

  return w(n, e), n.prototype.handlePointerEnter = function (e, t, n) {
    var o = ta(n);
    return this.fillDirection = this.getFillDirection(o, t), this.fillRange = this.getFillRange(n.cellMatrix, o, t, this.fillDirection), _C({}, n);
  }, n.prototype.handlePointerUp = function (e, t, n) {
    var o,
        r,
        i,
        l,
        a,
        c,
        s,
        u,
        d = this,
        g = ta(n),
        p = n.cellMatrix;
    if (!g || void 0 === this.fillRange) return n;
    var f = H() ? e.altKey : e.ctrlKey;
    this.fillRange = n.cellMatrix.validateRange(this.fillRange);

    var h = function h(e) {
      return P(n, e);
    },
        m = function m(e, t) {
      var n = e.map(function (e) {
        return e.value;
      }),
          o = d.findRegressionFunction(n, Array.from({
        length: n.length
      }, function (e, t) {
        return t + 1;
      })),
          r = isNaN(o.a) && isNaN(o.b);
      return t.map(function (t, i) {
        var l = d.calculateXForRegressionFunction(i + n.length + 1, o.a, o.b),
            a = e[i % e.length];
        return _C(_C(_C({}, t), "checkbox" === t.type && {
          checked: "checked" in a ? a.checked : !!a.value
        }), {
          text: r || f ? a.text : l.toString(),
          groupId: a.groupId,
          value: r || f ? a.value : l
        });
      });
    },
        b = function b(e, t, n) {
      return t.columns.forEach(function (o) {
        var r = t.rows.map(function (e) {
          return h(M(e, o)).cell;
        });

        if (r = "up" === n ? r.reverse() : r, d.fillRange) {
          var i = d.fillRange.rows.map(function (e) {
            return h(M(e, o)).cell;
          });
          i = m(r, i), i = "up" === n ? i.reverse() : i, e = d.fillColumn(e, o, i);
        }
      }), e;
    },
        v = function v(e, t, n) {
      return t.rows.forEach(function (o) {
        var r = t.columns.map(function (e) {
          return h(M(o, e)).cell;
        });

        if (r = "left" === n ? r.reverse() : r, d.fillRange) {
          var i = d.fillRange.columns.map(function (e) {
            return h(M(o, e)).cell;
          });
          i = m(r, i), i = "left" === n ? i.reverse() : i, e = d.fillRow(e, o, i);
        }
      }), e;
    };

    switch (this.fillDirection) {
      case "right":
        var y = p.getRange(g.first, M(g.last.row, t.column));
        if ((null === (o = null == (n = v(n, g, "right")) ? void 0 : n.props) || void 0 === o ? void 0 : o.onSelectionChanging) && !n.props.onSelectionChanging([y])) return n;
        (null === (r = (n = _C(_C({}, n), {
          selectedRanges: [y],
          selectedIds: E(E([], g.columns.map(function (e) {
            return e.columnId;
          }), !0), this.fillRange.columns.map(function (e) {
            return e.columnId;
          }), !0)
        })).props) || void 0 === r ? void 0 : r.onSelectionChanged) && n.props.onSelectionChanged(n.selectedRanges);
        break;

      case "left":
        y = p.getRange(g.last, M(g.first.row, t.column));
        if ((null === (i = null == (n = v(n, g, "left")) ? void 0 : n.props) || void 0 === i ? void 0 : i.onSelectionChanging) && !n.props.onSelectionChanging([y])) return n;
        (null === (l = (n = _C(_C({}, n), {
          selectedRanges: [y],
          selectedIds: E(E([], g.columns.map(function (e) {
            return e.columnId;
          }), !0), this.fillRange.columns.map(function (e) {
            return e.columnId;
          }), !0)
        })).props) || void 0 === l ? void 0 : l.onSelectionChanged) && n.props.onSelectionChanged(n.selectedRanges);
        break;

      case "up":
        y = p.getRange(g.last, {
          row: t.row,
          column: g.first.column
        });
        if ((null === (a = null == (n = b(n, g, "up")) ? void 0 : n.props) || void 0 === a ? void 0 : a.onSelectionChanging) && !n.props.onSelectionChanging([y])) return n;
        (null === (c = (n = _C(_C({}, n), {
          selectedRanges: [y],
          selectedIds: E(E([], g.rows.map(function (e) {
            return e.rowId;
          }), !0), this.fillRange.rows.map(function (e) {
            return e.rowId;
          }), !0)
        })).props) || void 0 === c ? void 0 : c.onSelectionChanged) && n.props.onSelectionChanged(n.selectedRanges);
        break;

      case "down":
        y = p.getRange(g.first, M(t.row, g.last.column));
        if ((null === (s = null == (n = b(n, g, "down")) ? void 0 : n.props) || void 0 === s ? void 0 : s.onSelectionChanging) && !n.props.onSelectionChanging([y])) return n;
        (null === (u = (n = _C(_C({}, n), {
          selectedRanges: [y],
          selectedIds: E(E([], g.rows.map(function (e) {
            return e.rowId;
          }), !0), this.fillRange.rows.map(function (e) {
            return e.rowId;
          }), !0)
        })).props) || void 0 === u ? void 0 : u.onSelectionChanged) && n.props.onSelectionChanged(n.selectedRanges);
    }

    return n;
  }, n.prototype.calculateXForRegressionFunction = function (e, t, n) {
    return Math.round((e - t) / n * 1e5) / 1e5;
  }, n.prototype.findRegressionFunction = function (e, t) {
    var n = this.sumArray(e),
        o = this.sumArray(t),
        r = this.sumArray(this.multipleArrays(e, t)),
        i = this.sumArray(this.powerArray(e, 2)),
        l = e.length,
        a = Math.fround(l * r - n * o) / Math.fround(l * i - Math.pow(n, 2));
    return {
      a: o / l - a * (n / l),
      b: a
    };
  }, n.prototype.sumArray = function (e) {
    return e.reduce(function (e, t) {
      return e + t;
    });
  }, n.prototype.multipleArrays = function (e, t) {
    for (var n = [], o = e.length <= t.length ? e.length : t.length, r = 0; r < o; ++r) {
      n.push(e[r] * t[r]);
    }

    return n;
  }, n.prototype.powerArray = function (e, t) {
    return e.map(function (e) {
      return Math.pow(e, t);
    });
  }, n.prototype.renderPanePart = function (e, n) {
    return this.fillDirection && this.fillRange && _a(n, this.fillRange) && t.createElement(Ua, {
      range: e.cellMatrix.validateRange(this.fillRange),
      className: "rg-partial-area-part",
      pane: n,
      style: {
        backgroundColor: "",
        borderTop: "down" === this.fillDirection ? "0px solid transparent" : "",
        borderBottom: "up" === this.fillDirection ? "0px solid transparent" : "",
        borderLeft: "right" === this.fillDirection ? "0px solid transparent" : "",
        borderRight: "left" === this.fillDirection ? "0px solid transparent" : ""
      }
    });
  }, n.prototype.getFillDirection = function (e, t) {
    var n = [];
    return n.push({
      direction: "",
      value: 0
    }), n.push({
      direction: "up",
      value: t.row.idx < e.first.row.idx ? e.first.row.idx - t.row.idx : 0
    }), n.push({
      direction: "down",
      value: t.row.idx > e.last.row.idx ? t.row.idx - e.last.row.idx : 0
    }), n.push({
      direction: "left",
      value: t.column.idx < e.first.column.idx ? e.first.column.idx - t.column.idx : 0
    }), n.push({
      direction: "right",
      value: t.column.idx > e.last.column.idx ? t.column.idx - e.last.column.idx : 0
    }), n.reduce(function (e, t) {
      return e.value >= t.value ? e : t;
    }).direction;
  }, n.prototype.getFillRange = function (e, t, n, o) {
    switch (o) {
      case "right":
        return e.getRange(e.getLocation(t.first.row.idx, e.last.column.idx < t.last.column.idx + 1 ? e.last.column.idx : t.last.column.idx + 1), M(t.last.row, n.column));

      case "left":
        return e.getRange(M(t.first.row, n.column), e.getLocation(t.last.row.idx, e.first.column.idx > t.first.column.idx - 1 ? e.first.column.idx : t.first.column.idx - 1));

      case "up":
        return e.getRange(M(n.row, t.first.column), e.getLocation(e.first.row.idx > t.first.row.idx - 1 ? e.first.row.idx : t.first.row.idx - 1, t.last.column.idx));

      case "down":
        return e.getRange(e.getLocation(e.last.row.idx < t.last.row.idx + 1 ? e.last.row.idx : t.last.row.idx + 1, t.first.column.idx), M(n.row, t.last.column));
    }
  }, n.prototype.fillRow = function (e, t, n) {
    var o;
    return null === (o = this.fillRange) || void 0 === o || o.columns.forEach(function (o, r) {
      e = ca(e, M(t, o), n[r]);
    }), e;
  }, n.prototype.fillColumn = function (e, t, n) {
    var o;
    return null === (o = this.fillRange) || void 0 === o || o.rows.forEach(function (o, r) {
      e = ca(e, M(o, t), n[r]);
    }), e;
  }, n;
}(L),
    Ka = function (e) {
  function t() {
    var t = null !== e && e.apply(this, arguments) || this;
    return t.autoScrollDirection = "vertical", t;
  }

  return w(t, e), t.prototype.handlePointerDown = function (e, t, n) {
    this.initialRowIdx = t.row.idx, this.lastPossibleDropLocation = t;
    var o = n.selectedIndexes.sort(),
        r = o.map(function (e) {
      return n.cellMatrix.rows[e];
    }),
        i = o.filter(function (e) {
      return e < t.row.idx;
    }),
        l = i.map(function (e) {
      return n.cellMatrix.rows[e];
    }),
        a = l.reduce(function (e, t) {
      return e + t.height;
    }, 0);
    return this.pointerOffset = a + t.cellY, this.selectedIds = r.map(function (e) {
      return e.rowId;
    }), _C(_C({}, n), {
      lineOrientation: "horizontal",
      shadowSize: r.reduce(function (e, t) {
        return e + t.height;
      }, 0),
      shadowPosition: this.getShadowPosition(t, n)
    });
  }, t.prototype.handlePointerMove = function (e, t, n) {
    var o,
        r,
        i = this.getShadowPosition(t, n),
        l = "-webkit-grabbing",
        a = n.linePosition,
        c = V(n.scrollableElement).scrollTop,
        s = t.viewportY + 0;

    if (this.lastPossibleDropLocation = this.getLastPossibleDropLocation(n, t), this.lastPossibleDropLocation && this.lastPossibleDropLocation.row.idx !== this.initialRowIdx) {
      var u = this.lastPossibleDropLocation.row.idx > this.initialRowIdx;
      a = Math.min(this.lastPossibleDropLocation.viewportY - this.lastPossibleDropLocation.cellY + (u ? this.lastPossibleDropLocation.row.height : 0), ((null === (o = n.visibleRange) || void 0 === o ? void 0 : o.height) || 0) + n.cellMatrix.ranges.stickyTopRange.height + n.cellMatrix.ranges.stickyBottomRange.height + c), (null === (r = n.props) || void 0 === r ? void 0 : r.canReorderRows) ? n.props.canReorderRows && n.props.canReorderRows(this.lastPossibleDropLocation.row.rowId, this.selectedIds, this.position) ? u ? s > t.row.top + n.cellMatrix.ranges.stickyTopRange.height && s < t.row.top + n.cellMatrix.ranges.stickyTopRange.height + t.row.height / 2 ? (this.position = "on", l = "move", a = -1) : this.position = "after" : s > t.row.top + n.cellMatrix.ranges.stickyTopRange.height + t.row.height / 2 && s < t.row.top + n.cellMatrix.ranges.stickyTopRange.height + t.row.height ? (this.position = "on", l = "move", a = -1) : this.position = "before" : a = -1 : this.position = u ? "after" : "before";
    }

    return _C(_C({}, n), {
      shadowPosition: i,
      linePosition: a,
      shadowCursor: l
    });
  }, t.prototype.getShadowPosition = function (e, t) {
    var n = e.viewportY - this.pointerOffset,
        o = t.cellMatrix.height - t.shadowSize;
    return n < 0 ? 0 : n > o ? o : n;
  }, t.prototype.getLastPossibleDropLocation = function (e, t) {
    var n;
    return !(null === (n = e.props) || void 0 === n ? void 0 : n.canReorderRows) || e.props.canReorderRows(t.row.rowId, this.selectedIds, this.position) ? t : this.lastPossibleDropLocation;
  }, t.prototype.handlePointerUp = function (e, t, n) {
    var o, r;
    return t.row.idx !== this.initialRowIdx && this.lastPossibleDropLocation && (null === (o = n.props) || void 0 === o ? void 0 : o.onRowsReordered) && (null === (r = n.props) || void 0 === r || r.onRowsReordered(this.lastPossibleDropLocation.row.rowId, this.selectedIds, this.position)), _C(_C({}, n), {
      linePosition: -1,
      shadowPosition: -1,
      shadowCursor: "default"
    });
  }, t.prototype.handleContextMenu = function (e, t) {
    return ee(e, t);
  }, t;
}(L);

function $a() {
  return "undefined" != typeof window && -1 !== window.navigator.userAgent.indexOf("Safari") && -1 === navigator.userAgent.indexOf("Chrome");
}

function qa(e, t, n) {
  void 0 === n && (n = !1);
  var o = ta(t);
  return o ? (ec(e, t, oa(t, o, n).div), _C(_C({}, t), {
    copyRange: o
  })) : t;
}

function ec(e, t, n) {
  var o;
  $a() ? e.clipboardData.setData("text/html", n.innerHTML) : (document.body.appendChild(n), n.focus(), document.execCommand("selectAll", !1), document.execCommand("copy"), document.body.removeChild(n)), null === (o = t.hiddenFocusElement) || void 0 === o || o.focus({
    preventScroll: !0
  }), e.preventDefault();
}

function tc(e, t) {
  var n, o;
  if (!ta(t)) return t;
  var r = [],
      i = e.clipboardData.getData("text/html"),
      l = new DOMParser().parseFromString(i, "text/html");
  if ("reactgrid-content" === (null === (n = l.body.firstElementChild) || void 0 === n ? void 0 : n.getAttribute("data-reactgrid")) && (null === (o = l.body.firstElementChild) || void 0 === o ? void 0 : o.firstElementChild)) for (var a = l.body.firstElementChild.firstElementChild.children, c = 0; c < a.length; c++) {
    for (var s = [], u = 0; u < a[c].children.length; u++) {
      var d = a[c].children[u].getAttribute("data-reactgrid"),
          g = d && JSON.parse(d),
          p = a[c].children[u].innerHTML;
      s.push(g || {
        type: "text",
        text: p,
        value: it(p)
      });
    }

    r.push(s);
  } else r = e.clipboardData.getData("text/plain").replace(/(\r\n)$/, "").split("\n").map(function (e) {
    return e.split("\t").map(function (e) {
      return {
        type: "text",
        text: e,
        value: it(e)
      };
    });
  });
  return e.preventDefault(), _C({}, sa(t, r));
}

var nc = function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }

  return w(t, e), t.prototype.handlePointerDown = function (e, t, n) {
    return (n = _C(_C({}, n), {
      currentBehavior: this.getNewBehavior(e, t, n),
      contextMenuPosition: {
        top: -1,
        left: -1
      }
    })).currentBehavior.handlePointerDown(e, t, n);
  }, t.prototype.getNewBehavior = function (e, t, n) {
    var o,
        r,
        i = e.target;
    return ("mouse" === e.pointerType && "rg-resize-handle" === i.className || "touch" === e.pointerType && ("rg-touch-resize-handle" === i.className || "rg-resize-handle" === i.className)) && 0 === t.row.idx && t.column.resizable && t.cellX > t.column.width - ((null === (r = null === (o = n.reactGridElement) || void 0 === o ? void 0 : o.querySelector(".rg-resize-handle")) || void 0 === r ? void 0 : r.clientWidth) || 0) - V(n.scrollableElement).scrollLeft ? new oe() : n.enableColumnSelection && 0 === t.row.idx && n.selectedIds.includes(t.column.columnId) && !Hc(e) && "column" === n.selectionMode && t.column.reorderable ? new re() : n.enableColumnSelection && 0 === t.row.idx && "rg-fill-handle" !== i.className && "rg-touch-fill-handle" !== i.className ? new Ja() : n.enableRowSelection && 0 === t.column.idx && n.selectedIds.includes(t.row.rowId) && !Hc(e) && "row" === n.selectionMode && t.row.reorderable ? new Ka() : n.enableRowSelection && 0 === t.column.idx && "rg-fill-handle" !== i.className && "rg-touch-fill-handle" !== i.className ? new ja() : ("mouse" === e.pointerType && "rg-fill-handle" === i.className || "touch" === e.pointerType && ("rg-touch-fill-handle" === i.className || "rg-fill-handle" === i.className)) && n.enableFillHandle ? new Qa() : new te();
  }, t.prototype.handleContextMenu = function (e, t) {
    return ee(e, t);
  }, t.prototype.handleDoubleClick = function (e, t, n) {
    return Oc(e, t, n);
  }, t.prototype.handleKeyDown = function (e, t) {
    return Oa(t, e);
  }, t.prototype.handleKeyUp = function (e, t) {
    return Dc(e, t);
  }, t.prototype.handleCompositionEnd = function (e, t) {
    return Yc(e, t);
  }, t.prototype.handleCopy = function (e, t) {
    return qa(e, t);
  }, t.prototype.handlePaste = function (e, t) {
    return tc(e, t);
  }, t.prototype.handleCut = function (e, t) {
    return qa(e, t, !0);
  }, t;
}(L),
    oc = {
  legacyBrowserMode: "undefined" != typeof window && window.navigator.userAgent.indexOf("Trident") > 0 || "undefined" != typeof window && window.navigator.userAgent.indexOf("Edge/") > 0,
  focusedLocation: void 0,
  currentBehavior: new nc(),
  cellTemplates: wl,
  hiddenFocusElement: void 0,
  reactGridElement: void 0,
  scrollableElement: void 0,
  queuedCellChanges: [],
  currentlyEditedCell: void 0,
  highlightLocations: [],
  visibleRange: void 0,
  topScrollBoudary: -1,
  bottomScrollBoudary: -1,
  leftScrollBoudary: -1,
  rightScrollBoudary: -1,
  enableGroupIdRender: !1,
  leftStickyColumns: void 0,
  topStickyRows: void 0,
  enableFillHandle: !1,
  enableRangeSelection: !0,
  enableColumnSelection: !1,
  enableRowSelection: !1,
  contextMenuPosition: {
    top: -1,
    left: -1
  },
  lineOrientation: "horizontal",
  linePosition: -1,
  shadowSize: 0,
  shadowPosition: -1,
  shadowCursor: "default",
  selectionMode: "range",
  selectedRanges: [],
  selectedIndexes: [],
  selectedIds: [],
  activeSelectedRangeIdx: 0,
  copyRange: void 0,
  rightStickyColumns: void 0,
  bottomStickyRows: void 0,
  disableVirtualScrolling: !1
},
    rc = function rc(e, t) {
  var n = t.cellMatrix,
      o = function (e, t, n) {
    if (e.ranges.stickyRightRange.first.column && t.column.idx >= e.ranges.stickyRightRange.first.column.idx) {
      var o = V(n.scrollableElement).scrollLeft,
          r = z(n).left,
          i = j(o, r);
      return J(n).width + i - e.ranges.stickyRightRange.width;
    }
  }(n, e, t) || dc(n, e) || pc(n, e, t);

  return o || 0;
};

var ic = function ic(e, t) {
  var n = t.cellMatrix,
      o = function (e, t, n) {
    if (e.ranges.stickyBottomRange.first.row && t.row.idx >= e.ranges.stickyBottomRange.first.row.idx) {
      var o = V(n.scrollableElement).scrollTop,
          r = z(n).top,
          i = j(o, r);
      return J(n).height + i - e.ranges.stickyBottomRange.height;
    }
  }(n, e, t) || gc(n, e) || fc(n, e, t);

  return o || 0;
},
    lc = function lc(e) {
  var t = e.state,
      n = e.location,
      o = V(t.scrollableElement),
      r = o.scrollTop,
      i = o.scrollLeft,
      l = z(t),
      a = l.top,
      c = l.left,
      s = 0,
      u = 0;

  if (t.scrollableElement !== Z()) {
    var d = t.scrollableElement.getBoundingClientRect();
    s = d.left, u = d.top;
  }

  return {
    state: t,
    location: n,
    left: n.column.left + rc(n, t) + s + c - i,
    top: n.row.top + ic(n, t) + u + a - r
  };
},
    ac = function ac() {
  var t = Kl(),
      n = t.currentlyEditedCell,
      o = t.focusedLocation,
      r = e.useRef(0),
      i = e.useReducer(lc, {
    state: t,
    location: o
  }),
      l = i[0],
      a = i[1];
  if (e.useEffect(function () {
    r.current += 1, a();
  }, []), !n || !o || 0 === r.current) return null;
  var c = t.cellTemplates[n.type];
  return e.createElement(cc, {
    cellType: n.type,
    style: {
      top: l.top && l.top - 1,
      left: l.left && l.left - 1,
      height: o.row.height + 1,
      width: o.column.width + 1,
      position: "fixed"
    }
  }, c.render(n, !0, function (e, n) {
    t.currentlyEditedCell = n ? void 0 : e, n && t.update(function (t) {
      return W(t, o, e);
    });
  }));
},
    cc = function cc(t) {
  var n = t.style,
      o = t.cellType,
      r = t.children;
  return e.createElement("div", {
    className: "rg-celleditor rg-".concat(o, "-celleditor"),
    style: n
  }, r);
},
    sc = function sc(e, t) {
  var n = t.cellMatrix,
      o = dc(n, e) || pc(n, e, t);
  return o || 0;
},
    uc = function uc(e, t) {
  var n = t.cellMatrix,
      o = gc(n, e) || fc(n, e, t);
  return o || 0;
};

function dc(e, t) {
  var n;
  if (t.column.idx > (e.ranges.stickyLeftRange.last.column ? e.ranges.stickyLeftRange.last.column.idx : e.first.column.idx) || t.column.idx === e.last.column.idx && t.column.idx !== (null === (n = e.ranges.stickyLeftRange.last.column) || void 0 === n ? void 0 : n.idx)) return e.ranges.stickyLeftRange.width;
}

function gc(e, t) {
  var n;
  if (t.row.idx > (e.ranges.stickyTopRange.last.row ? e.ranges.stickyTopRange.last.row.idx : e.first.row.idx) || t.row.idx === e.last.row.idx && t.row.idx !== (null === (n = e.ranges.stickyTopRange.last.row) || void 0 === n ? void 0 : n.idx)) return e.ranges.stickyTopRange.height;
}

function pc(e, t, n) {
  if (e.ranges.stickyLeftRange.first.column && t.column.idx >= e.ranges.stickyLeftRange.first.column.idx && t.column.idx <= e.ranges.stickyLeftRange.last.column.idx) {
    var o = V(n.scrollableElement).scrollLeft,
        r = z(n).left;
    return j(o, r);
  }
}

function fc(e, t, n) {
  if (e.ranges.stickyTopRange.first.row && t.row.idx >= e.ranges.stickyTopRange.first.row.idx && t.row.idx <= e.ranges.stickyTopRange.last.row.idx) {
    var o = V(n.scrollableElement).scrollTop,
        r = z(n).top;
    return j(o, r);
  }
}

var hc = function hc(e) {
  var t = e.state,
      n = e.location,
      o = V(t.scrollableElement),
      r = o.scrollTop,
      i = o.scrollLeft,
      l = z(t),
      a = l.top,
      c = l.left,
      s = 0,
      u = 0;

  if (t.scrollableElement !== Z()) {
    var d = t.scrollableElement.getBoundingClientRect();
    s = d.left, u = d.top;
  }

  return {
    state: t,
    location: n,
    left: n.column.left + sc(n, t) + s + c - i,
    top: n.row.top + uc(n, t) + u + a - r
  };
},
    mc = function mc(t) {
  var n = t.hiddenElementRefHandler,
      o = Kl().hiddenFocusElement;
  return e.createElement("input", {
    className: "rg-hidden-element",
    ref: n,
    inputMode: "none",
    onBlur: function onBlur(e) {
      e.relatedTarget || null == o || o.focus({
        preventScroll: !0
      });
    }
  });
},
    bc = function (e) {
  function n() {
    var t = null !== e && e.apply(this, arguments) || this;
    return t.state = {
      hasError: !1
    }, t;
  }

  return w(n, e), n.getDerivedStateFromError = function (e) {
    return {
      hasError: !0,
      error: e
    };
  }, n.prototype.componentDidCatch = function (e, t) {
    this.setState({
      errorInfo: t
    });
  }, n.prototype.render = function () {
    var e = this.state,
        n = e.hasError,
        o = e.errorInfo,
        r = e.error;
    return n ? t.createElement(t.Fragment, null, t.createElement("h1", null, null == r ? void 0 : r.message), " ", t.createElement("br", null), t.createElement("br", null), t.createElement("details", null, null == r ? void 0 : r.stack, null == o ? void 0 : o.componentStack)) : this.props.children;
  }, n;
}(d);

function vc() {
  return "undefined" != typeof window && navigator.userAgent.includes("Firefox");
}

var yc = function yc(t) {
  var n = t.eventHandlers,
      o = t.children,
      r = Kl(),
      i = r.cellMatrix,
      l = r.props,
      a = {
    width: (null == l ? void 0 : l.enableFullWidthHeader) ? "100%" : i.width,
    height: i.height
  };
  return e.createElement(bc, null, e.createElement("div", {
    className: "reactgrid",
    style: _C({
      position: "relative",
      paddingRight: vc() ? "10px" : ""
    }, a),
    ref: n.reactgridRefHandler
  }, e.createElement("div", {
    className: "reactgrid-content",
    onKeyDown: n.keyDownHandler,
    onKeyUp: n.keyUpHandler,
    onCompositionEnd: n.compositionEndHandler,
    onPointerDown: n.pointerDownHandler,
    onPasteCapture: n.pasteCaptureHandler,
    onPaste: n.pasteHandler,
    onCopy: n.copyHandler,
    onCut: n.cutHandler,
    onBlur: n.blurHandler,
    style: a
  }, o, e.createElement(mc, {
    hiddenElementRefHandler: n.hiddenElementRefHandler
  }))));
},
    Ic = {
  legacyBrowserHeader: "Please update to a modern browser.",
  legacyBrowserText: "Your current browser cannot run our content, please make sure you browser is fully updated or try adifferent browser. We highly recommend using the most recent release of Google Chrome, Microsoft Edge, Firefox, Safari, and Opera browser",
  copyLabel: "Copy",
  cutLabel: "Cut",
  pasteLabel: "Paste",
  appleMobileDeviceContextMenuPasteAlert: "Use ⌘ + c for copy, ⌘ + x for cut and ⌘ + v for paste.",
  otherBrowsersContextMenuPasteAlert: " Use ctrl + c for copy, ctrl + x for cut and ctrl + v for paste.",
  actionNotSupported: "This action is not supported in this browser."
};

function xc(e) {
  var t;
  return _C(_C({}, Ic), null === (t = e.props) || void 0 === t ? void 0 : t.labels);
}

var wc = function wc() {
  var t = Kl();
  return e.createElement(e.Fragment, null, e.createElement("h3", null, xc(t).legacyBrowserHeader), e.createElement("p", null, xc(t).legacyBrowserText));
},
    Cc = function Cc(e) {
  e.border;

  var t = function (e, t) {
    var n = {};

    for (var o in e) {
      Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
    }

    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
      var r = 0;

      for (o = Object.getOwnPropertySymbols(e); r < o.length; r++) {
        t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
      }
    }

    return n;
  }(e, ["border"]);

  return t;
};

function Rc() {
  return "undefined" != typeof window && (void 0 !== window.orientation || -1 !== navigator.userAgent.indexOf("IEMobile"));
}

var Ac = function Ac() {
  return e.createElement("div", {
    className: "rg-touch-resize-handle",
    "data-cy": "rg-touch-resize-handle"
  }, e.createElement("div", {
    className: "rg-resize-handle",
    "data-cy": "rg-resize-handle"
  }));
};

function Ec(e) {
  return {
    left: e("left"),
    right: e("right"),
    top: e("top"),
    bottom: e("bottom")
  };
}

var Mc = function Mc(t) {
  var n,
      o,
      r,
      i = t.state,
      l = t.location,
      a = t.range,
      c = t.borders,
      s = t.update,
      u = t.currentlyEditedCell,
      d = P(i, l),
      g = d.cell,
      p = d.cellTemplate,
      f = void 0 !== i.focusedLocation && b(i.focusedLocation, l),
      h = null !== (n = p.getClassName && p.getClassName(g, !1)) && void 0 !== n ? n : "",
      m = e.useRef(u),
      v = function (e, t) {
    return function (n, o) {
      return function (r) {
        var i, l, a, c, s, u, d, g;
        return e[r] ? (null === (a = null === (l = null === (i = t.style) || void 0 === i ? void 0 : i.border) || void 0 === l ? void 0 : l[r]) || void 0 === a ? void 0 : a[n]) ? null === (c = t.style.border[r]) || void 0 === c ? void 0 : c[n] : o : (null === (d = null === (u = null === (s = t.style) || void 0 === s ? void 0 : s.border) || void 0 === u ? void 0 : u[r]) || void 0 === d ? void 0 : d[n]) ? null === (g = t.style.border[r]) || void 0 === g ? void 0 : g[n] : "unset";
      };
    };
  }(c, g),
      y = Ec(v("width", "1px")),
      I = Ec(v("style", "solid")),
      x = Ec(v("color", "#e8e8e8")),
      w = {
    borderLeftWidth: y.left,
    borderLeftStyle: I.left,
    borderLeftColor: x.left,
    borderRightWidth: y.right,
    borderRightStyle: I.right,
    borderRightColor: x.right,
    borderTopWidth: y.top,
    borderTopStyle: I.top,
    borderTopColor: x.top,
    borderBottomWidth: y.bottom,
    borderBottomStyle: I.bottom,
    borderBottomColor: x.bottom
  },
      R = Rc(),
      A = (null === (o = i.props) || void 0 === o ? void 0 : o.enableRowSelection) && 0 === l.row.idx || (null === (r = i.props) || void 0 === r ? void 0 : r.enableColumnSelection) && 0 === l.column.idx,
      E = _C(_C(_C(_C(_C({}, p.getStyle && (p.getStyle(g, !1) || {})), g.style && Cc(g.style)), {
    left: l.column.left,
    top: l.row.top,
    width: a.width,
    height: a.height
  }), !(f && m.current) && w), (f || "header" === g.type || A) && {
    touchAction: "none"
  }),
      M = f && !!m.current,
      G = g.groupId ? " rg-groupId-".concat(g.groupId) : "",
      N = g.nonEditable ? " rg-cell-nonEditable" : "",
      k = M && R ? " rg-celleditor rg-".concat(g.type, "-celleditor") : " rg-".concat(g.type, "-cell"),
      T = "rg-cell".concat(k).concat(G).concat(N, " ").concat(h),
      B = f && m.current && R ? m.current : g,
      S = e.useCallback(function (e, t) {
    if (M) m.current = t ? void 0 : e, t && s(function (t) {
      return W(t, l, e);
    });else {
      if (!t) throw new Error("commit should be set to true in this case.");
      s(function (t) {
        return W(t, l, e);
      });
    }
  }, [M, l, s, m]);

  return e.createElement("div", _C({
    className: T,
    style: E
  }, {
    "data-cell-colidx": l.column.idx,
    "data-cell-rowidx": l.row.idx
  }), p.render(B, !!R && M, S), 0 === l.row.idx && l.column.resizable && e.createElement(Ac, null), i.enableGroupIdRender && void 0 !== (null == g ? void 0 : g.groupId) && !(M && R) && e.createElement("span", {
    className: "rg-groupId"
  }, g.groupId));
},
    Gc = function Gc(t) {
  var n,
      o = t.borderColor,
      r = t.location,
      i = t.className,
      l = t.state,
      a = r.column.idx,
      c = r.row.idx,
      s = null === (n = null == l ? void 0 : l.cellMatrix.rangesToRender[m(a, c)]) || void 0 === n ? void 0 : n.range;
  return s ? e.createElement(kc, {
    location: r,
    className: "rg-cell-highlight ".concat(i || ""),
    borderColor: o,
    width: s.width,
    height: s.height
  }) : null;
},
    Nc = function Nc(t) {
  var n = t.borderColor,
      o = t.location,
      r = t.className;
  return e.createElement(kc, {
    location: o,
    className: "rg-cell-focus ".concat(r || ""),
    borderColor: n,
    width: o.column.width,
    height: o.row.height
  });
},
    kc = function kc(t) {
  var n = t.className,
      o = t.location,
      r = t.borderColor,
      i = t.height,
      l = t.width;
  return e.createElement("div", {
    className: n,
    style: {
      top: o.row.top - (0 === o.row.top ? 0 : 1),
      left: o.column.left - (0 === o.column.left ? 0 : 1),
      width: l + (0 === o.column.left ? 0 : 1),
      height: i + (0 === o.row.top ? 0 : 1),
      borderColor: "".concat(r)
    }
  });
};

var Tc = e.memo(function (t) {
  var n = t.columns,
      o = t.row,
      r = t.cellRenderer,
      i = t.borders,
      l = t.state,
      a = n[n.length - 1].idx,
      c = r;
  return e.createElement(e.Fragment, null, n.map(function (t) {
    var n,
        r = null === (n = l.cellMatrix.rangesToRender[m(t.idx, o.idx)]) || void 0 === n ? void 0 : n.range;
    if (!r) return null;
    var s = {
      row: o,
      column: t
    };
    return e.createElement(c, {
      key: o.idx + "-" + t.idx,
      borders: _C(_C({}, i), {
        left: i.left && 0 === t.left,
        right: i.right && t.idx === a || !(l.cellMatrix.scrollableRange.last.column.idx === s.column.idx)
      }),
      state: l,
      location: s,
      range: r,
      currentlyEditedCell: l.currentlyEditedCell,
      update: l.update
    });
  }));
}, function (e, t) {
  var n = e.columns,
      o = t.columns;
  return !(t.forceUpdate || o[0].idx !== n[0].idx || o.length !== n.length || o[o.length - 1].idx !== n[n.length - 1].idx);
});
Tc.displayName = "RowRenderer";

var Bc = function Bc(t) {
  var n = t.state,
      o = t.calculatedRange;
  return e.createElement(e.Fragment, null, n.currentBehavior.renderPanePart(n, o));
},
    Sc = function Sc(e) {
  var o = e.state,
      r = e.location,
      i = c(null),
      a = n({
    width: 0,
    height: 0
  }),
      s = a[0],
      u = a[1];
  return l(function () {
    i.current && u({
      width: i.current.offsetWidth,
      height: i.current.offsetHeight
    });
  }, []), t.createElement("div", {
    className: "rg-touch-fill-handle",
    ref: i,
    style: {
      top: r.row.bottom - s.width / 2,
      left: r.column.right - s.height / 2
    },
    onPointerDown: function onPointerDown(e) {
      "mouse" !== e.pointerType && o.update(function (e) {
        return _C(_C({}, e), {
          currentBehavior: new Qa()
        });
      });
    }
  }, t.createElement("div", {
    className: "rg-fill-handle"
  }));
},
    Lc = function Lc(t) {
  var n = t.state,
      o = t.calculatedRange;
  return e.createElement(e.Fragment, null, n.selectedRanges[n.activeSelectedRangeIdx] && o instanceof f && o.contains(n.selectedRanges[n.activeSelectedRangeIdx].last) && n.enableFillHandle && !n.currentlyEditedCell && !(n.currentBehavior instanceof te) && e.createElement(Sc, {
    state: n,
    location: n.selectedRanges[n.activeSelectedRangeIdx].last
  }));
},
    Pc = function Pc(t) {
  var n = t.state,
      o = t.calculatedRange;
  return e.createElement(e.Fragment, null, n.selectedRanges.map(function (t, r) {
    return !(n.focusedLocation && t.contains(n.focusedLocation) && 1 === t.columns.length && 1 === t.rows.length) && o && _a(o, t) && e.createElement(Ua, {
      key: r,
      pane: o,
      range: t,
      className: "rg-partial-area-selected-range",
      style: {}
    });
  }));
};

var Wc = e.memo(function (t) {
  var n = t.range,
      o = t.state,
      r = t.borders,
      i = t.cellRenderer;
  return e.createElement(e.Fragment, null, n.rows.map(function (t) {
    var l;
    return e.createElement(Tc, {
      key: t.rowId,
      state: o,
      row: t,
      columns: n.columns,
      forceUpdate: !0,
      cellRenderer: i,
      borders: _C(_C({}, r), {
        top: r.top && 0 === t.top,
        bottom: r.bottom && t.idx === n.last.row.idx || !((null === (l = o.cellMatrix.scrollableRange.last.row) || void 0 === l ? void 0 : l.idx) === t.idx)
      })
    });
  }));
}, function (e, t) {
  var n = e.state,
      o = t.state;
  return !(!n.focusedLocation || !o.focusedLocation || n.currentlyEditedCell !== o.currentlyEditedCell) && n.focusedLocation.column.columnId === o.focusedLocation.column.columnId && n.focusedLocation.row.rowId === o.focusedLocation.row.rowId && !(n.visibleRange !== o.visibleRange || n.cellMatrix.props !== o.cellMatrix.props);
});
Wc.displayName = "PaneGridContent";

var Xc = function Xc(t) {
  var n = t.className,
      o = t.style,
      r = t.renderChildren,
      i = t.children;
  return o.width && o.height ? e.createElement(Vc, {
    className: n,
    style: o
  }, " ", r && i, " ") : null;
},
    Fc = function Fc(t) {
  var n = t.state,
      o = t.range,
      r = t.borders,
      i = t.cellRenderer,
      l = o();
  return e.createElement(e.Fragment, null, e.createElement(Wc, {
    state: n,
    range: l,
    borders: r,
    cellRenderer: i
  }), function (t, n) {
    return t.highlightLocations.map(function (o, r) {
      try {
        var i = t.cellMatrix.getLocationById(o.rowId, o.columnId);
        return i && n.contains(i) && e.createElement(Gc, {
          key: r,
          location: i,
          state: t,
          borderColor: o.borderColor,
          className: o.className
        });
      } catch (e) {
        return console.error("Cell location fot found while rendering highlights at: ".concat(e.message)), null;
      }
    });
  }(n, l), n.focusedLocation && !(n.currentlyEditedCell && Rc()) && l.contains(n.focusedLocation) && e.createElement(Nc, {
    location: n.focusedLocation
  }), e.createElement(Pc, {
    state: n,
    calculatedRange: l
  }), e.createElement(Bc, {
    state: n,
    calculatedRange: l
  }), e.createElement(Lc, {
    state: n,
    calculatedRange: l
  }));
},
    Vc = function Vc(t) {
  return e.createElement("div", {
    className: "rg-pane ".concat(t.className),
    style: t.style
  }, " ", t.children, " ");
},
    Zc = function Zc(t) {
  var n = t.renderCondition,
      o = t.className,
      r = t.style,
      i = t.zIndex,
      l = t.children;
  return n ? e.createElement("div", {
    className: "rg-pane-shadow ".concat(o),
    style: _C(_C({}, r), vc() && {
      zIndex: i
    })
  }, l) : null;
};

function Hc(e) {
  return !H() && e.ctrlKey || e.metaKey;
}

function Oc(e, t, n) {
  if (b(t, n.focusedLocation)) {
    var o = P(n, t),
        r = o.cell,
        i = o.cellTemplate;

    if (i.handleKeyDown) {
      var l = i.handleKeyDown(r, 1, Hc(e), e.shiftKey, e.altKey, "DoubleClick"),
          a = l.cell;
      if (l.enableEditMode && !r.nonEditable) return _C(_C({}, n), {
        currentlyEditedCell: a
      });
    }
  }

  return n;
}

function Dc(e, t) {
  return e.keyCode !== S.TAB && e.keyCode !== S.ENTER || (e.preventDefault(), e.stopPropagation()), t;
}

function Yc(e, t) {
  var n = function (e, t) {
    var n = e.focusedLocation;
    if (!n) return e;
    var o = P(e, n),
        r = o.cell,
        i = o.cellTemplate;

    if (i.handleCompositionEnd && !e.currentlyEditedCell) {
      var l = i.handleCompositionEnd(r, t.data),
          a = l.cell,
          c = l.enableEditMode;
      if (JSON.stringify(a) !== JSON.stringify(r) || c) return c && !r.nonEditable ? _C(_C({}, e), {
        currentlyEditedCell: a
      }) : W(e, n, a);
    }

    return e;
  }(t, e);

  return n !== t && (e.stopPropagation(), e.preventDefault()), n;
}

function zc(e, t) {
  var n = e.focusedLocation;
  if (!n) return e;
  var o = P(e, n),
      r = o.cell,
      i = o.cellTemplate;

  if (i.handleKeyDown && !e.currentlyEditedCell) {
    var l = i.handleKeyDown(r, t.keyCode, Hc(t), t.shiftKey, t.altKey, t.key, t.getModifierState("CapsLock")),
        a = l.cell,
        c = l.enableEditMode;
    if (JSON.stringify(a) !== JSON.stringify(r) || c) return c && !r.nonEditable ? _C(_C({}, e), {
      currentlyEditedCell: a
    }) : W(e, n, a);
  }

  return e;
}

var Jc = function Jc(e) {
  return function (t) {
    return function (n) {
      return function () {
        return t.slice(n, e);
      };
    };
  };
},
    jc = Jc("columns"),
    Uc = Jc("rows");

function _c(e, t, n, o) {
  var r = E([], e.queuedCellChanges, !0);
  r.length > 0 && (n.onCellsChanged && n.onCellsChanged(E([], r, !0)), r.forEach(function () {
    return e.queuedCellChanges.pop();
  })), e !== t && o(e);
}

export { Oa as $, v as A, L as B, h as C, et as D, Pe as E, De as F, yc as G, ot as H, Ye as I, ze as J, Je as K, wc as L, $e as M, lt as N, qe as O, Wc as P, P as Q, f as R, Xe as S, at as T, W as U, U as V, _ as W, Q as X, K as Y, $ as Z, q as _, I as a, Ha as a$, ve as a0, ye as a1, Ie as a2, xe as a3, Al as a4, Gl as a5, Nl as a6, kl as a7, Tl as a8, Bl as a9, Hc as aA, Oc as aB, Dc as aC, Yc as aD, va as aE, ya as aF, Ia as aG, xa as aH, wa as aI, Ca as aJ, Ra as aK, Aa as aL, Ea as aM, Ma as aN, Ga as aO, Na as aP, ka as aQ, Ta as aR, Ba as aS, Sa as aT, La as aU, Pa as aV, Wa as aW, Xa as aX, Fa as aY, Va as aZ, Za as a_, Ll as aa, Wl as ab, Xl as ac, Vl as ad, Zl as ae, Hl as af, vc as ag, $a as ah, Dl as ai, Yl as aj, zl as ak, Jl as al, jl as am, Ul as an, H as ao, O as ap, D as aq, b as ar, F as as, V as at, Z as au, Y as av, z as aw, J as ax, j as ay, X as az, We as b, zc as b0, ie as b1, le as b2, ae as b3, ce as b4, se as b5, ue as b6, de as b7, ge as b8, pe as b9, Rc as bA, fe as ba, he as bb, me as bc, be as bd, Re as be, Ae as bf, Me as bg, Ge as bh, Ne as bi, ke as bj, na as bk, jc as bl, Uc as bm, _c as bn, ca as bo, qa as bp, ec as bq, tc as br, oa as bs, ra as bt, ia as bu, la as bv, aa as bw, sa as bx, xc as by, S as bz, ac as c, oc as d, gc as e, pc as f, dc as g, fc as h, y as i, hc as j, Mc as k, Xc as l, Fc as m, $l as n, Zc as o, ba as p, Fe as q, tt as r, nt as s, m as t, ct as u, vl as v, Ve as w, Ze as x, He as y, Oe as z };